export default {
  translation: {
    CHECK_EMAIL_TITLE: "Consulter Email",
    WELCOME_BACK: "Bienvenue à nouveau !",
    ENTER_YOUR_CREDENTIALS: "Entrez vos identifiants pour continuer",
    EMAIL_FIELD: "Email",
    CHECK_BUTTON: "Consulter",
    EMAIL_IS_REQUIRED: "Adresse Email requise",
    CREATE_PASSWORD_TITLE: "Créer mot de passe",
    SUBMIT_BUTTON: "Enregister",
    LOGIN_TITLE: "Se connecter",
    PASSWORD_FIELD: "Mot de passe",
    PLEASE_INPUT_YOUR_PASSWORD: "Veuillez indiquer votre mot de passe !",
    FORGOT_PASSWORD: "Mot de passe oublié ?",
    REMEMBER_ME: "Se rappeller de mes identifiants",
    LOGIN_TO_ACCOUNT_BUTTON: "Se connecter à mon compte",
    SIDEBAR_ORDER_HISTORY: "Historique des commandes",
    SIDEBAR_SIGNOUT: "Fermer la session",
    FOOTER_MENU_HOME: "Accueil",
    FOOTER_MENU_SHARE: "Partager",
    FOOTER_MENU_KWIKCASH: "KwikCash",
    FOOTER_MENU_HISTORY: "Historique",
    SHARE_THE_PRODUCTS_TITLE: "Partager les produits",
    PLEASE_SELECT_A_CAMPAIGN_TO_SHARE:
      "Sélectionnez les produits pour lesquels vous souhaitez créer un lien",
    CREATE_A_KWIKLINK_BUTTON: "Créer un KwikLink",
    MANAGE_MY_KWIKLINKS: "Gérer mes KwikLinks",
    KWIK_CASH_TITLE: "1Cash",
    KWIK_LINK_TITLE: "Partager les produits",
    FIELD_PRODUCT: "Produit",
    FIELD_QUANTITY: "Quantité",
    FIELD_PRICE: "Prix",
    FIELD_KWIKCASH: "KwikCash",
    SHARE_THIS_PRODUCT_TO: "Partager",
    COPY_LINK: "Copier le lien",
    RETURN_TO_HOME_BUTTON: "Retour sur la page d'accueil",
    COPY_SUCCESS: "Lien copié avec succès",
    TOTAL_KWIKCASH_EARNED: "Total KwikCash gagné",
    TOTAL_CASHED_OUT: "Total des gains",
    KWIKCASH_BALANCE: "Solde 1Cash",
    CASH_OUT_BUTTON: "Encaisser ",
    WEEK_COL_NAME: "Semaine",
    KWIK_CASH_COL_NAME: "KwikCash",
    PRODUCT_INFO_TITLE: "Informations produit",
    KWIKCASH_VALUE: "Valeur KwikCash",
    "'DESCRIPTION': 'Description',": "Description",
    IMPORTANT_INFORMATION: "Informations importantes",
    "'INGREDIENTS': 'Ingredients',": "Ingrédients",
    "'USAGE': 'Usage',": "Utilisation",
    HANDLING_INSTRUCTIONS: "Mode d'emploi",
    "'MANUFACTURER': 'Manufacturer',": "Fabricant",
    ADD_TO_CART_BUTTON: "Ajouter au panier",
    YOUR_CART_TITLE: "Votre panier",
    PRODUCTS: "produits",
    REMOVE_LINK: "Enlever",
    FIELD_TAX: "Taxe",
    FIELD_TOTAL: "Total",
    PROCEED_TO_CHECKOUT_BUTTON: "Passer à la caisse",
    CHECKOUT_TITLE: "Paiement",
    SHIPPING_ADDRESS: "Adresse de livraison",
    NEW_LINK: "Nouveau",
    PAYMENT_BREAKDOWN: "Détail du paiement",
    SHOW_SAVE_CARDS: "Afficher les cartes sauvegardées",
    FIELD_NAME_ON_CARD: "Nom sur la carte",
    FIELD_CARD_NUMBER: "Numéro de carte",
    FIELD_EXPIRY_YEAR: "Année d'expiration",
    FIELD_EXPIRY_MONTH: "Mois d'expiration",
    FIELD_CVV: "CVV",
    SAVE_THIS_CARD: "Enregistrer cette carte",
    BILLING_ADDRESS_IS_SAME_SHIPPING_ADDRESS:
      "L'adresse de facturation est la même que l'adresse de livraison",
    BILLING_ADDRESS: "Adresse de facturation",
    FIELD_FIRST_NAME: "Prénom",
    FIELD_LAST_NAME: "Nom de famille",
    FIELD_ADDRESS_LINE: "Adresse",
    FIELD_ZIP: "Code postal",
    FIELD_PHONE: "Numéro de téléphone",
    FIELD_CITY: "Ville",
    FIELD_STATE: "Région",
    FIELD_COUNTRY: "Pays",
    FIELD_NAME: "Nom",
    PLEASE_SELECT: "choisir",
    "'SHIPPING': 'Shipping',": "Livraison",
    CONTINUE_TO_PLACE_ORDER_BUTTON: "Continuer à passer la commande",
    SAVE_AND_USE_THIS_ADDRESS_BUTTON: "Suivant",
    "'CONGRATULATIONS': 'Order Complete!',": "Commande terminée !",
    PAYMENT_SUCCESSFUL: "Paiement réussi",
    "'STANDARD': 'Standard',": "Standard",
    ORDER_ACCEPTED: "Commande acceptée",
    CHECKOUT_MESSAGE1:
      "Votre commande n° #{{orderId}} a été passée et un e-mail de confirmation a été envoyé à",
    CHECKOUT_MESSAGE2:
      "Félicitations ! Gagnez 2,5 $ chaque fois que quelqu'un achète avec votre code promo ! Cliquez sur le bouton Partager ci-dessous.",
    SHARE_THE_PRODUCT_BUTTON: "Kwik and Earn",
    TRACK_ORDER: "Suivre la commande",
    WAVES_COL: "Vagues",
    NAME_COL: "Nom",
    ORDER_K_CASH_COL: "Total de la commande",
    K_CASH_RATE: "Taux K.Cash",
    CASH_HISTORY_TITLE: "Historique des liquidités",
    TRANSFER_TO_BANK_TITLE: "Transfert à la banque",
    SAVED_BANK_LINK: "Banque sauvegardée",
    ADD_BANK_LINK: "Ajouter une banque",
    SELECT_LINK: "Sélectionner",
    PROCEED_TO_NEXT_BUTTON: "Passer à la suite",
    FIELD_BANKS_COUNTRY: "Pays de la banque",
    FIELD_CURRENCY_CODE: "Code devise",
    FIELD_NAME_ON_ACCOUNT: "Nom sur le compte",
    FIELD_NAME_ON_ROUTING_NUMBER: "Numéro de routage",
    FIELD_ACCOUNT_NUMBER: "Numéro de compte",
    FIELD_ACCOUNT_TYPE: "Type de compte",
    FIELD_ACCOUNT_TYPE_OPTION_CHECKING: "Compte chèque",
    FIELD_ACCOUNT_TYPE_OPTION_SAVINGS: "Compte d'épargne",
    FIELD_SWIFT_CODE_BIC: "Code Swift/BIC",
    FIELD_BANK_NAME: "Numéro de banque",
    FIELD_BANK_NUMBER: "Numéro de banque",
    FIELD_BRANCH_NAME: "Nom de l'agence",
    FIELD_BRANCH_CODE: "Code de l'agence",
    SAFE_KEEP_MESSAGE:
      "Ces informations seront sauvegardées en toute sécurité conformément aux conditions de service et à la politique de confidentialité",
    SAVE_BANK_DETAILS_BUTTON: "Enregistrer les détails de la banque",
    AVAILABLE_BALANCE: "Solde disponible",
    TRANSFER_TO_INTRODUCE_MESSAGE:
      "Choisissez le montant que vous souhaitez transférer de votre compte KwikCash vers votre compte bancaire sélectionné",
    FIELD_AMOUNT: "Montant",
    SELECTED_BANK: "Banque sélectionnée",
    VERIFY_BANK_CARD_INFORMATION:
      "Veuillez vérifier que la banque et le montant KwikCash sont corrects. Vous NE POUVEZ PAS changer d'avis après avoir effectué cette opération.",
    TRANSACTION_COMPLETE: "Transaction terminée !",
    TRANSACTION_CONSEQUENCE_MESSAGE:
      "Le numéro de votre transaction est {{amount}} et elle a été effectuée. Un e-mail de confirmation a été envoyé à {{email}}",
    TRANSACTION_CONSEQUENCE_MESSAGE2:
      "Veuillez patienter jusqu'à 24 heures pour que le solde KwikCash soit mis à jour.",
    RETURN_BUTTON: "Retour sur la page d'accueil",
    VIEW_TRANSACTION_HISTORY: "Voir l'historique des transactions",
    ORDER_TEXT: "Commander",
    ITEM_LIST_IS_EMPTY: "Veuillez sélectionner le produit",
    CART_MUST_NOT_BE_EMPTY: "Le panier ne doit pas être vide",
    CLICK_SEND_EMAIL:
      "Veuillez cliquer sur le bouton pour envoyer un e-mail de confirmation du mot de passe initial",
    SELECTED_DATE_GREATER_CURRENT_DATE:
      "La date sélectionnée doit être supérieure à la date actuelle",
    CARD_NUMBER_FORMAT_IS_INCORRECT:
      "Le format du numéro de carte est incorrect",
    ITEM_ADDED_TO_CART:
      "Vous avez ajouté l'article dans votre panier avec succès !",
    ORDER_NUMBER: "Numéro de commande",
    CREATION_TIME: "Date de la commande",
    ORDER_STATUS: "Statut de la commande",
    ARE_YOU_SURE: "Vous êtes sûr(e) ?",
    "'CANCEL': 'Cancel',": "Annuler",
    "'OK': 'Ok',": "OK",
    EMAIL_IS_NOT_UNIQUE_SHARE_LINK:
      "Nos dossiers montrent que cette adresse électronique a déjà un compte avec Kwik. Veuillez utiliser un autre adresse email ou vous connecter pour compléter la commande.",
    EMAIL_IS_NOT_UNIQUE:
      "Cette adresse email est déjà utilisé dans kwik.com. Veuillez utiliser une autre adresse email, ou allez sur kwik.com pour vous connecter afin de passer votre commande.",
    EMAIL_IS_NOT_UNIQUE_ARIIX:
      "Nos dossiers montrent que cet email a déjà été enregistré en tant que client d'ARIIX. Veuillez utiliser une autre adresse e-mail, ou vous rendre sur kwik.com pour vous connecter avec cette adresse e-mail afin d'explorer d'autres campagnes.",
    REQUIRED_FIELD: "Champ obligatoire",
    INCORRECT_EMAIL_FORMAT: "Format d'email incorrect",
    "'REFUND': 'Refund',": "Remboursement",
    "'DELETE': 'Delete',": "Supprimer",
    PLEASE_INPUT_TAGLINK: "Veuillez saisir le lien de l'étiquette",
    PLEASE_INPUT_CITY: "Veuillez saisir ville",
    UPDATE_SUCCESSFULLY: "Mise à jour réussie",
    TAGLINK_TEXT: "Tag Link",
    EXPLORATION_TITLE: "Explorer",
    SEE_ALL_NUM_PRODUCTS: "Voir tous les {{prodNumber}} produits",
    LEARN_MORE_LINK: "En savoir plus",
    KWIKCASH_VALUE_MESS: "Valeur KwikCash",
    SHARE_YOUR_LINK: "PARTAGEZ VOTRE LIEN",
    SEND_LINK_AND_EARN_KWIKCASH_MESS: "Envoyez le lien et gagnez du KwikCash",
    PRICE_TEXT: "PRIX",
    OUT_OF_STOCK_TEXT: "Rupture de stock",
    ORDER_HISTORY_TEXT: "Historique des commandes",
    ORDER_HISTORY_TIPS_NEED_PURCHASE: "Vous devez d'abord faire un achat !",
    ORDER_HISTORY_EXPLORE_PRODUCTS: "Explorer les produits",
    ORDER_HISTORY_ORDER_ON: "Commander le",
    ORDER_DETAIL_EXPECTED_DATE: "Date prévue",
    ORDER_DETAIL_TRACKING_ID: "Numéro de suivi",
    ORDER_DETAIL_BILLING_INFO_SAME_AS_SHIPPING:
      "Informations de facturation identiques à celles de l'expédition",
    ORDER_DETAIL_ORIGINAL_PRICE: "Prix d'origine",
    ORDER_DETAIL_SHIPPINGN_HANDING: "Frais d'expédition et de manutention",
    KWIK_CASH_AVAILABLE_BALANCE: "Solde disponible",
    KWIK_CASH_PENDING_BALANCE: "Solde en attente",
    KWIK_CASH_VIEW_HISTORY: "Afficher l'historique",
    KWIK_CASH_TRANSFER_BANK: "Transfert à la banque",
    ACCOUNT_NUMBER_4:
      "Le numéro de compte ne doit pas comporter moins de 4 caractères",
    KWIK_CASH_PENDING: "en attente",
    KWIK_CASH_PAID: "payé",
    KWIK_CASH_FULFILLED: "rempli",
    CAMPAIGNS_SHARE_A_CAMPAIGN: "Partager une campagne",
    CAMPAIGNS_ACTIVE_CAMPAIGN: "Campagne active",
    CAMPAIGNS_NODATA_TEXT: "Pour commencer, trouvez un produit à soutenir",
    CAMPAIGNS_EXPLORE_PRODUCTS: "Explorer les produits",
    PROGRESS_LOADING: "Chargement...",
    LOGIN_WELCOME_BACK: "Bienvenue !",
    LOGIN_CREDENTIALS:
      "Entrez vos informations d'identification pour continuer",
    LOGIN_LABEL_USERNAME: "Nom d'utilisateur",
    LOGIN_PLACEHOLDER_USERNAME: "Nom d'utilisateur ou adresse e-mail",
    LOGIN_REQUIRED_USERNAME: "Le nom d'utilisateur est obligatoire",
    LOGIN__LABEL_PASSWORD: "Mot de passe",
    LOGIN_PLACEHOLDER_PASSWORD: "Mot de passe",
    LOGIN_REQUIRED_PASSWORD: "Veuillez saisir votre mot de passe !",
    LOGIN_REMEMBER_ME: "Se souvenir de moi",
    LOGIN_FORGOT_PASSWORD: "Mot de passe oublié ?",
    LOGIN_BUTTON_LOGIN: "Connexion",
    LOGIN_NEED_ACCOUNT: "Vous avez besoin d'un compte ?",
    LOGIN_CREATE_ACCOUNT: "Créer un nouveau compte",
    VIEWS_REGISTER_1_CREATE_ACCOUNT: "Créer votre compte ",
    VIEWS_REGISTER_1_FIELDS_REQUIRED:
      "Veuillez remplir le formulaire ci-dessous. Tous les champs sont obligatoires.",
    VIEWS_REGISTER_1_LABEL_EMAIL_ADDRESS: "Adresse e-mail (unique)",
    VIEWS_REGISTER_1_PLACEHOLDER_EMAIL_ADDRESS: "Adresse e-mail (unique)",
    VIEWS_REGISTER_1_REQUIRED_EMAIL: "L'adresse e-mail ne doit pas être vide",
    VIEWS_REGISTER_1_LABEL_FIRST_NAME: "Prénom",
    VIEWS_REGISTER_1_PLACEHOLDER_FIRST_NAME: "Prénom",
    VIEWS_REGISTER_1_REQUIRED_FIRST_NAME: "Le prénom ne doit pas être vide",
    VIEWS_REGISTER_1_LABEL_LAST_NAME: "Nom de famille",
    VIEWS_REGISTER_1_PLACEHOLDER_LAST_NAME: "Nom de famille",
    VIEWS_REGISTER_1_REQUIRED_LAST_NAME:
      "Le nom de famille ne doit pas être vide",
    VIEWS_REGISTER_1_LABEL_USER_NAME: "Nom d'utilisateur (unique)",
    VIEWS_REGISTER_1_PLACEHOLDER_USER_NAME: "Nom d'utilisateur (unique)",
    VIEWS_REGISTER_1_REQUIRED_USER_NAME:
      "Le nom d'utilisateur ne doit pas être vide",
    VIEWS_REGISTER_1_LABEL_PHONE: "Numéro de téléphone",
    VIEWS_REGISTER_1_PLACEHOLDER_PHONE: "Numéro de téléphone (unique)",
    VIEWS_REGISTER_1_REQUIRED_PHONE:
      "Le numéro de téléphone ne doit pas être vide",
    VIEWS_REGISTER_1_BUTTON_NEXT: "Suivant",
    VIEWS_REGISTER_1_TIPS_DIGIT_SENT:
      "Un code à 4 chiffres a été envoyé à votre boite de réception électronique",
    VIEWS_REGISTER_1_TIPS_EMAIL_REGISTERED:
      "Nos dossiers montrent que cet email a déjà été enregistré chez Kwik.",
    VIEWS_REGISTER_1_BUTTON_EMAIL_REGISTERED_FORGOT_PASSWORD:
      "Mot de passe oublié",
    VIEWS_REGISTER_1_BUTTON_EMAIL_REGISTERED_CANCEL: "Annuler",
    VIEWS_REGISTER_1_TIPS_USERNAME_REGISTERED:
      "Nos dossiers montrent que ce nom d'utilisateur a déjà été enregistré auprès de WeR1. ",
    VIEWS_REGISTER_1_BUTTON_OK: "Ok",
    VIEWS_REGISTER_2_VERIFICATION: "Vérification",
    VIEWS_REGISTER_2_TO_VERIFY: "Pour vérifier que c'est bien vous",
    VIEWS_REGISTER_2_TIPS_ENTER:
      "Entrez le code à 4 chiffres qui vous a été envoyé à",
    VIEWS_REGISTER_2_BUTTON_NEXT: "Suivant",
    VIEWS_REGISTER_2_NEED_CODE: "Vous n'avez pas encore de code ?",
    VIEWS_REGISTER_2_LINK_RESEND: "Renvoyer",
    VIEWS_REGISTER_2_LOADING: "Chargement...",
    VIEWS_REGISTER_3_TITLE_PASSWORD_CREATE: "Créer un nouveau mot de passe",
    VIEWS_REGISTER_3_TITLE_ENTER_NEW_PASSWORD:
      "Entrez un nouveau mot de passe sécurisé",
    VIEWS_REGISTER_3_CREATE_LABEL: "Créer mot de passe",
    VIEWS_REGISTER_3_CREATE_PLACEHOLDER: "Créer mot de passe",
    VIEWS_REGISTER_3_CREATE_REQUIRED: "Veuillez indiquer votre mot de passe !",
    VIEWS_REGISTER_3_CONFIRM_LABEL: "Créer mot de passe",
    VIEWS_REGISTER_3_CONFIRM_PLACEHOLDER: "Créer mot de passe",
    VIEWS_REGISTER_3_CONFIRM_REQUIRED: "Veuillez indiquer votre mot de passe !",
    VIEWS_REGISTER_3_TOAST_PATTERN:
      "Le mot de passe nécessite huit caractères minimum avec au moins une majuscule, une minuscule et un chiffre.",
    VIEWS_REGISTER_3_TIPS_MATCH: "Les deux mots de passe ne correspondent pas",
    VIEWS_REGISTER_3_BUTTON_NEXT: "Suivant",
    VIEWS_REGISTER_3_BUTTON_BACK: "Retour",
    VIEWS_REGISTER_3_LOADING: "Chargement...",
    VIEWS_REGISTER_4_TITLE: "Télécharger une photo de profil",
    VIEWS_REGISTER_4_MESSAGE:
      "Cela vous rendra célèbre et ajoutera de la confiance à votre compte.",
    VIEWS_REGISTER_4_BUTTON_NEXT: "Passer à la suite",
    VIEWS_REGISTER_4_TIPS_NOT_NOW: "Pas maintenant ?",
    VIEWS_REGISTER_4_LINK_DO_LATER: "Vous préférez le faire plus tard",
    VIEWS_REGISTER_5_TITLE: "Créer votre compte",
    VIEWS_REGISTER_5_MESSAGE: "Veuillez fournir les informations suivantes",
    VIEWS_REGISTER_5_TIPS_YOUR_BIO: "Votre bio",
    VIEWS_REGISTER_5_PLACEHOLDER_TYPING: "Commencez à taper ici...",
    VIEWS_REGISTER_5_BUTTON_NEXT: "Soumettre et passer à la suite",
    VIEWS_REGISTER_5_TIPS_NOT_NOW: "Pas maintenant ?",
    VIEWS_REGISTER_5_LINK_DO_LATER: "Vous préférez le faire plus tard",
    VIEWS_REGISTER_6_BUTTON_BACK: "Retour",
    VIEWS_REGISTER_6_TITLE: "Fournissez vos informations personnelles",
    VIEWS_REGISTER_6_MESSAGE: "Veuillez fournir certaines de vos informations.",
    VIEWS_REGISTER_6_ADDRESS_LINE_1: "Ligne d'adresse 1",
    VIEWS_REGISTER_6_ADDRESS_LINE_2: "Ligne d'adresse 2",
    VIEWS_REGISTER_6_POSTAL_CODE: "Code postal",
    VIEWS_REGISTER_6_BUTTON_NEXT: "Suivant",
    VIEWS_REGISTER_6_COUNTRY_USA: "Etats-Unis",
    VIEWS_REGISTER_6_COUNTRY_CHA: "Chine",
    VIEWS_REGISTER_SSO_1_TIPS_EMAIL_REGISTERED:
      "Nos dossiers montrent que ce nom d'utilisateur a déjà été enregistré auprès de Kwikclick.",
    VIEWS_REGISTER_SSO_1_BUTTON_OK: "Ok",
    VIEWS_REGISTER_SSO_1_TIPS_SIGNUP: "S'inscrire",
    VIEWS_REGISTER_SSO_1_TITLE: "Créer votre compte",
    VIEWS_REGISTER_SSO_1_MESSAGE:
      "Félicitations ! Votre identifiant et votre mot de passe NewAge ont été vérifiés. Veuillez fournir les informations suivantes",
    VIEWS_REGISTER_SSO_1_TIPS_EMAIL:
      "Adresse e-mail (Nous vérifierons l'unicité de votre email)",
    VIEWS_REGISTER_SSO_1_TIPS_FIRST: "Prénom",
    VIEWS_REGISTER_SSO_1_REQUIRED_FIRST: "Le prénom ne doit pas être vide",
    VIEWS_REGISTER_SSO_1_TIPS_LAST: "Nom de famille",
    VIEWS_REGISTER_SSO_1_REQUIRED_LAST:
      "Le nom de famille ne doit pas être vide",
    VIEWS_REGISTER_SSO_1_TIPS_USERNAME:
      "Nom d'utilisateur (Nous vérifierons l'unicité de votre nom d'utilisateur)",
    VIEWS_REGISTER_SSO_1_REQUIRED_USERNAME:
      "Le nom d'utilisateur ne doit pas être vide",
    VIEWS_REGISTER_SSO_1_TIPS_PHONE: "Numéro de téléphone",
    VIEWS_REGISTER_SSO_1_REQUIRED_PHONE:
      "Le numéro de téléphone ne doit pas être vide",
    VIEWS_REGISTER_SSO_1_BUTTON_NEXT: "Suivant",
    CAMPAIGNS_BUTTON_OK: "Ok",
    CAMPAIGNS_LOADING: "Chargement...",
    CAMPAIGNS_CANNOT_SHARE_MESSAGE_1:
      "Désolé, vous ne pouvez pas partager ce produit ",
    CAMPAIGNS_CANNOT_SHARE_MESSAGE_2:
      "Veuillez acheter ce produit maintenant, ou demander l'éligibilité.",
    CAMPAIGNS_TITLE_STATS: "Statistiques",
    CAMPAIGNS_TIPS_CASH_EARNED: "Total des KwikCash gagnés cette semaine",
    CAMPAIGNS_TIPS_TOTAL_KWIKCASH_EARNED: "Total des KwikCash gagnés",
    CAMPAIGNS_TIPS_GENERATE_SALES: "Ventes generés",
    CAMPAIGNS_TITLE_CAMPAIGNS: "Campagnes",
    CAMPAIGNS_TIPS_VIEW_DETAIL: " (Cliquez pour voir les détails)",
    CAMPAIGNS_TITLE_ALL_STATS: "Statistiques de toutes les campagnes",
    CAMPAIGNS_TIPS_KWIK_INFO: "Informations Kwik",
    CAMPAIGNS_TITLE_TOTAL_BUYERS: "Total des acheteurs",
    CAMPAIGNS_BUTTON_QR_CODE: "Code QR",
    CAMPAIGNS_BUTTON_COPY_LINK: "Copier le lien",
    CAMPAIGNS_HEADER_TITLE_CAMPAIGNS_STATS: "Statistiques des campagnes",
    CAMPAIGNS_TITLE_TOTAL_CUSTOMERS: "Total des acheteurs",
    CAMPAIGNS_BUTTON_VIEW_DATA: "Voir les données",
    CAMPAIGNS_TITLE_ACTIVE_CAMPAIGN: "Campagne active",
    CAMPAIGNS_TITLE_SHARE_CAMPAIGN: "Partager une campagne",
    CAMPAIGNS_TITLE_CAMPAIGN_DETAILS: "Détails de la campagne",
    CAMPAIGNS_TITLE_WAVES: "Vagues",
    CAMPAIGNS_TIPS_KWIKCASH_EARNED: "1Cash gagnés",
    CAMPAIGNS_TITLE_BUYER: "Acheteur",
    CAMPAIGNS_COLOR_MEANS_GREEN: "Vert signifie que le KwikCash est disponible",
    CAMPAIGNS_COLOR_MEANS_YELLOW:
      "Jaune signifie que le KwikCash est en attente",
    CAMPAIGNS_COLOR_MEANS_RED:
      "Rouge signifie que le KwikCash n'est pas livrable",
    CAMPAIGNS_TITLE_KWIK_INFO: "Informations Kwik",
    SHARE_LINK_IMAGE_5M: "Les images ne doivent pas dépasser 5 mégaoctets",
    SHARE_LINK_REFERRED_BY: "Référencé par",
    SHARE_LINK_DESCRIPTION: "Description",
    SHARE_LINK_ADD_TO_CART: "Ajouter au panier",
    SHARE_LINK_PRODUCTS_DESC: "Description du produit",
    SHARE_LINK_LEAVE_MESSAGE: "Laissez un commentaire",
    SHARE_LINK_LEARN_MORE: "En savoir plus",
    SHARE_LINK_REVIEWS: "Avis",
    SHARE_LINK_RATE_THE_PRODUCT: "Évaluer le produit",
    SHARE_LINK_SHARE_YOUR_THOUGHTS_ON_THE_PRODUCT:
      "Partagez votre avis sur le produit",
    SHARE_LINK_ADD_AN_IMAGE_TO_YOUR_REVIEW:
      "Ajouter une image à votre commentaire",
    SHARE_LINK_DRAG_AND_DROP: "GLISSER-DÉPOSER",
    SHARE_LINK_YOUR_FILES_TO_ASSETS_OR_BROWSE:
      "vos fichiers aux actifs, ou <span>browse</span>",
    SHARE_LINK_LEAVE_REVIEW: "Laisser un avis",
    SHARE_LINK_MY_CART: "Mon panier",
    SHARE_LINK_CHECKOUT: "Passer à la caisse",
    SHARE_LINK_CHECKOUT2: "Passer à la caisse",
    SHARE_LINK_DISCOUNT: "Remise",
    SHARE_LINK_WILL_BE_CALCULATED_AT_CHECKOUT: "Sera calculé à la caisse",
    SHARE_LINK_RETURNING_CUSTOMER: "Retour client",
    SHARE_LINK_SIGN_IN_FOR_FASTER_CHECKOUT:
      "Se connecter pour un paiement plus rapide",
    SHARE_LINK_USERNAME_OR_EMAIL: "Nom d'utilisateur ou adresse e-mail",
    SHARE_LINK_USERNAME_IS_REQUIRED: "Le nom d'utilisateur est requis",
    SHARE_LINK_PASSWORD: "Mot de passe",
    SHARE_LINK_OR: "OU",
    SHARE_LINK_NEW_CUSTOMER: "Nouveau client",
    SHARE_LINK_DONT_HAVE_A_MESSAGE:
      "Vous n'avez pas encore de compte Kwik ? C'est la première étape ! Complétez la transaction pour commencer à configurer votre compte !",
    SHARE_LINK_ADD_NEW_ADDRESS: "Ajouter une nouvelle adresse",
    SHARE_LINK_TO_MAKE_SURE_MESSAGE:
      "Pour s'assurer que la connexion fonctionne bien, veuillez vous assurer qu'il s'agit de l'email que vous avez utilisé ou que vous utiliserez sur votre compte Kwik.",
    SHARE_LINK_ADDRESS: "Adresse",
    SHARE_LINK_APARTMENT_SUITE_ETC: "Appartement, suite, etc. (facultatif)",
    SHARE_LINK_APT_SUITE_ETC: "Apt, suite, etc. (facultatif)",
    SHARE_LINK_CITY: "Ville",
    SHARE_LINK_COUNTRY: "Pays",
    SHARE_LINK_STATE: "Région",
    SHARE_LINK_ZIP_CODE: "Code postal",
    SHARE_LINK_PHONE: "Téléphone",
    SHARE_LINK_CANCEL: "Annuler",
    SHARE_LINK_PRODUCTS: "Produits",
    SHARE_LINK_SHIPPING: "Livraison",
    SHARE_LINK_TOTAL: "Total",
    SHARE_LINK_ENTER_YOUR_CARD_DETAILS: "Entrez les détails de votre carte",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_NAME:
      "Veuillez saisir le nom de votre carte !",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_NUMBER:
      "Veuillez saisir le numéro de votre carte !",
    SHARE_LINK_EXPIRATION_DATE: "Date d'expiration",
    SHARE_LINK_EXPIRATION_YEAR: "Année d'expiration",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_CVV:
      "Veuillez saisir le CVV de votre carte !",
    SHARE_LINK_BILLING_ADDRESS_IS_THE_SAME_MESSAGE:
      "L'adresse de facturation est la même que l'adresse de livraison",
    SHARE_LINK_ENTER_YOUR_BILLING_ADDRESS:
      "Entrez votre adresse de facturation",
    SHARE_LINK_SAVE_THIS_CARD: "Sauvegarder cette carte",
    SHARE_LINK_COUNTINUE: "Continuer",
    SHARE_LINK_SHIPPING_ADDRESS: "Adresse de livraison",
    SHARE_LINK_EDIT: "Modifier",
    SHARE_LINK_SHIPPING_AND_HANDLING: "Expédition et manutention",
    SHARE_LINK_CHANGE: "Modifier",
    SHARE_LINK_PRICE_COUNT_ITEM: "Prix (article {{count}})",
    SHARE_LINK_PRICE_TAX: "Taxe",
    SHARE_LINK_PRICE: "PRIX",
    SHARE_LINK_PLACE_YOUR_ORDER: "Passez votre commande",
    SHARE_LINK_PAYMENT_SUCCESSFUL: "Paiement réussi !",
    SHARE_LINK_CONGRATS_MESSAGE:
      "Félicitations ! Gagnez du KwikCash chaque fois que quelqu'un achète avec votre code promo ! Cliquez sur le bouton Partager ci-dessous.",
    SHARE_LINK_SHARE_YOUR_LINK: "PARTAGEZ VOTRE LIEN",
    SHARE_LINK_CREATE_MY_ACCOUNT: "Créer mon compte",
    SHARE_LINK_DOWNLOAD_IMAGE: "Télécharger l'image",
    SHARE_LINK_COPY_LINK: "Copier le lien",
    SHARE_LINK_ORDER_ACCEPTED: "Commande acceptée",
    SHARE_LINK_SELECT_THE_PRODUCTS_YOU_WOULD_LIKE:
      "Sélectionnez les produits que vous souhaitez",
    SHARE_LINK_PRODUCT_NOT_AVAILABLE:
      "    Le produit que vous avez choisi n'est pas disponible dans le pays sélectionné",
    SHARE_LINK_OUT_OF_STOCK: "Rupture de stock",
    SHARE_LINK_PRICE2: "Prix",
    SHARE_LINK_ADD: "Ajouter",
    SHARE_LINK_CONTINUE_TO_CHECKOUT: "Continuer à la caisse",
    SHARE_LINK_SO_YOURE_ALREADY_MESSAGE:
      "Vous êtes donc déjà dans {{totalAlreadyJoin}} des campagnes {{totalCpgn}} que vous avez sélectionnées. Lorsque vous effectuerez l'achat des produits, vous rejoindrez {{referName}} dans les campagnes {{totalCanJoin}} sélectionnées",
    SHARE_LINK_SINCE_YOU_ALREADY_MESSAGE:
      "Puisque vous avez déjà rejoint cette campagne avec {{originalName}}, ils obtiendront le crédit.",
    SHARE_LINK_SINCE_YOU_HAVE_ALREADY_MESSAGE:
      "Puisque vous avez déjà participé à toutes les campagnes {{totalAlreadyJoin}}, lorsque vous compléterez l'achat des produits, ils obtiendront le crédit.",
    SHARE_LINK_CLICK_TO_SEE_DETAILS: "Cliquez pour voir les détails",
    SHARE_LINK_REFERRER: "Référent",
    SHARE_LINK_CAMPAIGN: "Campagne",
    SHARE_LINK_CAMPAIGNS_TYPE: "Type de campagne",
    SHARE_LINK_DATE_JOINED: "Date d'adhésion",
    SHARE_LINK_SINGLE_CAMPAIGN: "Campagne unique",
    SHARE_LINK_ULTI_PRODUCT: "ulti - Produit",
    SHARE_LINK_KWIKCASH: "1Cash",
    SHARE_LINK_QUANTITY: "Quantité",
    SHARE_LINK_SUBTOTAL: "Sous-total",
    SHARE_LINK_PLEASE_INPUT_YOUR_FIRSTNAME: "Veuillez saisir votre prénom !",
    SHARE_LINK_PLEASE_INPUT_YOUR_LASTNAME:
      "Veuillez saisir votre nom de famille !",
    SHARE_LINK_PLEASE_INPUT_YOUR_ZIP: "Veuillez saisir votre code postal !",
    SHARE_LINK_PLEASE_INPUT_YOUR_STATE: "Veuillez saisir votre région !",
    SHARE_LINK_PLEASE_INPUT_YOUR_CITY: "Veuillez saisir votre ville !",
    SHARE_LINK_PLEASE_INPUT_YOUR_ADDRESS_LINE1:
      "Veuillez saisir votre adresse ligne 1 !",
    SHARE_LINK_PLEASE_SELECT_YOUR_STATE: "Veuillez sélectionner votre région !",
    SHARE_LINK_PLEASE_INPUT_YOUR_ADDRESS_PHONE:
      "Veuillez saisir votre adresse téléphonique !",
    SHARE_LINK_EXISTING_KWIK_USER_LOGIN_HERE:
      "Vous êtes déjà un utilisateur Kwik ? Connectez-vous ici",
    SHARE_LINK_STEP_ADDRESS: "Adresse",
    SHARE_LINK_STEP_PAYMENTS: "Paiements",
    SHARE_LINK_STEP_SUMMARY: "Résumé",
    SHARE_LINK_BUTTON_LOGIN: "Connexion",
    SHARE_LINK_BUTTON_CONTINUE: "Continuer",
    SHOPPING_NEW_AGE_PV: "NewAge PV",
    SHOPPING_PRODUCT_DESCRIPTION: "Description du produit",
    SHOPPING_REVIEWS: "Avis",
    SHOPPING_LEAVE_REVIEW: "Laissez un commentaire",
    SHOPPING_RATE_PRODUCT: "Évaluer le produit",
    SHOPPING_SHARE_THOUGHTS_PRODUCT: "Partagez votre avis sur le produit",
    SHOPPING_PLACEHOLDER_TYPING: "Commencer à taper",
    SHOPPING_PLEASE_TYPING: "Veuillez saisir Commencer à taper",
    SHOPPING_TIPS_ADD_IMAGE: "Ajouter une image à votre commentaire",
    SHOPPING_BUTTON_REMOVE: "Enlever",
    SHOPPING_TIPS_IMAGE_UPLOAD_1: "vos fichiers aux actifs, ou ",
    SHOPPING_TIPS_IMAGE_UPLOAD_2: "parcourir",
    SHOPPING_BUTTON_LEAVE_REVIEW: "Laissez un commentaire",
    SHOPPING_BUTTON_DRAG_DROP: "GLISSER-DÉPOSER",
    SHOPPING_BUTTON_CHECKOUT: "Passer à la caisse",
    SHOPPING_SHARE_LINK_TEXT_PRICE: "PRIX",
    SHOPPING_SHARE_LINK_TEXT_NEW_AGE_PV: "NewAge PV",
    SHOPPING_BUTTON_QR_CODE: "code QR",
    SHOPPING_BUTTON_COPY_LINK: "Copier le lien",
    SHOPPING_BUTTON_QUICK_SHARE: "Partage rapide",
    SHOPPING_BUTTON_DOWNLOAD_IMAGE: "télécharger l'image",
    SHOPPING_BUTTON_X: "X",
    SHOPPING_BUTTON_CANCEL: "Annuler",
    SHOPPING_CART_TEXT_PRICE: "Prix",
    SHOPPING_CART_TEXT_KWIKASH: "KwikCash",
    SHOPPING_CART_TEXT_SHIP_FROM: "Expédier de",
    SHOPPING_CART_TEXT_SUBTOTAL: "Sous-total",
    SHOPPING_BUTTON_CHANGE: "Modifier",
    SHOPPING_TITLE_COUPON: "Coupon",
    SHOPPING_OPTION_SELECT_COUPON:
      "Sélectionnez un coupon disponible pour vous",
    SHOPPING_REQUIRED_INPUT_CARD_NAME:
      "Veuillez saisir le nom de votre carte !",
    SHOPPING_REQUIRED_INPUT_CARD_NUMBER:
      "Veuillez saisir le numéro de votre carte !",
    SHOPPING_TEXT_EXPIRATION_DATE: "Date d'expiration",
    SHOPPING_TEXT_EXPIRATION_YEAR: "Année d'expiration",
    SHOPPING_REQUIRED_INPUT_CARD_CVV: "Veuillez saisir le CVV de votre carte !",
    SHOPPING_REQUIRED_INPUT_FIRST_NAME: "Veuillez saisir votre prénom !",
    SHOPPING_REQUIRED_INPUT_LAST_NAME: "Veuillez saisir votre nom de famille !",
    SHOPPING_REQUIRED_INPUT_ADDRESS_1:
      "Veuillez saisir votre adresse ligne 1 !",
    SHOPPING_REQUIRED_INPUT_STATE: "Veuillez sélectionner votre région !",
    SHOPPING_REQUIRED_INPUT_CITY: "Veuillez saisir votre ville !",
    SHOPPING_REQUIRED_INPUT_ZIP: "Veuillez saisir votre code postal !",
    SHOPPING_REQUIRED_INPUT_PHONE:
      "Veuillez saisir votre adresse téléphonique !",
    SHOPPING_TEXT_SHIPPING_HANDING: "Expédition et manutention",
    SHOPPING_TEXT_SHOW_SAVED_CARD: "Afficher les paniers sauvegardés",
    SHOPPING_SUCCESS_TEXT_CONGRATS:
      "Félicitations ! Gagnez du KwikCash chaque fois que quelqu'un achète avec votre code promo ! Cliquez sur le bouton Partager ci-dessous.",
    SHOPPING_PAYMENT_TEXT_PAYMENT_SUCCESSFUL: "Paiement réussi !",
    SHOPPING_PAYMENT_TEXT_SHARE_LINK: "PARTAGEZ VOTRE LIEN",
    SHOPPING_PAYMENT_TEXT_ORDER_ACCEPTED: "Commande acceptée",
    SHOPPING_PASSWORD_TITLE_FORGOT: "Mot de passe oublié",
    SHOPPING_PASSWORD_TEXT_VERIFY: "Pour vérifier que c'est bien vous",
    SHOPPING_PASSWORD_TEXT_ENTER_EMAIL:
      "Entrez votre adresse e-mail enregistrée ci-dessous pour recevoir les instructions du lien de réinitialisation du mot de passe",
    SHOPPING_PASSWORD_LABEL_EMAIL: "Adresse e-mail",
    SHOPPING_PASSWORD_PLACEHOLDER_EMAIL: "Adresse e-mail",
    SHOPPING_PASSWORD_REQUIRED_EMAIL: "L'adresse e-mail est obligatoire",
    SHOPPING_PASSWORD_BUTTON_RESET: "Réinitialiser le mot de passe",
    SHOPPING_PASSWORD_SEND_EMAIL: "Un e-mail a été envoyé !",
    SHOPPING_PASSWORD_SEND_CHECK_INBOX:
      "Veuillez vérifier votre boîte de réception et cliquer sur le lien pour réinitialiser votre mot de passe.",
    SHOPPING_PASSWORD_SEND_BACK_TO_LOGIN: "Retour à la connexion",
    SHOPPING_PASSWORD_SEND_TEXT_DONT_RECEIVE: "Vous n'avez pas reçu le lien ?",
    SHOPPING_PASSWORD_SEND_BUTTON_RESEND: "Renvoyer",
    SHOPPING_PASSWORD_SEND_BUTTON_BACK: "Retour",
    HEADER_PHOTO_EDIT_IMAGE: "Modifier l'image",
    HEADER_PHOTO_OK: "OK",
    HEADER_PHOTO_CANCEL: "Annuler",
    HEADER_HOME: "Accueil",
    HEADER_1CASH: "Récompenses",
    HEADER_CAMPAIGNS: "Campagnes",
    HEADER_ORDER_HISTORY: "Historique des commandes",
    HEADER_SIGN_OUT: "Fermer la session",
    HEADER_LOGOUT: "Déconnexion",
    LOGIN_HEADER_TITLE_REPORT_ISSUE: "Signaler un problème",
    LOGIN_HEADER_LABEL_SUBJECT: "Sujet",
    LOGIN_HEADER_PLACEHOLDER_SUBJECT: "Résumez votre problème ici",
    LOGIN_HEADER_LABEL_DESCRIPTION: "Description",
    LOGIN_HEADER_PLACEHOLDER_DESCRIPTION:
      "Expliquez le problème en détail ici…",
    WELINK_ADDRESS_WE_RE_CURRENTLY:
      "We’re Currently Focused On expanding in the following Metro areas:  Las Vegas, NV; Pheonix, AZ, TUSCON, AZ. WE’LL BE BRINGING OUR WIRELESS FIBER TO EVEN MORE MARKETS IN 2022",
    WELINK_ADDRESS_FIRST_NAME: "Prénom",
    WELINK_ADDRESS_LAST_NAME: "Nom de famille",
    WELINK_ADDRESS_COMPANY_NAME: "Nom de l'entreprise",
    WELINK_ADDRESS_EMAIL: "Email",
    WELINK_ADDRESS_ADDRESS: "Adresse",
    WELINK_ADDRESS_APT_SUITE_ETC_OPTIONAL: "Apt, suite, etc. (facultatif)",
    WELINK_ADDRESS_CITY: "Ville",
    WELINK_ADDRESS_COUNTRY: "Pays",
    WELINK_ADDRESS_STATE: "Région",
    WELINK_ADDRESS_ZIP_CODE: "Code postal",
    WELINK_ADDRESS_PHONE: "Téléphone",
    WELINK_ADDRESS_HOW_MANY_W2_EMPLOYEES_DO_YOU_HAVE:
      "How many w2 Employees do you have?",
    WELINK_ADDRESS_HAS_YOUR_BUSINESS_BEEN:
      "Has your business been impacted or changed by COVID?",
    WELINK_ADDRESS_HAS_YOUR_BUSINESS_HAD:
      'Has your business had a supply chain "disruption" to your business?',
    WELINK_ADDRESS_PROCEED_TO_NEXT: "Suivant",
    FIELD_PROVINCE: "Province",
    FIELD_TOWN_CITY: "Ville",
    FIELD_POSTAL_CODE: "Code postal",
    SSONEWAGE_IF_YOU_ALREADY_SET_UP_MESSAGE:
      'Si vous avez déjà configuré votre compte Kwik en utilisant "Se connecter avec NewAge", vous pouvez également vous connecter à l\'App Kwik avec votre email et votre mot de passe Kwik en <a href="/">cliquant ici</a>.',
    SSONEWAGE_SIGN_IN_WITH_NEWAGE: "Se connecter avec NewAge",
    SSONEWAGE_LINK_AN_EXISTING_ACCOUNT_WITH_NEWAGE_ACCOUNT:
      "Lier un compte existant au Compte NewAge",
    SSONEWAGE_WELCOME_BACK: "Bienvenue à nouveau !",
    SSONEWAGE_ENTER_YOUR_CREDENTIALS_TO_CONTINUE:
      "Entrez vos identifiants pour continuer",
    SSONEWAGE_EMAIL: "Email",
    SSONEWAGE_USERNAME: "Nom d'utilisateur",
    SSONEWAGE_USERNAME_IS_REQUIRED: "Le nom d'utilisateur est obligatoire",
    SSONEWAGE_PASSWORD: "Mot de passe",
    SSONEWAGE_NEXT: "Suivant",
    SSONEWAGE_PLEASE_VERIFY_KWIK_ACCOUNT_INFOMATION:
      "Veuillez vérifier les informations du compte Kwik",
    SSONEWAGE_KWIK_ACCOUNT_EMAIL: "Email du compte Kwik",
    SSONEWAGE_FIRST_NAME: "Prénom",
    SSONEWAGE_LAST_NAME: "Nom de famille",
    SSONEWAGE_PHONE_NUMBER: "Numéro de téléphone",
    SSONEWAGE_NEWAGE_ID: "Identifiant NewAge",
    SSONEWAGE_YOUR_KWIK_ACCOUNT_HAS_ALREADY_MESSAGE:
      "Votre compte Kwik a déjà été lié à cet identifiant NewAge. Si cet identifiant est correct, aucune autre action n'est nécessaire",
    SSONEWAGE_IF_THIS_IS_NOT_MESSAGE:
      "Si ce n'est pas votre identifiant NewAge correct, vous pouvez le mettre à jour.",
    SSONEWAGE_UPDATE: "Mettre à jour",
    SSONEWAGE_IS_THIS_YOU: "C'est bien vous ?",
    SSONEWAGE_YES_AND_PROCEED_TO_NEXT_STEP: "Oui, passer à l'étape suivante",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_THIS_MESSAGE:
      "Nos dossiers montrent que cet identifiant NewAge {{newAgeID}} a été lié à un autre compte Kwik. Veuillez vérifier votre identifiant NewAge et essayer plus tard. Merci !",
    SSONEWAGE_OK: "OK",
    SSONEWAGE_CONDRATULATIONS_YOUR_NEWAGE_ID_MESSAGE:
      "Félicitations ! Votre identifiant et votre mot de passe NewAge ont été vérifiés. Voulez-vous lier cet identifiant NewAge à votre compte Kwik ?",
    SSONEWAGE_YES: "Oui",
    SSONEWAGE_NO: "Non",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_MESSAGE:
      "Nos dossiers montrent que ce nom d'utilisateur a déjà été enregistré auprès de WeR1.",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_THIS_EMAIL_MESSAGE:
      "Nos dossiers montrent que cet email a déjà été enregistré chez Kwik.",
    SSONEWAGE_FORGOT_PASSWORD: "Mot de passe oublié",
    FIELD_DUTY: "Devoir",
    SHARE_LINK_BTGIN_QUALIFYING: "Commencez à vous qualifier",
    "'KWIKCASH': 'KwikCash',": "KwikCash",
    "'CONNECTED': 'Connected!',": "Connecté !",
    ADD_BANK_ACCOUNT: "Ajouter un compte bancaire",
    CONNECTED_YOUR_ACCOUNT: "Nous avons connecté votre compte",
    KWIKCASH_SUCCESSFULLY_ADDED_1: "Vous avez ajouté ceci avec succès",
    KWIKCASH_SUCCESSFULLY_ADDED_2:
      "à votre compte ! Maintenant, nous devons vérifier que vous possédez ce compte bancaire. Voici comment nous procédons",
    KWIKCASH_PROCESSING_STEP_1:
      "Au cours des 1 à 3 prochains jours ouvrables, nous effectuerons deux petits dépôts sur votre compte. Les montants ne seront pas supérieurs à 1$ USD.",
    KWIKCASH_PROCESSING_STEP_2:
      "Une fois que vous aurez vu ces dépôts sur votre compte bancaire, entrez ces montants sur la page suivante",
    KWIKCASH_PROCESSING_STEP_3: "Commencez à encaisser !",
    "'COMPLETE': 'Complete',": "Compléter",
    ENTER_AMOUNT: "Entrez le montant",
    TRANSFER_AMOUNT_DESC:
      "Choisissez le montant que vous souhaitez transférer de votre KwikCash vers votre compte bancaire sélectionné",
    KWIKCASH_SELECT_BANK_ACCOUNT: "Sélectionnez le compte bancaire",
    KWIKCASH_AMOUNT_TO_TRANSFER: "Montant à transférer",
    KWIKCASH_ADD_ACCOUNT: "Ajouter un compte",
    KWIKCASH_PLEASE_CONFIRM: "Veuillez confirmer",
    KWIKCASH_TRANSFER_AMOUNT: "Montant du transfert KwikCash",
    KWIKCASH_TO: "à",
    KWIKCASH_PROCESSING_FEE: "Frais de traitement :",
    KWIKCASH_NET_CASHOUT: "Encaissement net :",
    KWIKCASH_TRANSFER: "Transfert",
    KWIKCASH_CONFIRM: "Confirmer",
    KWIKCASH_CANCEL: "Annuler",
    KWIKCASH_AMOUNT: "Montant",
    KWIKCASH_BANK_NAME: "Nom de la banque",
    KWIKCASH_NEXT: "Suivant",
    KWIKCASH_TRANSFER_SUCCESS_1: "Votre numéro de transaction est",
    KWIKCASH_TRANSFER_SUCCESS_2:
      "et elle a été placée. Un email de confirmation a été envoyé à",
    KWIKCASH_TRANSFER_SUCCESS_3:
      "Veuillez patienter jusqu'à 24 heures pour que le solde KwikCash soit mis à jour",
    KWIKCASH_BACK_KWIKCASH: "Retour à 1Cash",
    KWIKCASH_SUCCESS_HEADER: "Succès !",
    KWIKCASH_PHONE_HEADER: "Vérification du numéro de téléphone",
    KWIKCASH_PHONE_1: "Veuillez confirmer que c'est bien vous",
    KWIKCASH_PHONE_2: "Entrez le code à 4 chiffres qui vous a été envoyé à",
    KWIKCASH_DIDNT_GET_CODE: "Vous n'avez pas reçu le code ?",
    KWIKCASH_RESEND_IT: "Renvoyez-le",
    KWIKCASH_THE_BANK_NAME: "Le compte bancaire",
    KWIKCASH_BANK_LINKED: "A été relié à votre compte",
    KWIKCASH_ENTER_DEPOSIT_DESC:
      "Entrez deux montants que nous avons déposés sur votre compte",
    KWIKCASH_DEPOSIT_1: "Montant du dépôt 1",
    KWIKCASH_DEPOSIT_2: "Montant du dépôt 2",
    KWIKCASH_DEPOSIT_DESC:
      "Cela peut prendre du temps pour que les dépôts apparaissent sur votre compte. Veuillez prévoir 1 à 3 jours pour les percevoir.",
    KWIKCASH_VERIFY: "Vérifier",
    KWIKCASH_BACK: "Retour",
    KWIKCASH_BANK_VERIFY: "Vérifier le compte bancaire",
    KWIKCASH_HISTORY: "Historique KwikCash",
    KWIKCASH_NO_TRANSACTIONS: "Aucune transaction récente",
    KWIKCASH_CONNECT: "Connecter",
    KWIKCASH_BANK_ACCOUNTS: "Comptes bancaires",
    KWIKCASH_PENDING: "En attente",
    KWIKCASH_CONNECT_TO: "Se connecter à",
    KWIKCASH_FEATURE_TBA:
      "Désolé, cette fonctionnalité est encore en cours d'élaboration. Veuillez revenir à une date ultérieure",
    KWIKCASH_LINKED_ACCOUNTS: "Comptes liés",
    KWIKCASH_VALIDATION_MESSAGE:
      "Veuillez remplir le formulaire ci-dessous. Tous les champs sont obligatoires.",
    REGISTER_IMAGE_5M: "The image must not be larger than 2M",
    ACCOUNT: "Account",
    EDIT_ACCOUNT: "Edit Account",
    ACCOUNT_SETTING: "Account Settings",
    HELP_CONTACT: "Help/Contact",
    LEGAL: "Legal",
    LANGUAGE: "Language",
    SELECT_REG: "Select your geographical region",
    SELECT_LANG: "Select your preferred language",
    HEADER_SHARING: "Sharing",
    HEADER_SHOPPING: "Shopping",
    HELP: "Help",
    HELP_SUPPORT: "Help & Support",
    TRACKING: "Tracking",
    STATUS: "Statut",
    VIEW_DETAILS: "View Details",
    MY_REVIEW: "My Review",
    YOUR_STARRATING: "Your Star Rating",
    SAVE: "Save",
    DETAILED_REVIEW: "Detailed Review",
    ORDER_MORE: "Commander plus",
    SHARE_PRODUCT: "Partager un produit",
    EDIT_REVIEW: "Edit a Review",
    WRITE_REVIEW: "Write a Review",
    RETURN_PRODUCT: "Return Product",
    SHIPPING_DETAILS: "Détails de l'expédition",
    TRACKING_NUMBER: "Tracking Number",
    ARRIVAL_DATE: "Arrival Date",
    ORDER_INFO: "Order Information",
    TOTAL_COST: "Total Cost",
    ORDER_DATE: "Date de la commande",
    SHIP_DATE: "Ship Date",
    SHIP_LOCATION: "Destination",
    CHANGE_IMAGE: "Change Image",
    PROFILE_INFO: "Profile Contact Info",
    SETTING_PROFILE_INFO:
      "Please Note: this is how people will be able to reach you from your Profile Page. Update these so people know where to reach out to you.",
    SETTING_LOGIN_EMAIL_PHONE:
      "Your login email and account phone number will still be the same.",
    SECURITY: "Security",
    DISCARD: "Discard",
    CHANGE_PASSWORD: "Change Password",
    "HELP&CONTACT": "Help & Contact",
    CONTACT_US_AT: "Contact us at",
    WHAT_TYPE_PROBLEM: "What type of Problem",
    PROBLEM_REQUIRED: "Problem is required",
    FIELD_REQUIRED: "This field is required",
    ATTACH_IMAGE: "Attach any images or screen captures",
    CONNECTED_DATE: "Connected Date",
    SAVE_ACCONT_DESC:
      "Make changes to this payment method as necessary. When you are finished, click the save button.",
    BANK_NAME_REQUIRED: "Bank Name is required",
    ROUTING_REQUIRED: "Routing Number is required",
    ACCOUNT_NUMBER_REQUIRED: "Account Number is required",
    ACCOUNT_TYPE_REQUIRED: "Account Type is required",
    ACCONT_CONFIRM:
      "Changes to this type of account may require you to confirm the account. This will be done by entering the amounts of two small deposits into the account.",
    REMOVE_METHOD: "Remove Method",
    LEGAL_INFO: "Legal Information",
    VENDOR_ALL_VENDORS: "Tous les vendeurs",
    VENDOR_CAMPAIGNS: "Campagnes",
    VENDOR_CAMPAIGN_LOGO: "Logo de la campagne",
    VENDOR_CAMPAIGN_NAME: "Nom de la campagne",
    VENDOR_MARKET: "Marché",
    VENDOR_CURRENCY: "Monnaie",
    VENDOR_START_DATE: "Date de début",
    VENDOR_END_DATE: "Date de fin",
    VENDOR_ACTIONS: "Actions",
    VENDOR_EDIT: "Modifier",
    VENDOR_DELETE: "Supprimer",
    VENDOR_BACK_TO_CAMP_LIST: "Retour à la liste des campagnes",
    VENDOR_CAMP_DETAIL: "Détail de la campagne",
    VENDOR_UPDATE: "Mettre à jour",
    VENDOR_SAVE: "Enregistrer",
    VENDOR_CANCEL: "Annuler",
    VENDOR_PLS_INPUT_CAMP_NAME: "Veuillez saisir le nom de la campagne !",
    VENDOR_PLS_SELECT_ONE: "Veuillez en sélectionner un !",
    VENDOR_PRTS: "Achat requis pour partager",
    VENDOR_NPRTS: "    Aucun achat requis pour partager",
    VENDOR_FREE_TO_SHARE: "Gratuit pour le partage",
    VENDOR_CAMP_IMAGE: "Image de la campagne",
    VENDOR_DRAG_AND_DROP: "GLISSER-DÉPOSER",
    VENDOR_YFTA: "vos fichiers aux actifs, ou",
    VENDOR_BROWSE: "parcourir",
    VENDOR_IMAGE: "Image",
    VENDOR_PRODUCT_NAME: "Nom du produit",
    VENDOR_AC_NAME: "Actions/Nom de la campagne",
    VENDOR_TPHBATTC: "Ce produit a été attribué à la campagne",
    VENDOR_AYSYWT_DELETE: "Etes-vous sûr de vouloir supprimer ?",
    VENDOR_YCLTC_TIPS:
      "Vous ne pouvez pas lier la campagne au produit car ils appartiennent à des vendeurs différents",
    VENDOR_SEARCH_TIPS: "Rechercher un produit, un client, etc...",
    VENDOR_PRODUCT_ID: "ID du produit",
    VENDOR_COUNTRY: "Pays",
    VENDOR_REMOVE_FROM_CAMP: "supprimer des campagnes",
    VENDOR_CUSTOMERS: "Clients",
    VENDOR_HEAD: "Tête",
    VENDOR_USER_NAME: "Nom d'utilisateur",
    VENDOR_USER_ID: "ID de l'utilisateur",
    VENDOR_EMAIL_ADDRESS: "Adresse e-mail",
    VENDOR_PHONE_NUMBER: "Numéro de téléphone",
    VENDOR_BACK_TO_CUSTOMER_LIST: "Retour à la liste des clients",
    VENDOR_USER_PROFILE: "Profil de l'utilisateur",
    VENDOR_UPDATE_PROFILE: "Mettre à jour le profil",
    VENDOR_FIRST_ROMAN_NAME: "Prénom romain",
    VENDOR_LAST_ROMAN_NAME: "Nom de famille romain",
    VENDOR_FIRST_NATIVE_NAME: "Prénom de naissance",
    VENDOR_LAST_NATIVE_NAME: "Nom de naissance",
    VENDOR_ADD_LINE_1: "Ligne d'adresse 1",
    VENDOR_ADD_LINE_2: "Ligne d'adresse 2",
    VENDOR_CITY: "Ville",
    VENDOR_STATE: "Région",
    VENDOR_ZIP_CODE: "Code postal",
    VENDOR_BIO: "Bio",
    VENDOR_BIO_TIPS:
      "Faites court et simple. Décrivez-vous au monde entier. Ce sera votre biographie, que tout le monde pourra voir.",
    VENDOR_STATUS: "Statut",
    VENDOR_ORDER_HISTORY: "Historique des commandes",
    VENDOR_ORDERS: "Commandes",
    VENDOR_DATE: "Date",
    VENDOR_CUSTOMER: "Client",
    VENDOR_PAYMENT_STATUS: "Statut de paiement",
    VENDOR_FULFILLMENT_STATUS: "Statut de traitement",
    VENDOR_PRICE: "Prix",
    VENDOR_ALL_ORDERS: "Toutes les commandes",
    VENDOR_OPERATE: "Opérer",
    VENDOR_EXPORT: "Exporter",
    VENDOR_ORDER_ID: "ID de la commande",
    VENDOR_MARK_AS_FULFILLED: "Marquer comme exécuté",
    VENDOR_ALL_STATUS: "Tous les statuts",
    VENDOR_PLS_SELECT: "Veuillez sélectionner",
    VENDOR_START_TIME_TO_END_TIME: "Date de début - Date de fin",
    VENDOR_PLS_INPUT_STTET:
      "Veuillez saisir la date de début et la date de fin !",
    VENDOR_TRACKING: "Suivi",
    VENDOR_REFUNDED: "Remboursé",
    VENDOR_STAFF_DELETE_TIPS: "Etes-vous sûr de vouloir supprimer ?",
    VENDOR_STAFF: "Personnel",
    VENDOR_ADD_STAFF: "Ajouter du personnel",
    VENDOR_FULL_NAME: "Nom complet",
    VENDOR_DEPARTMENT: "Département",
    VENDOR_ROLE: "Rôle",
    VENDOR_ADD: "Ajouter",
    VENDOR_PFTFB: "Veuillez remplir le formulaire ci-dessous.",
    VENDOR_PWD: "Mot de passe",
    VENDOR_PSYR: "Veuillez sélectionner votre rôle !",
    VENDOR_PIYUI: "Veuillez saisir votre ID utilisateur !",
    VENDOR_PIYUN: "Veuillez saisir votre nom d'utilisateur !",
    VENDOR_PIYP: "Veuillez saisir votre mot de passe !",
    VENDOR_PIYE: "Veuillez saisir votre adresse e-mail !",
    VENDOR_BSE: "Acheter. Partagez. Gagnez.",
    VENDOR_BSE_DESC:
      "Kwik est une nouvelle plateforme de marché qui connecte les marques à leurs plus grands fans, créant ainsi une puissante force de vente de bouche à oreille.",
    VENDOR_PETIMBTAYA:
      "Veuillez saisir les informations mentionnées ci-dessous pour accéder à votre compte.",
    VENDOR_PIYEOU:
      "Veuillez saisir votre adresse email ou votre nom d'utilisateur !",
    VENDOR_KEEP_SIGN_IN: "Restez connecté",
    VENDOR_DONT_HAVE_ACCOUNT: "Vous n'avez pas encore de compte ?",
    VENDOR_CREATE_ONE: "Créer un compte",
    VENDOR_PPTREATRP:
      "Veuillez fournir l'adresse e-mail enregistrée pour réinitialiser le mot de passe.",
    VENDOR_ALREADY_KNOW_PASSWORD: "Vous connaissez déjà le mot de passe",
    VENDOR_GO_TO_SIGNIN: "Aller vers Se connecter",
    VENDOR_PCYI_CTLTRYP:
      "Veuillez vérifier votre boîte de réception et cliquer sur le lien pour réinitialiser votre mot de passe.",
    VENDOR_DIDNOT_RECEIVE_THE_LINK: "Vous n'avez pas reçu le lien ?",
    VENDOR_CHOOSE_NEW_PWD: "Choisissez un nouveau mot de passe",
    VENDOR_EAUPTCYNP:
      "Entrez un mot de passe unique pour créer votre nouveau mot de passe",
    VENDOR_NEW_PWD: "Nouveau mot de passe",
    VENDOR_PIYCP: "Veuillez saisir votre mot de passe confirmé !",
    VENDOR_SUCESS: "Succès",
    VENDOR_YAHBC_PL: "Votre compte a été créé. Veuillez vous connecter",
    VENDOR_CYBAN: "Créez votre compte professionnel maintenant.",
    VENDOR_PPUWSITCYA:
      "Veuillez nous fournir quelques informations pour créer votre compte",
    VENDOR_BUSINESS_NAME: "Nom de l'entreprise",
    VENDOR_PIBN: "Veuillez saisir le nom de l'entreprise",
    VENDOR_BPN: "Numéro de téléphone de l'entreprise",
    VENDOR_PIPN: "Veuillez saisir le numéro de téléphone",
    VENDOR_EAFCA: "Adresse e-mail pour le compte de l'entreprise",
    VENDOR_PIEA: "Veuillez saisir l'adresse e-mail",
    VENDOR_PIP: "Veuillez saisir le mot de passe",
    VENDOR_CYP: "Confirmer votre mot de passe",
    VENDOR_PICP: "Veuillez saisir Confirmation du mot de passe",
    VENDOR_INCONSISTENT_PWD: "Mots de passe incohérents",
    VENDOR_IAGREETOTHE: "J'accepte les",
    VENDOR_TERMS_CONDITIONS: "termes et conditions",
    VENDOR_PCTT_CONDITONS_AGREEMENT:
      "Veuillez vérifier l'accord des termes et conditions",
    VENDOR_BUSINESS_INFO: "Informations commerciales",
    VENDOR_BUSINESS_INFO_DESC:
      "Veuillez noter que ces informations ne sont pas nécessaires lors de l'inscription, mais qu'elles sont requises pour la mise en ligne",
    VENDOR_BUSINESS_TYPE: "Type d'entreprise",
    VENDOR_PLS_INPUT_BUSINESS_TYPE: "Veuillez saisir le type d'entreprise",
    VENDOR_SSN_EIN: "NIN (ou ERN si entreprise)",
    VENDOR_PLS_INPUT_SSN: "Veuillez saisir le NIN",
    VENDOR_WHO_REFER_YOU_TO_KWIK: "Qui vous a recommandé à Kwik ?",
    VENDOR_JSWCGTCTTRP:
      "Juste pour que nous puissions donner le crédit à la bonne personne",
    VENDOR_PLS_INPUT_FN: "Veuillez saisir le Prénom",
    VENDOR_PLS_INPUT_LN: "Veuillez saisir le Nom de famille",
    VENDOR_PLS_INPUT_EA: "Veuillez saisir votre Adresse e-mail",
    VENDOR_BRAND_INDUSTRY: "Secteur de la marque",
    VENDOR_PLS_INPUT_BRAND_INDUSTRY:
      "Veuillez sélectionner le Secteur de la marque",
    VENDOR_CONTACT_INFO: "Informations de contact",
    VENDOR_CONTACT_INFO_DESC:
      "Votre marque sera en attente jusqu'à ce qu'elle soit approuvée. Nous avons besoin de quelqu'un que nous pourrons contacter",
    VENDOR_BUSINESS_URL: "URL de l'entreprise",
    VENDOR_CR: "Revenu de l'entreprise (revenu annuel de l'année précédente)",
    VENDOR_PLS_INPUT_CR: "Veuillez saisir le Revenu de l'entreprise",
    VENDOR_SUCCESS: "Succès",
    VENDOR_REGISTER_SUCCESS_1:
      "Merci d'avoir rempli les informations du profil de la marque",
    VENDOR_REGISTER_SUCCESS_2:
      "Un membre de notre Équipe de Marques vous contactera bientôt pour recueillir plus d'informations et vous aider à intégrer vos produits à Kwik !",
    VENDOR_REGISTER_SUCCESS_3: "Merci pour votre patience.",
    VENDOR_REGISTER_SUCCESS_4: "Temps estimé : 1-3 jours",
    VENDOR_KWIK_HOME: "Accueil Kwik",
    VENDOR_STILL_PENDING: "Toujours en attente",
    VENDOR_REGISTER_PENDING_1:
      "Toutes nos excuses, notre Équipe de Gestion de  Marque est très occupée en ce moment, et l'intégration prend plus de temps que prévu.",
    VENDOR_REGISTER_PENDING_2:
      "Nous faisons tout notre possible pour que toutes les marques soient sur Kwik.",
    VENDOR_REGISTER_PENDING_3:
      "Utilisez les identifiants de votre marque pour vous connecter et voir ce que les utilisateurs verraient !",
    VENDOR_CHECK_OUT_USER: "Vérifiez l'expérience utilisateur",
    VENDOR_USER_USERNAME: "Nom d'utilisateur",
    DASHBOARD_HI_USER_NAME: "Bonjour,{{userName}}",
    DASHBOARD_ANALYTIC_REPORT: "Rapport analytique",
    DASHBOARD_SEARCH_FOR_PRODUCT_PLACEHOLDER:
      "Rechercher un produit, un client, etc.",
    DASHBOARD_TOTAL_EARNINGS: "Gains totaux",
    DASHBOARD_EARNINGS_REPORT: "Rapport de gains",
    DASHBOARD_HERE_IS_THE_UPDATE_OF_YOUR_EARNING:
      "Voici les mises à jour de vos gains",
    DASHBOARD_THIS_WEEK_ITEM: "Cette semaine",
    DASHBOARD_THIS_MONTH_ITEM: "Ce mois-ci",
    DASHBOARD_THIS_YEAR_ITEM: "Cette année",
    DASHBOARD_YOUR_TOTAL_EARNINGS: "Vos gains totaux",
    DASHBOARD_GET_ALL_THE_EARNING_MESSAGE:
      "Obtenez tous les gains de la semaine, du mois, de l'année en un seul endroit",
    DASHBOARD_REVENUE: "Revenus",
    DASHBOARD_USERS: "Utilisateurs",
    DASHBOARD_ALL_USERS: "Tous les utilisateurs",
    DASHBOARD_NEW_USERS: "Nouveaux utilisateurs",
    DASHBOARD_TOP_SELLING_PRODUCTS: "Produits les plus vendus",
    DASHBOARD_IMAGE_TH: "Image",
    DASHBOARD_PRODUCT_NAME_TH: "Nom du produit",
    DASHBOARD_STATUS_TH: "Statut",
    DASHBOARD_PRICE_TH: "Prix",
    DASHBOARD_SALES_TH: "Ventes",
    DASHBOARD_KWIKCASH_VALUE_TH: "Valeur KwikCash",
    DASHBOARD_INVENTORY_IN_STOCK: "{{inventory}} en stock",
    DASHBOARD_TOP_EARNERS: "Top gagnants",
    DASHBOARD_ACTIVITY: "Activité",
    DASHBOARD_PURCHASED: "acheté",
    PRODUCTS_PRODUCTS_TITLE: "Produits",
    PRODUCTS_IMAGE_TH: "Image",
    PRODUCTS_PRODUCT_NAME_TH: "Nom du produit",
    PRODUCTS_PRODUCT_ID_TH: "ID du produit",
    PRODUCTS_COUNTRY_TH: "Pays",
    PRODUCTS_CURRENCY_TH: "Devise",
    PRODUCTS_TYPE_TH: "Type",
    PRODUCTS_PRICE_TH: "Prix",
    PRODUCTS_BUDGET_TH: "Budget",
    PRODUCTS_KWIKCASH_VALUE_TH: "Valeur KwikCash",
    PRODUCTS_ACTIONS_TH: "Actions",
    PRODUCTS_EDIT_BUTTON: "Modifier",
    PRODUCTS_PREVIEW_BUTTON: "    Aperçu",
    PRODUCTS_DETAIL_UPDATE_PRODUCT: "Mettre à jour le produit",
    PRODUCTS_DETAIL_ADD_PRODUCT: "Ajouter un produit",
    PRODUCTS_DETAIL_PLEASE_FILL_THE_FORM_BELLOW:
      "Veuillez remplir le formulaire ci-dessous",
    PRODUCTS_DETAIL_CANCEL_BUTTON: "Annuler",
    PRODUCTS_DETAIL_SAVE_PRODUCT: "Enregistrer le produit",
    PRODUCTS_DETAIL_COUNTRY: "Pays",
    PRODUCTS_DETAIL_PLEASE_SELECT_COUNTRY: "Veuillez sélectionner le pays !",
    PRODUCTS_DETAIL_PLEASE_SELECT_WAREHOUSE:
      "    Veuillez sélectionner l'entrepôt !",
    PRODUCTS_DETAIL_SELECT_COUNTRY: "Sélectionnez le pays",
    PRODUCTS_DETAIL_CURRENCY: "Devise",
    PRODUCTS_DETAIL_SELECT_CURRENCY: "Sélectionnez la devise",
    PRODUCTS_DETAIL_WAREHOUSE: "Entrepôt",
    PRODUCTS_DETAIL_SELECT_WAREHOUSE: "Sélectionnez l'entrepôt",
    PRODUCTS_DETAIL_GENERAL_INFO: "Informations générales",
    PRODUCTS_DETAIL_PRODUCT_NAME: "Nom du produit",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_PRODUCT_NAME:
      "Veuillez saisir le nom de votre produit !",
    PRODUCTS_DETAIL_PRODUCT_SHORT_DESCRIPTION:
      "Description courte du produit (limitée à 200 caractères)",
    PRODUCTS_DETAIL_ADD_PRODUCT_IMAGE: "Ajouter une image du produit",
    PRODUCTS_DETAIL_REMOVE: "Enlever",
    PRODUCTS_DETAIL_DRAG_AND_DROP: "GLISSER-DÉPOSER",
    PRODUCTS_DETAIL_YOUR_FILES_TO_ASSETS:
      "vos fichiers aux actifs, ou <span>browse</span>",
    PRODUCTS_DETAIL_ACCEPTED_FILE_TYPE:
      "Types de fichiers acceptés : PNG, JPEG uniquement.",
    PRODUCTS_DETAIL_RETURN_POLICY: "Politique de retour",
    PRODUCTS_DETAIL_PLEASE_ENTER_THE_NUMBER: "Veuillez saisir le nombre",
    PRODUCTS_DETAIL_DAYS: "Jours",
    PRODUCTS_DETAIL_ADD_PRODUCT_VIDEO: "Ajouter une vidéo du produit",
    PRODUCTS_DETAIL_VIDEO_URL: "URL de la vidéo",
    PRODUCTS_DETAIL_PRICING: "Prix",
    PRODUCTS_DETAIL_PRICE: "Prix",
    PRODUCTS_DETAIL_COMPARE_AT_PRICE: "Comparer au prix (Prix de vente)",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_SALE_PRICE:
      "Veuillez saisir votre Prix de vente !",
    PRODUCTS_DETAIL_BUDGET: "Budget",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_BUDGET: "Veuillez saisir votre Budget !",
    PRODUCTS_DETAIL_FULL_KWIK_CASH: "KwikCash complet",
    PRODUCTS_DETAIL_1ST_WAVE_COMMISSION_RATE:
      "Taux de commission de la 1re vague",
    PRODUCTS_DETAIL_VAT_RATE: "Taux de TVA",
    PRODUCTS_DETAIL_TAX_RATE: "Taux de TVA",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_VAT_RATE:
      "Veuillez saisir votre taux de TVA !",
    PRODUCTS_DETAIL_VAT_INCLUSIVE: "TVA incluse",
    PRODUCTS_DETAIL_TAX_INCLUSIVE: "TVA incluse",
    PRODUCTS_DETAIL_TAX_CATEGORY: "Catégorie de taxe",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_TAX_CATEGORY:
      "Veuillez saisir votre Catégorie de taxe !",
    PRODUCTS_DETAIL_DUTY_RATE: "Taux des droits de douane",
    PROUDCTS_DETAIL_DUTY_INCLUSIVE: "Droits de douane inclus",
    PRODUCTS_DETAIL_NEWAGE_CAMPAIGN: "Campagne NewAge",
    PRODUCTS_DETAIL_FULFILED_BY_NEWAGE: "Rempli par NewAge",
    PRODUCTS_DETAIL_PV: "PV",
    PRODUCTS_DETAIL_INVENTORY: "Inventaire",
    PRODUCTS_DETAIL_SKU_STOCK_KEPING_UNIT: "UGS (Unité de Gestion des Stocks)",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_SKU: "Veuillez saisir votre UGS !",
    PRODUCTS_DETAIL_QUANTITY: "Quantité",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_INVENTORY:
      "Veuillez saisir votre inventaire !",
    PRODUCTS_DETAIL_SHIPPING: "Livraison",
    PRODUCTS_DETAIL_WEIGHT: "Poids",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_WEIGHT: "Veuillez saisir votre poids !",
    PRODUCTS_DETAIL_CANADA_NFR_LIMITS: "Limites NFR (Not for Resale) du Canada",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_NFR_LIMITS:
      "Veuillez saisir vos limites NFR !",
    PRODUCTS_DETAIL_PRODUCT_STATUS: "Statut du produit",
    PRODUCTS_DETAIL_SCHEDULE_LAUNCH_TIME: "Heure de lancement prévue",
    PRODUCTS_DETAIL_PRODUCT_LONG_DESCRIPTION: "Description longue du produit",
    PRODUCTS_DETAIL_ORGANIZATION: "Organisation",
    PRODUCTS_DETAIL_PRODUCT_CATEGORY: "Catégorie de produit",
    PRODUCTS_DETAIL_PLEASE_SELECT_YOUR_PRODUCT_CATEGORY:
      "Veuillez sélectionner votre Catégorie de produit !",
    PRODUCTS_DETAIL_PLEASE_SELECT: "Veuillez sélectionner",
    PRODUCTS_DETAIL_SUBCATEGORY: "Sous-catégorie",
    PRODUCTS_DETAIL_PLEASE_SELECT_YOUR_SUBCATEGORY:
      "Veuillez sélectionner votre sous-catégorie !",
    PRODUCTS_DETAIL_VARIANTS_INFO: "Informations sur les Variantes",
    PRODUCTS_DETAIL_VARIANT_NAME: "Nom de la Variante",
    PRODUCTS_DETAIL_ADD_OPTION: "Ajouter une Option",
    PRODUCTS_DETAIL_ADD_VARIANT: "Ajouter une Variante",
    PRODUCTS_DETAIL_VARIANTS_TH: "Variantes",
    PRODUCTS_DETAIL_IMAGE_URL_TH1: "    Image1",
    PRODUCTS_DETAIL_IMAGE_URL_TH2: "    Image2",
    PRODUCTS_DETAIL_IMAGE_URL_TH3: "    Image3",
    PRODUCTS_DETAIL_IMAGE_URL_TH4: "    Image4",
    PRODUCTS_DETAIL_DETELE_TH: "Supprimer",
    PRODUCTS_DETAIL_DELETE_IT_TH: "Supprimer ?",
    PRODUCTS_DETAIL_SKU_TH: "SKU",
    PRODUCTS_DETAIL_PRICE_TH: "PRIX",
    PRODUCTS_DETAIL_COMPARE_TO_TH: "COMPARER_AVEC",
    PRODUCTS_DETAIL_POINTS_TH: "    POINTS",
    PRODUCTS_DETAIL_BUDGET_TH: "BUDGET",
    PRODUCTS_DETAIL_KCASH_TH: "KCASH",
    PRODUCTS_DETAIL_INVENTORY_TH: "INVENTAIRE",
    PRODUCTS_DETAIL_START_DATE_TH: "DATE_DE_DÉBUT",
    PRODUCTS_DETAIL_END_DATE_TH: "DATE_DE_FIN",
    PRODUCTS_DETAIL_STATUS_TH: "STATUT",
    PRODUCTS_DETAIL_ACTIVE: "Actif",
    PRODUCTS_DETAIL_HIDDEN: "Caché",
    PRODUCTS_DETAIL_WEIGHT_TH: "POIDS",
    WAREHOUSE_PRODUCTS: "Produits",
    WAREHOUSE_WAREHOUSE: "Entrepôt",
    WAREHOUSE_ADD_WAREHOUSE_BUTTON: "Ajouter un Entrepôt",
    WAREHOUSE_NAME_TH: "Nom",
    WAREHOUSE_COUNTRY_TH: "Pays",
    WAREHOUSE_ADDRESS1_TH: "Adresse 1",
    WAREHOUSE_ADDRESS2_TH: "Adresse 2",
    WAREHOUSE_CITY_TH: "Ville",
    WAREHOUSE_STATE_TH: "Etat",
    WAREHOUSE_POSTAL_CODE_TH: "Code postal",
    WAREHOUSE_CONTACT_TH: "Contact",
    WAREHOUSE_PHONE_TH: "Téléphone",
    WAREHOUSE_SHIPPING_VENDOR_TH: "Fournisseur d'expédition",
    WAREHOUSE_ACTIONS_TH: "Actions",
    WAREHOUSE_EDIT_BUTTON: "Modifier",
    WAREHOUSE_DETAIL_BACK_TO_WAREHOUSE_LIST: "Retour à la Liste des Entrepôts",
    WAREHOUSE_DETAIL_WAREHOUSE_DETAIL: "Détails de l'Entrepôt",
    WAREHOUSE_DETAIL_UPDATE: "Mettre à jour",
    WAREHOUSE_DETAIL_SAVE: "Sauvegarder",
    WAREHOUSE_DETAIL_CANCEL: "Annuler",
    WAREHOUSE_DETAIL_FORM_NAME: "Nom",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_NAME: "Veuillez saisir le nom !",
    WAREHOUSE_DETAIL_FORM_COUNTRY: "Pays",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_COUNTRY: "Veuillez saisir le pays !",
    WAREHOUSE_DETAIL_FORM_SELECT_COUNTRY: "Sélectionnez le pays",
    WAREHOUSE_DETAIL_FORM_PLEASE_SELECT: "Veuillez sélectionner",
    WAREHOUSE_DETAIL_FORM_ADDRESS1: "Adresse 1",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_ADDR1:
      "Veuillez saisir l'adresse ligne 1 !",
    WAREHOUSE_DETAIL_FORM_ADDRESS2: "Adresse 2",
    WAREHOUSE_DETAIL_FORM_CITY: "Ville",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_CITY: "Veuillez saisir la ville !",
    WAREHOUSE_DETAIL_FORM_STATE: "Région",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_STATE: "Veuillez saisir la région !",
    WAREHOUSE_DETAIL_FORM_POSTAL_CODE: "Code postal",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_POSTAL_CODE:
      "Veuillez saisir le code postal !",
    WAREHOUSE_DETAIL_FORM_CONTACT: "Contact",
    WAREHOUSE_DETAIL_FORM_PHONE: "Téléphone",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_PHONE:
      "Veuillez saisir le numéro de téléphone !",
    WAREHOUSE_DETAIL_FORM_SHIPPING_VENDOR: "Vendeur d'expédition",
    INVENTORY_PRODUCTS: "Produits",
    INVENTORY_INVENTORY: "Inventaire",
    INVENTORY_IMAGE: "Image",
    INVENTORY_PRODUCT_NAME: "Nom du Produit",
    INVENTORY_SUPPLIER: "Fournisseur",
    INVENTORY_SKU: "SKU#",
    INVENTORY_QTY_ALLOTED: "Qté allouée",
    INVENTORY_QTY_SOLD: "Qté vendue",
    INVENTORY_QTY_ON_HAND: "Qté disponible",
    INVENTORY_SALES: "Ventes",
    SIDEBAR_MENU: "Menu",
    SIDEBAR_OVERVIEW: "Aperçu",
    SIDEBAR_PRODUCTS: "Produits",
    SIDEBAR_WAREHOUSE: "Entrepôt",
    SIDEBAR_INVENTORY: "Inventaire",
    SIDEBAR_ADD_PRODUCT: "Ajouter un produit",
    SIDEBAR_GRAPH_VIEW: "Vue graphique",
    SIDEBAR_CAMPAIGNS: "Campagnes",
    SIDEBAR_CREATE_EDIT_CAMPAIGNS: "Créer/modifier des campagnes",
    SIDEBAR_MAP_CAMPAIGNS_PRODUCTS: "Cartographier les campagnes/produits",
    SIDEBAR_CUSTOMERS: "Clients",
    SIDEBAR_ORDERS: "Commandes",
    SIDEBAR_PAYOUTS: "Paiements",
    SIDEBAR_STAFF_MANAGEMENT: "Gestion du personnel",
    SIDEBAR_SETTINGS: "Paramètres",
    SETTINGS_GENERAL_STORE_DETAILS: "Détails du magasin",
    SETTINGS_GENERAL_STORE_ADDRESS: "    Adresse du magasin",
    SETTINGS_GENERAL_YOUR_CUSTOMERS_WILL_MESSAGE:
      "Vos clients utiliseront ces informations pour vous contacter.",
    SETTINGS_GENERAL_STORE_NAME: "Nom du magasin",
    SETTINGS_GENERAL_CONTACT_EMAIL: "Email de contact",
    SETTINGS_GENERAL_ADD_LOGO: "Ajouter un logo",
    SETTINGS_GENERAL_DRAG_AND_DROP: "GLISSER-DÉPOSER",
    SETTINGS_GENERAL_YOUR_FILES_TO_ASSETS: "<span>browse</span>",
    SETTINGS_ACCEPTED_FILE_TYPE:
      "Types de fichiers acceptés : PNG, JPEG uniquement.",
    SETTINGS_ACCEPTED_ADD_HERO_BANNER: "Ajouter une bannière de super-héros",
    SETTINGS_ACCEPTED_REMOVE: "Enlever",
    SETTINGS_GENERAL_UPLOAD_TERMS_AND_CONDITIONS:
      "Télécharger les Termes et Conditions",
    SETTINGS_GENERAL_ENTER_YOUR_TEXT: "Entrez votre texte",
    SETTINGS_GENERAL_STORE_INFORMATION: "Informations sur le magasin",
    SETTINGS_GENERAL_SHARE_BIO_LIMIT_CHARACTERS:
      "Partager la bio (limite de 120 caractères)",
    SETTINGS_GENERAL_COPY_AND_PASTE_YOUR_MESSAGE:
      "Copiez et collez vos termes et conditions ici",
    SETTINGS_GENERAL_ENTER_URL_S: "Entrez l'URL",
    SETTINGS_GENERAL_WEBSITE_URL: "URL du site web",
    SETTINGS_GENERAL_FACEBOOK_URL: "URL Facebook",
    SETTINGS_GENERAL_INSTAGRAM_URL: "URL Instagram",
    SETTINGS_GENERAL_TWITTER_URL: "URL Twitter",
    SETTINGS_GENERAL_UPLOAD_RETURN_POLICY_HERE:
      "Télécharger la Politique de retour ici",
    SETTINGS_GENERAL_UPLOAD_SHIPPING_POLICY_HERE:
      "Télécharger la Politique d'expédition ici",
    SETTINGS_GENERAL_ACTIVE_STATUS: "Statut actif",
    SETTINGS_GENERAL_PENDING: "En attente",
    SETTINGS_GENERAL_APPROVED: "Approuvé",
    SETTINGS_GENERAL_LIVE: "En direct",
    SETTINGS_GENERAL_DISCARD: "Rejeter",
    SETTINGS_GENERAL_SAVE: "Sauvegarder",
    SETTINGS_PROFILE_SAVE_PROFILE: "Enregistrer le profil",
    SETTINGS_PROFILE_PREVIEW: "Aperçu",
    SETTINGS_BANKINFO_CONNECT_BANK_ACCOUNT: "Connecter le compte bancaire",
    SETTINGS_BANKINFO_ACCEPT_PAYMENTS_ON_YOUT_MESSAGE:
      "Accepter les paiements sur votre boutique en utilisant des fournisseurs tiers tels que PayPal ou d'autres méthodes de paiement",
    SETTINGS_BANKINFO_ADD_BANK_ACCOUNT: "Ajouter un compte bancaire",
    SETTINGS_BANKINFO_EDIT: "Modifier",
    SETTINGS_BANKINFO_MANUAL_VERIFICATION: "Vérification manuelle",
    SETTINGS_BANKINFO_AT_KWIK_YOUR_SECURITY_MESSAGE:
      "Chez Kwik, votre sécurité est très importante pour nous, nous allons donc vérifier votre compte bancaire en effectuant deux très petits dépôts sur votre compte. Veuillez entrer ces montants lorsqu'ils apparaissent sur votre compte",
    SETTINGS_BANKINFO_GO_BACK: "Revenir en arrière",
    SETTINGS_BANKINFO_CONTINUE: "Continuer",
    SETTINGS_BANKINFO_PLEASE_VERIFY_THE_MESSAGE:
      "Veuillez vérifier les petits dépôts que nous avons placés sur votre/vos compte(s)",
    SETTINGS_BANKINFO_CHARGE1: "Dépôt 1",
    SETTINGS_BANKINFO_ENTER_AMOUNT: "Entrez le montant",
    SETTINGS_BANKINFO_CHARGE2: "Dépôt 2",
    SETTINGS_BANKINFO_TO_VERIFY_YOUR_MESSAGE:
      "Pour vérifier votre compte bancaire, vous verrez deux dépôts et deux retraits sur votre relevé bancaire au cours des deux ou trois prochains jours. Chacun d'eux sera inférieur à 1$ USD",
    SETTINGS_BANKINFO_PLEASE_MAKE_SURE_MESSAGE:
      "Veuillez vous assurer qu'il y a un solde d'au moins 2$ USD pour éviter les frais de découvert",
    SETTINGS_BANKINFO_BANK_ROUTING_NUMBER: "Numéro d'acheminement de la banque",
    SETTINGS_BANKINFO_ROUTING_NUMBER: "Numéro de routage",
    SETTINGS_BANKINFO_ACCOUNT_NUMBER: "Numéro de compte",
    SETTINGS_BANKINFO_CONFIRM_ACCOUNT_NUMBER: "Confirmer le Numéro de compte",
    SETTINGS_BANKINFO_ACCOUNT_NAME: "Nom du Compte",
    SETTINGS_BANKINFO_ENTER_ACCOUNT_NAME: "Entrez le Nom du compte",
    SETTINGS_BANKINFO_SET_YOUR_SHIPPING_RATES:
      "Définir vos Tarifs d'expédition",
    SETTINGS_BANKINFO_SET_YOUR_VARIOUS_SHIPPING_RATES:
      "Définir vos différents Tarifs d'expédition",
    SETTINGS_BANKINFO_ADD_RATE: "Ajouter un Taux",
    SETTINGS_BANKINFO_ADD_A_NEW_SHIPPING_RATES:
      "Ajouter un nouveau Taux d'expédition",
    SETTINGS_BANKINFO_PRICING: "Prix",
    SETTINGS_BANKINFO_ADD_CONDITIONS: "Ajouter des conditions",
    SETTINGS_BANKINFO_BASED_ON_ITEM_WEIGHT: "Basé sur le poids de l'article",
    SETTINGS_BANKINFO_BASED_ON_ORDER_PRICE: "Basé sur le prix de la commande",
    SETTINGS_BANKINFO_NUMBER_OF_UNITS: "Nombre d'unités",
    SETTINGS_BANKINFO_SAVE_RATE: "Enregistrer le taux",
    SETTINGS_BANKINFO_CANCEL: "Annuler",
    SETTINGS_SHIPPINGCOST_SHOW_ALL: "Tout afficher",
    SETTINGS_SHIPPINGCOST_ADD_SHIPPING_FORMULA:
      "Ajouter une Formule d'expédition",
    SETTINGS_SHIPPINGCOST_EDIT_SHIPPING_FORMULA:
      "Modifier la Formule d'expédition",
    SETTINGS_SHIPPINGCOST_SAVE: "Enregistrer",
    SETTINGS_SHIPPINGCOST_SKU_ID: "ID UGS",
    SETTINGS_SHIPPINGCOST_PRODUCT_NAME: "Nom du produit",
    SETTINGS_SHIPPINGCOST_DELETE: "Supprimer",
    SETTINGS_SHIPPINGCOST_BY_PRICE: "Par prix",
    SETTINGS_SHIPPINGCOST_BY_WEIGHT: "Par poids",
    SETTINGS_SHIPPINGCOST_BY_COUNT: "Par nombre",
    SETTINGS_SHIPPINGCOST_FROM_PRICE: "Du prix",
    SETTINGS_SHIPPINGCOST_TO_PRICE: "Au prix",
    SETTINGS_COUNTRY_CODE: "    Code pays",
    SETTINGS_VAT_ID: "    Numéro de TVA",
    SHIPPINGS_SHIPPINGCOST_FROM_LBS: "De kg",
    SHIPPINGS_SHIPPINGCOST_TO_LBS: "A kg",
    SHIPPINGS_SHIPPINGCOST_FROM_COUNTS: "De Nombre",
    SHIPPINGS_SHIPPINGCOST_TO_COUNTS: "A Nombre",
    SHIPPINGS_SHIPPINGCOST_PLEASE_SELECT_VENDOR:
      "Veuillez sélectionner le vendeur",
    SHIPPINGS_SHIPPINGCOST_PLEASE_SELECT_SHIPPING_METHOD:
      "Veuillez sélectionner le mode d'expédition",
    SHIPPINGS_SHIPPINGCOST_ITEM_ALREADY_EXISTS: "L'article existe déjà",
    SHIPPINGS_SHIPPINGCOST_TO_PRICE_CANNOT_BE_ADDED:
      "Au prix est #{{unlimited}} et les nouvelles données ne peuvent pas être ajoutées",
    SHIPPINGS_SHIPPINGCOST_TO_LBS_CANNOT_BE_ADDED:
      "A kg est #{{unlimited}} et les nouvelles données ne peuvent pas être ajoutées",
    SHIPPINGS_SHIPPINGCOST_TO_COUNT_CANNOT_BE_ADDED:
      "A nombre est #{{unlimited}} et de nouvelles données ne peuvent être ajoutées",
    SHIPPINGS_SHIPPINGCOST_FORMULA_save_successfully:
      "Formule(s) enregistrée(s) avec succès",
    SHIPPINGS_SHIPPINGCOST_DATA_MUST_NOT_BE_EMPTY:
      "Les données ne doivent pas être vides",
    SHIPPINGS_SHIPPINGCOST_TO_PRICE_DATA_FORMAT_ERROR:
      "Erreur de format de données Au prix",
    SHIPPINGS_SHIPPINGCOST_TO_LBS_DATA_FORMAT_ERROR:
      "Erreur de format de données A kg",
    SHIPPINGS_SHIPPINGCOST_TO_COUNT_DATA_FORMAT_ERROR:
      "Erreur de format des données A nombre",
    SHIPPINGS_SHIPPINGCOST_PLEASE_EDIT_UNDER_THE_CORRESPONDING_TYPE:
      "Veuillez éditer sous le type correspondant",
    SHIPPINGS_SHIPPINGCOST_NUMBERS_CAN_NOT_BE_NEGATIVE:
      "les chiffres ne peuvent pas être négatifs",
    CHECKOUT_PAGE_MY_CART: "Mon panier",
    CHECKOUT_PAGE_SHIPPING_ADDRESS: "Adresse de livraison",
    CHECKOUT_PAGE_SAVE: "Enregistrer",
    CHECKOUT_PAGE_CHANGE: "Modifier",
    CHECKOUT_FIELD_NAME: "Nom",
    CHECKOUT_FIELD_ADDRESS: "Adresse",
    CHECKOUT_FIELD_APT_SUITE_ETC: "Appartement, etc. (facultatif)",
    CHECKOUT_FIELD_CITY: "Ville",
    CHECKOUT_FIELD_ZIP: "Code postal",
    CHECKOUT_FIELD_PROVINCE: "Province",
    CHECKOUT_FIELD_STATE: "Département",
    CHECKOUT_IS_BILLING_ADDRESS_DIFFERENT:
      "L'adresse de facturation est-elle différente ?",
    CHECKOUT_ITEM: "article",
    CHECKOUT_ITEMS: "articles",
    CHECKOUT_PLEASE_FILL_OUT_NAME_FOR_CARD:
      "Veuillez indiquer le nom de la carte",
    CHECKOUT_TEXT_CHECKOUT: "Finaliser la commande",
    CHECKOUT_ENTER_CREDIT_CARD: "Entrer la carte de crédit",
    CHECKOUT_FIRST: "Premier",
    CHECKOUT_LAST: "Dernier",
    CHECKOUT_SAVE_SAVE_TO_MY_ACCOUNT: "Enregistrer la carte sur mon compte",
    CHECKOUT_BY_CLICKING_CONFIRM_MESSAGE:
      "En cliquant sur Confirmer, vous acceptez la <span>Politique de confidentialité</span> et les <span>Conditions d'utilisation</span> de WeR1",
    CHECKOUT_CONFIRM: "Confirmer",
    CHECKOUT_CARD_NUMBER: "Numéro de la carte",
    CHECKOUT_CARD_MM_YY: "MM/YY",
    CHECKOUT_CARD_CVC: "CVV",
    CHECKOUT_BILLING_ADDRESS: "Adresse de facturation",
    CHECKOUT_SAVE_ADDRESS: "Sauvegarder l'adresse",
    CHECKOUT_SAVE_SUCCESS: "Enregistré avec succès !",
    CHECKOUT_SAVE_FAILED:
      "Veuillez remplir le formulaire ci-dessous. Tous les champs sont obligatoires",
    SHARING_PRO_YOU_CAN_SHARE: "Produits que vous pouvez partager",
    SHARING_UWTTEE:
      "Utilisez Waves Tech pour gagner de l'argent de façon exponentielle",
    SHARING_UWTTEE_DESC:
      "L'outil pour exploiter votre véritable potentiel pour gagner en ligne et maximiser votre véritable influence. Prenez un lien ci-dessous pour mettre la technologie Kwik Waves à l'épreuve et être payé pour votre véritable influence.",
    SHARING_CLOSE: "Fermer",
    SHARING_FIVE_TIMES: "Vous ne verrez ceci que 5 fois de plus",
    SHARING_SHARE_FULL_CAMP: "Partager la campagne complète",
    SHARING_SINGLE_PRO: "Partage d'un seul produit",
    SHARING_MOST_SHARED: "Lien le plus partagé",
    ALL_PRO_POLICIES: "Politique",
    SS_THANK_YOU: "Remerciements",
    SS_SHARE_TIPS:
      "Vous avez aimé votre achat ? Super ! Pourquoi ne pas être récompensé pour partager ce produit avec un ami ?",
    SS_SHARE_TIPS_DESC:
      "Créez un compte et commencez à partager vos KwikLinks ! Votre lien permet de suivre les achats effectués par vos amis et votre famille, et les commissions de parrainage sont déposées directement sur votre compte Kwik.",
    SS_CUSTOMER_INFO: "Informations sur le client",
    SS_ADDRESS_INFO: "Informations sur l'adresse",
    SS_CHECK_YOUR_EARNING: "Vérifiez vos gains !",
    SS_WHMIETSYA: "Nous avons rendu facile la création de votre compte !",
    SS_RETURN_HOME: "Retour à l'accueil",
    SS_CREATE_HOME: "Créer un compte",
    SS_NEWAGE_PV: "NewAge PV",
    SS_FOOTER_HEAR_YOU: "Nous aimerions avoir de vos nouvelles !",
    SS_FOOTER_EMAIL: "support@wer1.com",
    SS_FOOTER_PPTOU: "Politique de confidentialité | Conditions d'utilisation",
    SS_FOOTER_COPY_RESERVED: "Copyright. ©2023 Tous droits réservés",
    SS_FOOTER_HOME: "Accueil",
    SS_FOOTER_HOW_IT_WORKS: "Comment ça marche",
    SS_FOOTER_FOR_BRANDS: "Pour les marques",
    SS_FOOTER_WHAT_NEW: "Nouveautés",
    SS_FOOTER_HELP_SUPPORT: "Aide et assistance",
    SS_FOOTER_PRIVACY_POLICY: "Politique de confidentialité",
    SS_TERMS_OF_USE: "Conditions d'utilisation",
    SS_FOOTER_SUB_FOR_UPDATES: "S'abonner aux mises à jour",
    SS_FOOTER_FOLLOW_US: "SUIVEZ-NOUS",
    SS_SUCESS: "Partage réussi",
    SS_REGISTER_YSSYP:
      "Vous avez partagé votre produit avec succès. Il est temps de créer un compte pour gérer vos gains !",
    SS_REGISTER_BSUFAK:
      "En créant un compte Kwik, j'accepte toutes les Conditions d'utilisation énoncées.",
    SS_REGISTER_YAAD: "Vous avez presque terminé !",
    SS_REGISTER_WHSAVCT:
      "Nous avons envoyé un code de vérification à l'adresse e-mail que vous avez utilisée lors du processus de commande. Si vous avez besoin d'un autre code, veuillez cliquer sur \"Renvoyer\".",
    LEGAL_INFO: "Informations légales",
    LEGAL_WELCOME_TO_KWIK: "Bienvenue chez WeR1 !",
    LEGAL_TC: "Conditions d'utilisation",
    HEADER_MENU_SHARING: "Partager",
    HEADER_MENU_BUY: "Acheter",
    HEADER_MENU_SHOPPING: "Acheter",
    HEADER_MENU_HELP: "Aide",
    HEADER_MENU_ACCOUNT_SETTING: "Paramètres du compte",
    HEADER_LAYER_ACCOUNT: "COMPTE",
    HEADER_LAYER_EDIT_ACCOUNT: "Modifier le compte",
    HEADER_LAYER_LOGOUT: "Se déconnecter",
    HEADER_LAYER_HELP_CONTACT: "Aide/Contact",
    HEADER_LAYER_HELP_LEGAL: "Mentions légales",
    HEADER_LAYER_HELP_LANGUAGE: "Langue",
    HEADER_LAYER_HELP_SELECT_YOUR_GEOGRAPHICAL_REGION:
      "Sélectionnez votre région géographique",
    HEADER_LAYER_HELP_SELECT_YOUR_PREFERRED_LANGUAGE:
      "Sélectionnez votre langue de préférence",
    SETTING_HEADER_ACCOUNT: "Compte",
    SETTING_HEADER_HELP_CONTACT: "Aide Contact",
    SETTING_HEADER_LEGAL: "Mentions légales",
    SETTING_HEADER_SETTINGS: "Paramètres",
    SETTING_ACCOUNT_CHANGE_IMAGE: "Changer d'image",
    SETTING_ACCOUNT_FIRST_NAME: "Prénom",
    SETTING_ACCOUNT_FIRST_NAME_IS_REQUIRED: "Le prénom est obligatoire",
    SETTING_ACCOUNT_LAST_NAME: "Nom de famille",
    SETTING_ACCOUNT_LAST_NAME_IS_REQUIRED: "Le nom de famille est obligatoire",
    SETTING_ACCOUNT_USER_NAME: "Nom d'utilisateur",
    SETTING_ACCOUNT_USER_NAME_IS_REQUIRED:
      "Le nom d'utilisateur est obligatoire",
    SETTING_ACCOUNT_PROFILE_CONTACT_INFO: "Coordonnées du profil",
    SETTING_ACCOUNT_PHONE_NUMBER: "Numéro de téléphone",
    SETTING_ACCOUNT_PHONE_NUMBER_IS_REQUIRED:
      "Le numéro de téléphone est obligatoire",
    SETTING_ACCOUNT_EMAIL: "Adresse email",
    SETTING_ACCOUNT_EMAIL_IS_REQUIRED: "L'adresse email est obligatoire",
    SETTING_ACCOUNT_PLEASE_NOTE_MESSAGE:
      "Remarque : c'est ainsi que les intenautes pourront vous contacter à partir de votre page de profil. Mettez-les à jour afin qu'ils sachent où vous joindre.",
    SETTING_ACCOUNT_YOUR_LOGIN_EMAIL_MESSAGE:
      "Votre adresse email de connexion et le numéro de téléphone de votre compte resteront les mêmes.",
    SETTING_ACCOUNT_SECURITY: "Sécurité",
    SETTING_ACCOUNT_PASSWORD: "Mot de passe",
    SETTING_ACCOUNT_DISCARD: "Jeter",
    SETTING_ACCOUNT_CHANGE_PASSWORD: "Changer le mot de passe",
    SETTING_CONTACT_HELP_CONTACT: "Aide et contact",
    SETTING_CONTACT_CONTACT_US_AT: "Contactez-nous ici",
    SETTING_CONTACT_ADDRESS: "Adresse",
    SETTING_CONTACT_EMAIL: "Adresse email",
    SETTING_CONTACT_PHONE: "Téléphone",
    SETTING_CONTACT_WHAT_TYPE_OF_PROBLEM: "Quel type de problème ?",
    SETTING_CONTACT_PROBLEM_IS_REQUIRED: "Le problème est obligatoire",
    SETTING_CONTACT_THIS_FIELD_IS_REQUIRED: "Ce champ est obligatoire",
    SETTING_CONTACT_PLEASE_GIVE_US_DETAILS_MESSAGE:
      "Veuillez nous donner des détails sur le problème que vous signalez. Votre nom, votre adresse électronique et votre numéro de commande, le cas échéant.",
    SETTING_CONTACT_DETAIL_IS_REQUIRED: "Ce champ est obligatoire",
    SETTING_CONTACT_ATTACH_ANY_IMAGES_MESSAGE:
      "Joignez des images ou des captures d'écran",
    SETTING_CONTACT_DRAG_AND_DROP_MESSAGE:
      "Faites glisser et déposez un fichier vidéo vers les actifs, ou parcourez-le.",
    SETTING_CONTACT_SUBMIT: "Envoyer",
    SORRY_YOU_CAN_T_SHARE_PRODUCT_MESSAGE:
      "Désolés, vous ne pouvez pas partager le produit #{{names}}. Veuillez acheter ce produit maintenant, ou demander à être éligible.",
    USER_REGISTER_INVLID_INPUT_CHARACTERS:
      "    Caractères d'entrée non valides",
    BACK_TO_ORDERS: "Retour aux commandes",
    ORDER_AGAIN: "Commander à nouveau",
    DOWNLOAD_INVOICE: "Download Invoice",
    REPORT_A_PROBLEM: "Report a Problem",
    CONTACT_BRAND: "Contact Brand",
    TERMS_COND: "Terms & Conditions",
    FINANCE: "Finance",
    SETTINGS: "Settings",
    POST_LIVE_SUCCESS: "Congrats! Your Post is live",
    POST_LIVE_DESC:
      "You can share this post with the other to make engagement to this post",
    SHARE_POST: "Share Post",
    VIEW_POST: "View Post",
    BACK_PROFILE: "Back To Profile",
    FOLLOW: "Follow",
    REVIEW_PRODUCT: "Review this Product",
    HOW_LIKE_PRODUCT: "How did you like this product?",
    SAVE_DETAILS: "Save Details",
    PHONE_UNIQUE_ERROR:
      "This phone number is already associated with a Kwik account. Please enter in a new phone number",
    ADD_ACCOUNT_PHONE: "add account phone",
    CASH_NOT_AVAILABLE: "You cannot cash out more than your available balance",
    SELECT_BANK_CARD: "Please select a bank card!",
    INPUT_AMOUNT: "Please input the amount!",
    SIGN_HERE: "Sign in here",
    ALREADY_HAVE_ACCOUNT: "Already Have An Account",
    CHECKOUT_PAYMENT: "    Paiement",
    ADD_PRODUCT_RETAIL: "    Prix de détail",
    ADD_PRODUCT_WHOLESALE: "    Prix de gros",
    ADD_PRODUCT_PLEASE_INPUT_YOUR_WHOLESALE:
      "    Veuillez saisir votre prix de gros",
    ADD_PRODUCT_RETAIL_SHOULD_NOT_MESSAGE:
      "    Le prix de gros doit être inférieur au prix de détail",
    ADD_PRODUCT_PROMOTIONAL_INSTANT_KWIK_CASH_ACCRUAL:
      "    Accumulation promotionnelle instantanée de KwikCash",
    ADD_PRODUCT_OF_RETAIL: "    du prix de détail",
    ADD_PRODUCT_BRAND_PAYOUT:
      "    Rémunération de la marque (prix de gros ajusté)",
    ADD_PRODUCT_KWIK_REVENUE: "    Revenu Kwik",
    ADD_PRODUCT_OF_DELTA: "    de Delta",
    ADD_PRODUCT_ADMINISTRATION_FEE: "    Frais d'administration",
    ADD_PRODUCT_REFERRAL_FEE: "    Commission de recommandation",
    ADD_PRODUCT_INSTANT_KWIK_CASH_ACCRUAL:
      "    Accumulation instantanée de KwikCash",
    ADD_PRODUCT_COMMISSION_ALLOCATION: "    Allocation de la commission",
    ADD_PRODUCT_TRUE_COMMISSION_ALLOCATION:
      "    Allocation de commission réelle",
    ADD_PRODUCT_LEVEL_WAVE_OF_COMMISSION: "    {{level}} Vague de Commission",
    VENDOR_SETTINGS_BRAND_ID: "    ID de la marque",
    VENDOR_SETTINGS_KWIK_REVENUE: "    Revenu Kwik(%)",
    VENDOR_SETTINGS_ADMIN_FEE: "    Frais d'administration (%)",
    VENDOR_SETTINGS_RETAIL_MULTIPLLER: "    Multiplicateur de vente au détail",
    VENDOR_SETTINGS_FEE_MULTIPLLER: "    Multiplicateur de frais",
    VENDOR_SETTINGS_REFERRAL_FEE: "    Commission de recommandation (%)",
    VENDOR_SETTINGS_IKCA: "    Accumulation instantanée de KwikCash(%)",
    VENDOR_SETTINGS_REFERRAL_EMAIL: "    Email du parrain",
    VENDOR_SETTINGS_TP: "    Promotion temporaire(%)",
    VENDOR_SETTINGS_NEWAGE_CAMPAIGN: "    Engagement de la marque NewAge",
    VENDOR_SETTINGS_FULL_BY_NEWAGE: "    Rempli par NewAge",
    VENDOR_SETTINGS_CTPV:
      "    Commission en pourcentage de la valeur du PV (%)",
    VENDOR_SETTINGS_DPP: "    Dollar par PV",
    PRODUCTS_DETAIL_VENFOR_PAYOUT: "    Paiement par le vendeur",
    PRODUCTS_DETAIL_PAYOUT_REMITTENCE: "    Versement du paiement",
    PRODUCTS_DETAIL_CASHBACK_STRUCTRUE: "    Structure du cashback",
    PRODUCTS_DETAIL_CASHBACK: "    Cashback",
    PRODUCTS_DETAIL_PROMOTIONAL_CASHBACK: "    Cashback promotionnel",
    PRODUCTS_DETAIL_WAVE_COMM_STRUCTURE:
      "    Structure de commission des Vagues",
    PRODUCTS_DETAIL_WAVE_COMM_STRUCTURE_DESC:
      "    Déterminé par le prix de détail - prix de vente total. Ajustez-les pour voir les changements dans la structure des Vagues",
    PRODUCTS_DETAIL_TOTAL_WAVE_FUNDING: "    Financement total des Vagues",
    PRODUCTS_DETAIL_1ST_OF_RETAIL: "    1re vague en % du prix de détail",
    PRODUCTS_DETAIL_TEMPORARY_PROMOTIONS: "    Promotions temporaires",
    PRODUCTS_DETAIL_OPTIONAL: "    Optionnel",
    PRODUCTS_DETAIL_TPR: "    Temporaire - Remise des paiements",
    PRODUCTS_DETAIL_SALES_CHANNEL: "    Canal de vente",
    PRODUCTS_DETAIL_SALES_CHANNEL_DESC:
      "    Veuillez noter que ces canaux supplémentaires sont facultatifs. Si vous optez pour l'un d'entre eux, cela peut avoir un impact sur les différents montants des vagues.",
    PRODUCTS_DETAIL_DIRECT_DISTRIBUTE: "    Distributeur direct",
    VENDOR_SETTINGS_WRONG_TYPE: "    Veuillez entrer le type de numéro",
    PRODUCTS_DETAIL_TAX_VAT_DUTY: "    Taxes/TVA/Droits",
    PRODUCTS_DETAIL_REQUIRE_EU: "    - Obligatoire pour les pays de l'UE",
    PRODUCTS_DETAIL_REQUIRE_AUS: "    - Requis pour l'Australie",
    PRODUCTS_DETAIL_REQUIRE_CAN:
      "    - Requis pour le commerce électronique transfrontalier vers le Canada",
    SHARE_LINK_PRICE_VAT: "    TVA",
    LEGAL_CONTENT:
      "Bienvenue sur Kwik !  \nKwik est un marché unique où vous pouvez vendre, acheter, partager et gagner au moyen de votre influence en ligne. Nous souhaitons que tous ceux qui visitent notre site et utilisent nos produits aient une expérience agréable. Nos produits incluent notre site Web, notre appli mobile, etc.\nCe document est un contrat juridiquement contraignant entre vous et Kwik. En utilisant les produits Kwik, vous acceptez les conditions générales suivantes qui constituent nos règles destinées à garantir que chacun ait la meilleure expérience possible. N’utilisez pas les produits Kwik si vous n’acceptez pas ces conditions.  \nAyez conscience que ces conditions générales ne créent pas de relation de partenariat, de coentreprise, d’emploi ou de franchise entre vous et Kwik.\nSi vous souhaitez vendre par l’intermédiaire de Kwik, vous devez aussi comprendre et accepter notre politique applicable aux vendeurs.\nVotre compte\nVous devrez créer un compte pour utiliser nos produits. Cliquez ici pour apprendre comment créer un compte auprès de Kwik. En créant un compte, vous acceptez les conditions suivantes :\nIl ne peut y avoir qu’un seul compte par personne. Vous avez la responsabilité de votre compte.\nVous devez avoir 18 ans ou plus. Les mineurs de plus de 13 ans peuvent utiliser Kwik uniquement via le compte d’un parent ou d’un tuteur légal. Toute utilisation des services par un mineur via votre compte relève de votre responsabilité. Les enfants de moins de 13 ans ne peuvent pas utiliser nos produits.\nLes informations que vous fournissez à votre sujet doivent être honnêtes et précises. Usurper l’identité d’une autre personne ou d’une entreprise via votre compte est interdit.\nVous êtes responsable de la sécurité de votre compte et de la protection de votre mot de passe.\nUtilisation des produits Kwik\nEn utilisant les produits Kwik, vous déclarez comprendre et accepter les conditions suivantes. En utilisant Kwik :\nN’accédez pas aux données des produits Kwik auxquelles vous n’êtes pas autorisé à accéder à l’aide de robots, de moteurs de balayage ou de toute méthode automatisée\nIl vous est interdit de recueillir, copier, utiliser, transférer ou vendre des données de produits Kwik qui ne vous sont pas fournies par Kwik\nVous ne devez pas placer un lien non autorisé sur un site externe\nVous ne devez pas charger ou aider à charger tout code malveillant ou virus dans les produits Kwik\nIl vous est interdit de violer les droits de tiers, y compris les droits de propriété intellectuelle\nVous ne devez pas perturber le fonctionnement normal des produits Kwik\nVous ne devez pas enfreindre les lois locales ou internationales, les marques commerciales ou les droits, y compris les droits de propriété intellectuelle \nVous devez respecter notre politique en matière de marques commerciales\nVous devez payer tous les frais dus à Kwik\nContenu\nEn utilisant Kwik, vous aurez diverses possibilités de créer du contenu. Le contenu que vous produisez inclut (sans s’y limiter) des évaluations, des commentaires, des photos, des photos de profil, des descriptions sur votre profil et des messages aux vendeurs. Vous êtes responsable du contenu que vous publiez ou chargez sur votre compte.\nPour assurer une expérience agréable pour tous les membres Kwik, il existe certains types de contenu dont nous ne souhaitons pas la publication sur les produits Kwik. En utilisant nos produits, vous vous engagez à ne pas produire de contenu haineux, abusif, menaçant, vulgaire, obscène, faux, trompeur ou mensonger de quelque manière que ce soit. \nKwik s’engage à protéger les droits de propriété intellectuelle. Si vous chargez ou publiez un contenu qui enfreint la propriété intellectuelle de tiers, nous prendrons les mesures appropriées. Cela peut inclure la désactivation temporaire de votre compte ou sa résiliation si vous utilisez à plusieurs reprises ou si vous enfreignez la propriété intellectuelle de tiers. Nous vous informerons de tels changements le cas échéant. Contactez Kwik si un contenu que vous possédez ou dont vous détenez les droits a été publié sans votre autorisation.\nSi vous êtes vendeur, reportez-vous à notre politique applicable aux vendeurs pour en savoir plus sur nos normes.\nVotre vie privée\nNous nous engageons à protéger votre vie privée et vos informations personnelles. Nous décrivons à la suite les informations personnelles recueillies par Kwik et la façon dont elles sont utilisées. N’utilisez pas les produits Kwik si vous ne voulez pas que Kwik utilise vos informations de l’une des manières décrites ci-dessous.\nKwik peut obtenir des informations que vous fournissez sur une base volontaire. Pour utiliser les produits Kwik et créer un compte, vous devez fournir une adresse e-mail valide et un nom qui seront associés à votre compte. Vous avez la possibilité de fournir d’autres informations via votre compte, telles qu’une date d’anniversaire, une biographie, un lieu ou votre sexe. Vous pouvez aussi laisser des évaluations sur les produits ainsi que d’autres commentaires. Ces informations seront disponibles pour les autres visiteurs et membres de Kwik.\nSi vous gagnez des distributions de vague (ou du Kwik Cash), vous devez fournir des données financières supplémentaires (par exemple, les numéros de carte bancaire et de compte, les détails de la transaction et la méthode de paiement). Si vous avez l’intention de vendre via Kwik, reportez-vous à notre politique applicable aux vendeurs pour connaître les informations supplémentaires qui doivent être fournies à Kwik afin de vérifier votre identité et que vous puissiez bénéficier de vos ventes.\nSi vous publiez un contenu via les produits Kwik, vous accordez à Kwik une licence permettant de l’utiliser. Nous ne revendiquons jamais la propriété d’un contenu. Nous utilisons et partageons le contenu publié par les vendeurs pour promouvoir leurs produits auprès d’autres vendeurs et acheteurs sur la base de leurs publications, des recherches et de l’utilisation des produits Kwik. Cette autorisation permet également à Kwik d’apporter certains ajustements au contenu, tels que l’amélioration ou le redimensionnement d’une photo ou la traduction du contenu dans une langue différente selon les besoins.\nKwik collecte aussi de façon automatique des informations lorsque vous utilisez nos produits, y compris notre site et notre appli mobile. Cela peut inclure votre adresse IP, l’identifiant unique de votre appareil ou la version de l’application mobile que vous utilisez. Ces informations peuvent nous aider à prévenir les actes frauduleux commis par les utilisateurs. Kwik recueillera également automatiquement des données sur votre utilisation du site, telles que les pages que vous visitez et la façon dont vous interagissez avec celles-ci (comme le fait de cliquer sur un lien ou la durée de consultation d’une page). Cela nous aide à personnaliser votre expérience et facilite la diffusion publicitaire en fonction de vos centres d’intérêt.\nKwik et les vendeurs collectent des informations personnelles sur les acheteurs, et sont, à ce titre, des responsables du traitement de ces données. Lorsque vous achetez un article via Kwik, vous fournissez également des informations aux vendeurs, ce qui peut inclure votre nom, votre adresse résidentielle, votre adresse de facturation et vos informations de paiement. Les vendeurs doivent respecter toutes les normes afin de protéger la vie privée des acheteurs comme indiqué dans notre politique applicable aux vendeurs. Au moment du paiement d’une commande, nous pouvons stocker les informations de votre carte bancaire, votre adresse de facturation et tout autre renseignement pour traiter votre transaction, ou à des fins de facturation et de paiement. Les membres situés dans certains pays ont la possibilité d’autoriser Kwik à se souvenir de leurs informations pour faciliter leurs futurs achats.\nVous pouvez fournir d’autres informations que nous obtenons lorsque vous contactez le service à la clientèle. \nGagner du Kwik Cash\nLes influenceurs peuvent gagner du Kwik Cash lorsqu’ils achètent un produit, en partageant un lien unique vers ce dernier sur les médias sociaux, et lorsque quelqu’un clique sur ce lien pour se rendre sur la page du produit et l’acheter. L’influenceur DOIT acheter le produit et la vente doit être réalisée en utilisant le lien de l’influenceur pour que ce dernier gagne du Kwik Cash. Comme indiqué ci-dessus, vous devez soumettre des renseignements supplémentaires, y compris des informations financières, pour recevoir votre Kwik Cash.\nAux États-Unis, où Kwik opère, les influenceurs doivent se conformer aux dispositions relatives à la divulgation de liens importants (Disclosure of Material Connection) de la FTC (Federal Trade Commision) [lien]. Ceci est requis lorsqu’un lien important (comme un paiement, un produit ou service gratuit, ou un parrainage) aurait une incidence sur la crédibilité de la recommandation de l’influenceur (par exemple, la recommandation est positive uniquement en raison des avantages tirés par l’influenceur) ou lorsque le public n’attendrait pas un tel lien parce qu’il n’y a pas de relation évidente avec la marque en question.\nPour gagner du Kwik Cash, les influenceurs doivent respecter les règles suivantes :\nL’influenceur doit clairement indiquer s’il existe un lien important avec les produits, les biens ou les services d’un vendeur. Voici quelques exemples de la façon dont vous pouvez le divulguer :\nDivulgation : en cliquant sur ce lien et en achetant le [produit de la marque] sur Kwik, je profite d’un avantage en gagnant du Kwik Cash. \nDes hashtags clairement visibles tels que #publicité, #parrainé, #pub[marque] ou #pub.\nLa divulgation doit apparaître dans la publication de l’influenceur sur le produit et être clairement visible.\nL’influenceur doit faire preuve d’honnêteté concernant le produit et s’abstenir de publier un contenu trompeur.\nL’influenceur s’engage à ne pas publier d’affirmations trompeuses sur le produit, y compris des mensonges, des témoignages fallacieux (par exemple l’effet d’un produit qui ne s’appliquerait pas à tout le monde comme « cette crème pour le visage m’a fait paraître cinq ans plus jeune »), ou des affirmations infondées (l’influenceur n’a pas une expérience pertinente du produit l’autorisant à le recommander).\nSi vous résidez en dehors des États-Unis, des lois similaires sont susceptibles de s’appliquer. Les personnes qui résident au Canada doivent se conformer à la loi sur la concurrence [lien]. Le non-respect de cette réglementation expose l’influenceur à des pénalités. Si vous résidez au Royaume-Uni, prenez connaissance des réglementations applicables aux influenceurs sur les médias sociaux publiées par l’Advertising Standards Authority (ASA), le Committee of Advertising Practice (CAP) et la Competition and Markets Authority (CMA) [liens]. Il vous incombe de comprendre les lois de votre pays de résidence et d’utiliser votre influence sur les médias sociaux en conséquence.\nPolitique d’exclusion d’un plan 401(k)\nLorsque vous gagnez du Kwik Cash, vous comprenez que Kwik ne vous offre pas et n’est pas tenue de vous offrir un plan 401(k) puisque vous n’êtes pas employé(e) par Kwik.\nPolitique applicable aux litiges\nPolitique applicable aux dossiers concernant un litige \nSi vous rencontrez un problème avec un produit, nous vous demandons de contacter le vendeur directement pour le résoudre. Si le vendeur ne répond pas ou ne résout pas le problème, vous pouvez ouvrir un dossier auprès de Kwik aux fins de résolution du litige. \nUn dossier peut être ouvert si l’article reçu n’est pas comme décrit ou représenté dans la boutique du vendeur, ou s’il n’est pas livré en raison des actions du vendeur. L’acheteur doit fournir une photo de l’article n’étant pas comme décrit ou représenté dans la boutique du vendeur. Exemples : un article qui est \nfabriqué dans un matériau ou avec un motif différent de celui qui a été décrit\nd’une taille, d’une couleur, d’une version ou d’un modèle différent\ndans un état différent de celui qui a été décrit (c’est-à-dire, s’il est décrit comme nouveau, mais qu’il a déjà été utilisé)\nfourni dans une quantité erronée\nendommagé \ndont des pièces ou des parties manquent\nceci s’applique également à des services promis, mais non exécutés\nLe vendeur doit expédier un article acheté dans un délai raisonnable ou respecter une date de livraison promise. Cependant, un dossier ne peut être ouvert si l’article est endommagé, non livré ou livré en retard en raison d’un service d’expédition tiers, puisque dans un tel cas, ni le vendeur, ni Kwik n’ont commis une faute. \nLes dossiers seront considérés comme résolus si\nL’acheteur obtient un remboursement.\nL’acheteur ferme le dossier.\nSi le dossier a été ouvert en raison d’une absence de livraison et que le vendeur fournit une preuve que l’article a été expédié en temps opportun à l’adresse de l’acheteur.\nConsultez notre politique applicable aux vendeurs pour en savoir plus sur les responsabilités du vendeur.\nLitiges avec des tiers\nLorsqu’un problème se produit concernant un produit ou une interaction avec un vendeur ou un autre membre Kwik, suivez les étapes ci-dessus énumérées dans notre politique applicable aux dossiers concernant un litige. Nous ferons tout notre possible pour vous aider à résoudre tout problème en ce qui concerne nos politiques. Nous ne sommes cependant pas tenus de résoudre les litiges que vous ayez avec d’autres membres Kwik ou un tiers. Vous vous engagez à décharger Kwik de toute responsabilité en cas de réclamation, préjudice ou demande découlant de litiges avec d’autres membres ou parties. \nLitiges avec Kwik\nEn cas de litige nous opposant, que vous soyez vendeur ou acheteur, veuillez d’abord nous contacter et nous ferons de notre mieux pour résoudre le problème. Si le litige ne peut être résolu avec notre service à la clientèle, veuillez vous reporter à nos politiques ci-dessous pour savoir comment procéder.\nDroit applicable\nLes présentes conditions générales sont régies par les lois des États-Unis. Si vous résidez en dehors des États-Unis, vous pouvez être protégé(e) par des lois contraignantes de protection des consommateurs selon votre juridiction.\nSi vous rencontrez un problème nous impliquant, veuillez nous contacter et nous nous efforcerons de le résoudre. Cependant, si le problème ne peut pas être résolu, les règles suivantes régiront tout litige juridique concernant Kwik et ses produits.\nArbitrage\nEn utilisant nos services, vous acceptez de résoudre tous les litiges vous opposant à Kwik au moyen d’un arbitrage individuel contraignant. Cela signifie que les litiges sont tranchés par un arbitre, et non par un juge ou un jury. Vous renoncez à tout droit de participer à des poursuites au moyen d’actions collectives, d’arbitrages collectifs ou d’actions représentatives. (Un arbitrage collectif ne sera disponible que si l’une ou l’autre des parties le demande en vertu des règles d’arbitrage collectif et si cela est approuvé par l’arbitre). L’arbitrage sera effectué par l’American Arbitration Association, ou « AAA », en vertu de ses règles d’arbitrage, ou « règles AAA », et la décision d’arbitrage sera exécutoire, sauf si la loi en dispose autrement. Chaque partie a le droit d’ester en justice devant un tribunal ayant compétence après la décision finale d’un arbitre ou d’un médiateur.\nEn remplacement d’un arbitrage, vous pouvez également recourir à un tribunal ayant compétence pour des litiges de faible ampleur si vous remplissez les conditions. Votre dossier doit également être tranché sur une base individuelle (et non collective ou représentative). La Federal Arbitration Act (« FAA ») et les lois applicables détermineront l’interprétation et l’application des présentes conditions générales. \nLes règles AAA détermineront les paiements pour toute affaire raisonnablement portée à la connaissance de l’AAA, y compris les frais administratifs et les honoraires de l’arbitre. Si le montant de votre réclamation ne dépasse pas 10 000 USD, Kwik paiera les frais raisonnables de dépôt, d’administration et d’arbitrage associés à l’arbitrage. Cependant, si l’arbitre détermine que votre réclamation ou la réparation visée est sans fondement ou à des fins inappropriées, Kwik ne sera pas responsable d’un tel paiement. \nLimitation de responsabilité\nEn utilisant les produits Kwik, vous acceptez de ne pas tenir Kwik responsable de ce qui suit : \nArticles achetés et utilisation des articles \nLorsque vous achetez un article via les produits Kwik, vous reconnaissez que vous ne l’achetez pas auprès de Kwik. Les articles publiés et vendus via les produits Kwik sont proposés par des vendeurs indépendants. Si vous rencontrez un problème avec un article, contactez le vendeur ou ouvrez un dossier auprès de Kwik comme décrit ci-dessus. \nKwik dégage toute responsabilité en ce qui concerne les conséquences de l’utilisation de l’article. Si votre utilisation, appropriée ou non, d’un article entraîne des blessures ou endommage l’article, vous vous engagez à dégager Kwik de toute responsabilité.  \nServices et sites Web tiers\nLe contenu des vendeurs et des membres Kwik peut inclure des liens vers des sites Web, des services, des pages de médias sociaux de tiers ou d’autres marchés en ligne. Vous comprenez que ceux-ci ne sont pas contrôlés ou influencés par Kwik. La plupart de ces sites Web et services auront leurs propres conditions générales que vous accepterez de respecter, et il est de votre responsabilité d’en être conscient. De même, vous accéderez aux produits Kwik en utilisant un appareil tel qu’un téléphone mobile. De tels appareils ne sont pas associés à Kwik.\nContenu et interactions avec les membres\nEn tant que membre Kwik, vous pouvez partager du contenu via votre profil, en laissant une évaluation ou en envoyant un message. Nous nous soucions de votre expérience, c’est pourquoi nous demandons à tous les membres Kwik de respecter nos normes. Cependant, un contenu publié par un membre ne reflète pas l’opinion de Kwik, et nous ne nous approprions aucun contenu publié. Kwik dégage toute responsabilité en ce qui concerne la légalité, une conformité exacte aux copyrights ou une conformité avec nos normes de tout contenu publié par les membres que vous consultez par l’intermédiaire de nos produits. Vous dégagez Kwik de toute responsabilité en ce qui concerne le contenu des membres.\n Kwik dégagera aussi toute responsabilité s’agissant de vos interactions avec d’autres personnes par le biais de Kwik. Bien que les membres puissent ouvrir des dossiers concernant des produits endommagés ou non livrés, et que Kwik résiliera un compte lorsque certaines règles sont enfreintes (voir ci-dessous), vous comprenez que nous ne filtrons pas les utilisateurs de nos produits. Vous dégagez Kwik de toute responsabilité en ce qui concerne vos interactions avec d’autres utilisateurs. Faites preuve de jugement et de prudence lorsque vous interagissez avec d’autres personnes via Kwik ou avec tout service. Par exemple, il n’est pas toujours recommandé d’accepter de rencontrer physiquement quelqu’un après un contact en ligne.\nIndemnisation \nDans les rares cas où Kwik ferait l’objet de poursuites en raison de votre action, de votre utilisation appropriée ou non de nos produits, de votre violation de ces conditions générales ou de droits de tiers, vous vous engagez à indemniser Kwik. Cela signifie que vous nous défendrez ou nous dégagerez de toute responsabilité (y compris nos employés, sociétés affiliées et filiales) contre s’agissant de toute réclamation ou poursuite en justice, y compris des frais juridiques raisonnables. \nNous nous réservons le droit de gérer notre défense juridique à notre discrétion. Cela inclut les cas où vous nous indemnisez, auquel cas vous acceptez de coopérer avec nous.\nModifications apportées aux conditions générales \nNous vous informerons de toute modification substantielle apportée à nos conditions générales 30 jours avant leur entrée en vigueur. En continuant d’utiliser les produits Kwik, vous acceptez d’être lié(e) par de telles mises à jour. Si vous n’acceptez pas une modification apportée à nos conditions générales, vous pouvez envoyer une notification écrite à Kwik ou résilier votre compte avant qu’elle ne prenne effet.\nLitiges portant sur les modifications\nComme pour tous les changements apportés à nos conditions générales, vous recevrez une notification et pourrez choisir de les accepter ou de les refuser en résiliant votre compte. Si vous refusez des conditions mises à jour et qu’un litige vous oppose à Kwik, vous acceptez que ce dernier soit tranché par voie d’arbitrage conformément à notre politique en matière de litiges, y compris tout changement apporté avant votre refus. Si nous apportons une modification à la politique applicable aux litiges après la date à laquelle vous avez accepté pour la dernière fois les conditions générales, ce qui inclut la poursuite de votre utilisation de nos produits après que vous ayez été informé(e) de changements, cette modification ne s’appliquera pas à toute réclamation faite dans le cadre d’une procédure judiciaire visant Kwik avant la date à laquelle les changements deviennent effectifs. Si vous résiliez votre compte puis le rouvrez, vous accepterez la version en vigueur des présentes conditions générales.\nRésiliation de votre compte\nLa résiliation de votre compte peut se produire à notre initiative ou à la vôtre. Vous pouvez résilier votre compte à tout moment via ses paramètres. Si vous résiliez votre compte, le contenu que vous avez créé et publié (par exemple, des commentaires, des évaluations ou des photos mises en ligne) restera visible sur les produits Kwik. Sachez que vous risquez de perdre d’autres informations associées à votre compte.\nNous pouvons suspendre ou résilier votre compte si nous avons des raisons de croire que vous avez enfreint les présentes conditions générales d’utilisation des produits Kwik. Si nous le faisons, sachez que vous ne disposerez d’aucun droit légal ou contractuel de continuer à utiliser nos produits. Par exemple, une fois votre compte résilié, vous ne pouvez plus acheter ou vendre via notre marché en ligne. À moins que vous n’ayez enfreint nos conditions à plusieurs reprises ou que nous ayons des motifs de ne pas le faire en raison de la législation ou de nos politiques, nous vous informerons de toute modification apportée à votre compte.\nKwik se réserve le droit d’interrompre, de suspendre ou de modifier ses produits ainsi que la façon dont vous interagissez avec eux. En utilisant nos produits, vous comprenez que Kwik n’est pas responsable des conséquences de toute modification ou interruption les affectant. \nLes présentes conditions générales resteront en vigueur après la résiliation de votre compte.\nAutres questions juridiques \nLes présentes conditions générales remplacent tout autre accord que vous pourriez avoir conclu avec Kwik. Si une partie des conditions n’est pas applicable, celle-ci sera limitée dans la mesure minimale nécessaire, et les conditions resteront pleinement en vigueur dans le cas contraire. Si nous n’appliquons pas immédiatement une partie quelconque des présentes conditions, vous reconnaissez que nous nous réservons le droit de l’appliquer ultérieurement ou d’appliquer une autre partie des conditions.\nQuestions concernant les conditions générales  \nSi vous avez des questions concernant les présentes conditions générales, veuillez contacter notre service à la clientèle : support@wer1.com.",
    SHARELINK_PRODUCT_DETAIL_NO_DATA:
      "Ce produit n'est pas disponible dans votre pays !",
    VENDOR_SHIPPING_COST_SHIPPING_METHODS: "Méthode de livraison",
    CHECKOUT_SAVE_SHIPPING_ADDRESS_MESSAGE:
      "Veuillez remplir le formulaire ci-dessous",
    SORRY_YOUR_PAYMENT_DID_NOT_GO_THROUGH:
      "Nous n'avons pas pu traiter votre paiement. Veuillez réessayer.",
    ORDER_HISTORY_ORDER_MORE: "Commander plus",
    ORDER_HISTORY_SHARE_PRODUCT: "Partager le produit",
    ORDER_HISTORY_EDIT_REVIEW: "Modifier un avis",
    ORDER_HISTORY_ADD_REVIEW: "Rédiger un commentaire",
    ORDER_HISTORY_SHIPPING_DETAIL: "Détails de livraison",
    ORDER_HISTORY_ARRIVAL_DATE: "Date d'arrivée",
    ORDER_HISTORY_TRACKING_NUMBER: "Numéro de suivi",
    ORDER_HISTORY_ORDER_INFO: "Informations sur la commande",
    ORDER_HISTORY_TOTAL_COST: "Coût total",
    ORDER_HISTORY_ORDER_DATE: "Date de la commande",
    ORDER_HISTORY_SHIP_DATE: "Date de livraison",
    ORDER_HISTORY_SHIP_LOCATION: "Lieu de livraison",
    CHECKOUT_PRE_VAT_SUBTOTAL: "Sous-total avant TVA",
    CHECKOUT_VAT_TOTAL: "Total TVA",
    CHECKOUT_PRE_VAT_SHIPPING: "TVA avant livraison",
    CHECKOUT_SHIPPING_VAT: "TVA Livraison",
    CHECKOUT_ORDER_TOTAL: "Total de la commande",
    CHECKOUT_ORDER_INFORMATION_ERROR_MESSAGE:
      "Erreur d'information sur la commande, veuillez contacter le service client",
    SHARING_MFSP: "Produits les plus fréquemment partagés",
    SHARING_KWIK: "Kwik",
    SHARING_ESS: "Explorez, achetez, partagez",
    SHARING_FYNCTEM: "Trouvez votre prochaine campagne pour gagner plus",
    ACCOUNT_PHONE_UNIQUE:
      "Ce numéro de téléphone est déjà associé à un compte Kwik. Veuillez saisir un nouveau numéro de téléphone",
    CHECKOUT_ADDRESS_INVALID_FORMAT: "Format invalide",
    VENDOR_INVENTORY_PLEASE_SELECT_WAREHOUSE:
      "Veuillez sélectionner l'entrepôt",
    VENDOR_INVENTORY_ADD_INVENTORY_FOR_SKU: "Ajouter l'inventaire pour SKU#",
    ORDER_HISTORY_VIEW_DETAILS: "Voir les détails",
    VENDOR_INVENTORY_EDIT_INVENTORY: "Editer l'inventaire",
    SHARING_NEW_TITLE: "Bienvenue chez WeR1",
    VENDOR_PRODUCT_PSTCAW: "Veuillez sélectionner le pays et l'entrepôt !",
    VENDOR_PRODUCT_PSDCAW:
      "Veuillez sélectionner un autre pays et un autre entrepôt !",
    VENDOR_INVENTORY_ENTER_A_POSITIVE_OR_NEGATIVE_MESSAGE:
      "Entrez un nombre positif ou négatif pour ajouter ou soustraire à la quantité allouée.",
    VENDOR_INVENTORY_INVALID_VALUE: "Valeur invalide ?",
    PRODUCT_DETAIL_UPPER_LIMIT_OF_THE_INVENTORY:
      "Limite supérieure de l'inventaire",
    PRODUCTS_COPY_BUTTON: "Copier",
    PRODUCT_DETAIL_BACK_TO_PRODUCT_LIST: "Retour à la liste des produits",
    NEW_PRODUCT_ID: "ID du nouveau produit",
    NEW_PRODUCT_NAME: "Nom du nouveau produit",
    SHARING_TOP_DESC1: "Acheter, partager, gagner sur Kwik !",
    SHARING_TOP_DESC2_1: "Remplissez le",
    SHARING_TOP_DESC2_2: "Guide de démarrage",
    SHARING_TOP_DESC2_3: "ci-dessous",
    SHARING_TOP_DESC3_1: "pour gagner",
    SHARING_TOP_DESC3_2: "5$ de KwikCash !",
    SHARING_CHECKBOX_1: "Créez un compte Kwik",
    SHARING_CHECKBOX_2: "Rejoignez une campagne",
    SHARING_CHECKBOX_3: "Partagez votre lien",
    SHARING_CHECKBOX_4: "Consultez votre KwikCash",
    SHARING_CHECKBOX_5: "Vérifiez vos vagues",
    SHARING_ALL_PRODUCT: "Partagez tous les produits",
    KWIKCASH_ADD_PAYPAL: "Ajouter PayPal",
    ERC__CLICKING_CONFIRM_MESSAGE:
      'J\'accepte les <a href="https://cms.kwik.com/Terms%26ConditionsWeR1.pdf" target=""_blank""><span>Terms</span></a> et <a href="https://cms.kwik.com/PrivacyPolicyWeR1.pdf.pdf" target=""_blank""><span>Politique de confidentialité de WeR1</span></a>',
    KWIKCASH_CONNECT_TO_PAYPAL: "Connectez-vous à Paypal",
    KWIKCASH_PLEASE_INPUT_THE_AMOUNT: "Veuillez saisir le montant !",
    ENTER_LOGIN_EMAIL: "Entrez votre email pour commencer ou connectez-vous !",
    I_FORGOT_PASSWORD: "J'ai oublié mon mot de passe",
    KWIKCASH_THE_ACCOUNT_NUMBER_SHOULD_BE_EMAIL_ADDRESS:
      "Le numéro de compte devrait être l'adresse email",
    REGISTER_WE_JUST_SEND_YOU_A_VERIFY_MESSAGE:
      "Nous venons de vous envoyer un code de vérification. Vérifiez vos dossiers spam et promotion.",
    REGISTER_RESEND_CODE: "Envoyer le code à nouveau",
    REGISTER_CREATE_ACCOUNT: "Créer un compte",
    REGISTER_DONT_RECEIVED: "Vous n'avez rien reçu ?",
    REGISTER_SIGN_IN: "Se connecter",
    REGISTER_ALREADY_A_MEMBER: "Déjà membre ?",
    YOUR_EMAIL: "Votre adresse e-mail",
    LET_FIND_LINK: "Trouvons votre lien !",
    ENTER_EMAIL_FIND_LINK:
      "Entrez votre adresse e-mail et nous pourrons voir si vous avez un lien !",
    ENTER_LOGIN_CRED: "Entrez vos informations d'identification pour continuer",
    SHARING_TOP_DESC2_NEW:
      "Pour vous aider à démarrer, nous avons créé une liste de contrôle de démarrage !",
    SHARING_TOP_DESC3_NEW: "Cliquez ICI pour en savoir plus sur Kwik.",
    SHARING_NO_LINK_TO_SHARE: "Pas de liens à partager ?",
    SHARING_ITEM_TEXT_1: "Explorez la Marketplace Kwik",
    SHARING_ITEM_TEXT_2: "Acheter un produit d'une marque que vous aimez",
    SHARING_ITEM_TEXT_3: "Partager un lien vers un produit",
    SHARING_ITEM_TEXT_4: "Gagner du KwikCash",
    YOU_MAY_ALSO_LIKE: "Vous pourriez aussi aimer",
    ADD_REVIEW: "Ajouter un avis",
    BE_FIRST_REVIEW: "Soyez le premier à donner votre avis",
    COMMENT: "Commenter",
    REFERRAL_MESSAGE: "Message de référence",
    VERIFIED_PURCHASER: "Acheteur vérifié",
    COMMENTS: "Commentaires",
    COPY_FROM_PROD: "Copier du produit",
    COPY_TO_PROD: "Copier vers le(s) produit(s)",
    KWIKCASH_PAYPAL_EMAIL_ADDRESS: "Adresse e-mail",
    SHARELINK_PRODUCT_DETAIL_CASHBACK_ON_PURCHASE: "Cashback sur l'achat",
    SHARE: "Partager",
    CASHBACK_ON_PURCHASE: "Cashback sur l'achat",
    EMAIL_NOT_REGISTERED: "Cette adresse e-mail n'est pas enregistrée",
    SEND_SUCCESS: "Envoyer avec succès",
    LOGIN_KIHTM: "WeR1 est là pour rendre",
    LOGIN_ERE: "les recommandations plus faciles au quotidien",
    PROCEED: "Continuer",
    TSIPBRATGPP:
      "Ce site est protégé par reCAPTCHA et les règles de confidentialité de Google",
    BRAND_NEW_TO_KWIK: "Tout nouveau sur WeR1",
    CLICK_HERE_TO_CREATE: "Cliquez ici pour créer",
    LOOKING_TO_FIND_YOUR_LINK: "À la recherche de votre lien",
    CLICK_HERE_TO_FIND_IT: "Cliquez ici pour le trouver",
    SHARE_INFO_LAYER_CREATE_A_SHARE_LINK: "Créer un lien de partage",
    SHARE_INFO_LAYER_GIVE_A_RATING: "Donner une note (facultatif)",
    SHARE_INFO_LAYER_ADD_A_MESSAGE: "Ajouter un message (facultatif)",
    SHARE_INFO_LAYER_250_WORDS_LEFT: "{{count}} mots restants",
    SHARE_INFO_LAYER_ADD_ADDITIONAL_MEDIA: "Ajouter un média supplémentaire",
    SHARE_INFO_LAYER_UPLOAD: "Télécharger",
    SHARE_INFO_LAYER_SHARE_YOUR_LINK: "Partager votre lien",
    SHARE_INFO_LAYER_COPY_LINK: "Copier le lien",
    SHARE_INFO_LAYER_THE_MAXIMUM_FILE_SIZE:
      "La taille maximale du fichier est de 80 Mo",
    SHARE_INFO_LAYER_THE_FILE_FORMAT_IS_INCORRECT:
      "Le format du fichier est incorrect",
    SHARE_INFO_LAYER_VERIFIED_PURCHASER: "Acheteur vérifié",
    SHARE_INFO_LAYER_SUPER_AMAZING_PRODUCT: "PRODUIT SUPER ÉTONNANT !",
    USER_HAS_GOT_PASSWORD: "L'utilisateur a déjà son mot de passe !",
    INVALID_EMAIL: "Adresse e-mail invalide",
    HEY_WE_MISS_YOU: "Hey {{name}}, tu nous as manqué !",
    LAST_REMEMBER_YOU: "La dernière fois que nous vous avons vu",
    SAVE_YOUR_INFO_TEXT:
      "Nous espérions que vous reviendriez, aussi nous avons décidé de sauvegarder vos informations.",
    PHONE_HAS_REGISTERED: "Le téléphone a été enregistré",
    IMPACT_OF_YOUR_RECOMMENDATIONS_1: "Voyez le véritable impact de vos",
    IMPACT_OF_YOUR_RECOMMENDATIONS_2: "Recommandations.",
    FULL_NAME_NOT_BE_EMPTY: "La case Nom complet ne doit pas rester vide",
    CODE_VERIFICATION: "Vérification du code",
    ENTER_4_DIGIT_TIPS:
      "Veuillez entrer le code à 4 chiffres qui vous a été envoyé à",
    CHECK_JUNK_EMAIL_FOLDER:
      "Si vous ne trouvez pas facilement un e-mail de KwikClick, veuillez vérifier votre dossier de courrier indésirable ou spam. Si vous utilisez Gmail, veuillez vérifier l'onglet Promotions.",
    PRODUCT_DETAIL_PAGE_CASHBACK_IS_THE_AMOUNT_MESSAGE:
      "Le Cashback est le montant que vous gagnerez instantanément lors de l'achat de ce produit. Il sera disponible après l'expiration de la période de retour.",
    LINK_HEADER_ALREADY_A_USER: "Vous êtes déjà un utilisateur ?",
    RESET_PASSWORD_PASS_RECOVERY: "Récupération du mot de passe",
    RESET_PASSWORD_ENTER_EMAIL_TIPS:
      "Entrez l'email que vous utilisez pour WeR1",
    RESET_PASSWORD_SEND_TITLE: "Réinitialiser votre mot de passe",
    RESET_PASSWORD_SEND_TIPS_1: "Nous avons envoyé les instructions à : ",
    RESET_PASSWORD_SEND_TIPS_2:
      "Si vous n'avez pas reçu l'e-mail, demandez à ce que l'on vous renvoie les instructions.",
    RESET_PASSWORD_SEND_BTN_BACK_SIGN_IN: "Retour à la connexion",
    RESET_PASSWORD_SEND_LINK_RESEND: "Renvoyer les instructions",
    RESET_PASSWORD_UPDATE_TIPS_SAME_PASS:
      "Le mot de passe ne correspond pas au mot de passe de confirmation",
    RESET_PASSWORD_UPDATE_TIPS_CONFIRM: "Confirmer le nouveau mot de passe",
    RESET_PASSWORD_UPDATE_SAVE_PASS: "Enregistrer le mot de passe",
    RESET_PASSWORD_SUCCESS_TIPS:
      "Votre mot de passe a été créé. Veuillez retourner à l'écran de connexion",
    RESET_PASSWORD_SUCCESS_LOGIN_ACCOUNT: "Se connecter à votre compte",
    RESET_PASSWORD_SUCCESS_BACK_HOME: "Retour à la page d'accueil",
    RESET_PASSWORD_REQUIRED_EMAIL: "L'adresse email est requise",
    RESET_PASSWORD_RESEND_SUCCESS: "Renvoyer la confirmation",
    RESET_PASSWORD_CHOOSE_PASSWORD: "Choisissez votre nouveau mot de passe",
    ALL_TIME: "Depuis toujours",
    LAST_DAY: "Derniers {{day}} Jours",
    MY_CAMPAIGNS: "Mes campagnes",
    SHOW_MORE: "Montrer plus",
    SHOW_LESS: "Montrer moins",
    OTHER_PRODUCTS: "Autres produits",
    CLICK_PRODUCT_SHOW: "Cliquez sur un produit pour afficher ses données !",
    SEARCH_PRODUCT: "Rechercher un produit",
    SHOWING_PAGE: "Afficher {{pagination}}",
    REFERRAL: "{{referral}} Références",
    PREVIOUS: "Précédent",
    NEXT: "Suivant",
    CASH: "Cash",
    LEARN_KWIK: "Apprendre Kwik",
    KWIK_TIPS: "Conseils Kwik",
    WANT_LEARN_ABOUT: "Vous voulez savoir quelles données Kwik fournit ?",
    TOTAL_REFERRAL: "Total des références générées",
    DIRECT_REFERRAL: "Références directes",
    WAVE_DEPTH: "Profondeur des vagues",
    RECENT_ADDITIONS: "Ajouts récents",
    TRANSACTIONS: "Vagues",
    TOP_SHARED_PRODUCT: "Top {{count}} des Produits partagés",
    VIEW_ALL: "Voir tout",
    TOP_COUNTRIES: "Top des pays",
    ANALYTICS: "Analytique",
    PEOPLE_REACHED: "Personnes atteintes",
    SHARES: "Actions",
    LINK_CLICKS: "Clics sur les liens",
    RECENT_SHARES: "Actions récentes",
    DATE: "Date",
    PLATFORM: "Plateforme",
    OPENED: "Opinions",
    CONVERTED: "Converti",
    SIGNED_UP: "Inscrit",
    CLAIMS: "Réclamations",
    ORDERED: "Ordonnée",
    WAVE_SOURCES: "Sources des Vagues",
    REFERRAL_SUCCESS_RATE: "Taux de réussite du parrainage",
    OPEN_RATE: "Taux d'ouverture",
    CONVERSION: "Conversion",
    IMPACT_RECOMMENDATIONS: "Recommandations les plus impactantes",
    REFFERED_BRANDS: "Marques recommandées",
    REFERRED_BRANDS_DESCRIPTION:
      "Ce sont les marques que vous avez recommandées à Kwik.",
    SEARCH_BRAND: "Rechercher une marque",
    SELECTED_CAMPAIGN: "Campagne sélectionnée",
    ACTIVE_CAMPAIGN: "Campagne active",
    SELECTED_CAMPAIGN_DESCRIPTION:
      "Vous visualisez les données de la Campagne “{{campaignName}}”",
    SELECT_SPECIFIC_CAMPAIGN:
      "Sélectionnez une campagne spécifique pour ne visualiser que les données la concernant",
    SEARCH_CAMPAIGN: "Rechercher une campagne",
    GENERAL_SALES_INFO:
      "Il s'agit du montant en dollars des ventes que vous avez générées à partir de vos recommandations.",
    KWIKCASH_INFO:
      "C'est le montant que vous avez gagné grâce à vos parrainages.",
    TOTAL_REFERRALS: "Total des parrainages",
    SALES_GENERATED: "Ventes générées",
    WAVE_NUMBER: "Vague {{number}}",
    MEMBERS: "Membres",
    MEMBERS_NUMBER: "Membres ({{number}})",
    SEARCH_MEMBER: "Recherche de membre",
    RECENT_REFERRALS: "Parrainages récents",
    ALL_REFERRALS: "Tous les parrainages",
    SHOPPING_PV: "VP",
    POLICY_POLICIES: "Politiques",
    POLICY_VTPTTBHUTK:
      "Voir les politiques que la marque a téléchargées sur Kwik",
    POLICY_SHIPPING_POLICY: "Politique d'expédition",
    POLICY_TAC: "Conditions Générales",
    POLICY_RP: "Politique de retour",
    POLICY_PP: "Politique de confidentialité",
    POLICY_NOT_SEEING:
      "Vous ne voyez pas ce que vous voulez ? Contactez directement la marque",
    DASHBOARD_PROFILE_STATUS: "Pour commencer",
    DASHBOARD_GET_5_CASHBACK:
      "Effectuez les 5 étapes pour gagner 5$ de cashback !",
    DASHBOARD_COMPLETE_STEPS_EXPERT:
      "Complétez ces étapes pour devenir un expert !",
    DASHBOARD_CREATE_ACCOUNT: "Créer un compte",
    DASHBOARD_ALREADY_CREATED: "Déjà créé",
    DASHBOARD_DONE: "Terminé !",
    DASHBOARD_FAPOCWAB: "Trouver un produit ou se connecter avec une marque",
    DASHBOARD_MAKE_A_REFER: "Faire un renvoi",
    DASHBOARD_SEE_ROLLIN: "Super ! Voir l'argent défiler",
    DASHBOARD_SRAPTAF: "Réussir à recommander un produit à un ami",
    DASHBOARD_SHOW_ME_MONEY: "Montrez-moi l'argent",
    DASHBOARD_SEE_YOUR_IMPACT: "Voir votre impact",
    DASHBOARD_CLAIM_REWARD: "Réclamer une récompense",
    DASHBOARD_UPLOAD_IMAGE: "Télécharger l'image",
    DASHBOARD_HEY: "Hey",
    DASHBOARD_WELCOME_TO_KWIK:
      "Bienvenue sur WeR1 ! Ceci est le tableau de bord. Ici, vous apprendrez tout ce que vous devez savoir sur WeR1 et comment commencer à partager et gagner de l'argent. De plus, il y a de l'argent gratuit dans la section “Pour commencer“ à droite !",
    DASHBOARD_WELCOME_TO_KWIK_MOBILE:
      "Bienvenue sur WeR1 ! Voici le tableau de bord. Ici, vous apprendrez tout ce que vous devez savoir sur WeR1 et comment commencer à partager et à gagner de l'argent. Il y a aussi de l'argent gratuit dans la section “Pour commencer“ en bas !",
    DASHBOARD_WELCOME_TO_KWIK2:
      "Bienvenue sur WeR1 ! Nous sommes ravis de votre récent achat ! Nous voulons vous aider à le partager avec vos proches d'une manière significative.",
    DASHBOARD_WELCOME_TO_KWIK3:
      "Les choses peuvent sembler un peu différentes ici. Si vous avez manqué la dernière mise à jour, cliquez ici pour voir toutes les nouvelles fonctionnalités ajoutées à WeR1 !",
    DASHBOARD_WELCOME_TO_KWIK4:
      "Bienvenue sur WeR1. C'est le moyen le plus facile et le plus valorisant pour recommander vos produits à des amis et des abonnés.",
    DASBOARD_LOOK_TO_THE_RIGHT: "Regardez à droite",
    DASBOARD_LOOK_TO_BELOW: "Regardez en bas",
    DASHBOARD_SALES_GENERATED: "Revenus générés",
    DASHBOARD_VIEW_ANALYTICS: "Voir les analytics",
    DASHBOARD_NOTIFICATION: "Avis",
    DASHBOARD_PURCHASED_FORM_YOUR_LINK: "Acheté depuis votre lien",
    MOST_RECENT: "Les plus récents",
    KWIK: "Kwik",
    KB_VERSION: "KB",
    KB_THANKYOU: "Merci !",
    KB_TITLE_01: "Nouveaux emails",
    KB_TITLE_02: "Mises à jour du KwikCash",
    KB_TITLE_03: "Partager les changements de page",
    KB_TITLE_04: "Petites améliorations",
    KB_TITLE_05: "C'est tout !",
    KB_TITLE_06: "Correction de bugs",
    WELCOME_KWIK:
      "Bienvenue sur 1.3.7 ! Il s'agit d'un changement important, car l'application vient de recevoir un autre écran entièrement refait. Consultez-le et découvrez les autres changements.",
    THANKYOU_KWIK:
      "Nous sommes très heureux de cette version et encore plus enthousiastes pour la suivante. Partagez-nous vos avis sur <span>hello@wer1.com</span>, nous lisons tous les commentaires et les considérons !",
    WELCOME_KWIK_01: "Checkez les nouveautés !",
    VERSION_DESC_01:
      "Il y a de nouveaux emails sur Kwik ! Ils correspondent  à notre style unique et sont beaucoup plus efficaces que les emails précédents.",
    VERSION_DESC_02:
      "L'argent gagné sur Kwik est essentiel ! Désormais le design le reflète.",
    VERSION_DESC_03:
      "Rendre le partage plus accessible et amusant est notre but à chaque version. Alors découvrez le nouveau design.",
    VERSION_DESC_04:
      "Il y a beaucoup de petits changements dans cette version, en voici quelques-uns.",
    VERSION_DESC_05:
      "Merci beaucoup d'avoir participé à la bêta de WeR1. Veuillez envoyer vos commentaires à <span>hello@wer1.com</span>. Nous voulons entendre vos suggestions. Profitez de la version 1.3.7.",
    VERSION_DESC_06:
      "Il y a beaucoup de nouvelles corrections de bugs dans la 1.3.6, consultez les notes de version pour en voir plus, ou regardez simplement dans Kwik. Tous les détails s'améliorent !",
    BASEHEADER_LINK_DASHBOARD: "Tableau de bord",
    NEW_SHARE_LINK_SAVE_FOR_LATER: "Sauvegarder pour plus tard",
    NEW_SHARE_LINK_CART_TEXT_WHAT_WANT_SAVED:
      "Vous voulez voir ce que vous avez sauvegardé ? ",
    NEW_SHARE_LINK_CART_TEXT_OR: " ou ",
    NEW_SHARE_LINK_CART_TEXT_CREATE_ACCOUNT: "Créer un compte",
    NEW_SHARE_LINK_CART_TEXT_SIGN_IN: "Se connecter",
    NEW_CHECKOUT_SELECT_SHIPPING_RATE:
      "Sélectionnez une méthode d'expédition par marque",
    NEW_CHECKOUT_TITLE_CART: "Panier :",
    DASHBOARD_WELCOME_BACK: "Bienvenue",
    DASHBOARD_MY_ORDERS: "Mes commandes",
    DASHBOARD_NO_ORDERS: "Aucune commande",
    DASHBOARD_MADE_ORDER_TIPS:
      "Il semble que vous n'ayez passé aucune commande auprès d'une marque par le biais de WeR1 !",
    DASHBOARD_RECENT_SHARE: "Partage récent",
    DASHBOARD_SHARE_OTHER_PRODUCTS: "Partager d'autres produits",
    DASHBOARD_SEE_MORE: "Voir plus",
    DASHBOARD_SHOW_LESS: "Voir moins",
    DASHBOARD_WELCOME: "Bienvenue",
    ALREADY_SHARED_FAVOURITE:
      "Vous partagez déjà vos produits préférés. Nous faisons en sorte qu'il soit facile pour vous de gagner les commissions que vous méritez.",
    SHOW_ME_HOW: "Montrez-moi comment",
    ALREADY_BRAND_AMBASSADOR:
      "- Vous \\ êtes déjà un ambassadeur officiel de la marque",
    WHY_MAKE_AMBASSADOR:
      "Pourquoi ne pas le rendre officiel ? Kwik vous donne les outils dont vous avez besoin pour rendre le partage et le gain simples et amusants",
    MEET_SHARE_PAGE: "- Rencontrez la Page de partage",
    MEET_SHARE_PAGE_DESC:
      "C'est votre nouveau meilleur ami. C'est là que vous trouverez tous vos liens de parrainage et vos campagnes de produits.",
    SHARE_PAGE_FEATURE: "- Caractéristiques de la page de partage",
    SHEARCH_FAVOURITE_PRODUCT:
      "<ul><li>Recherchez vos produits et marques préférés que vous pouvez partager.</li><li>Partagez des produits individuels ou le catalogue complet des marques.</li></ul>",
    CUSTOM_LINKS_COLLECTION: "- Liens et collections personnalisés",
    PERSONAL_SHARE_LINK:
      "<ul><li>Personnalisez votre lien de partage avec des messages, des images, des vidéos et des avis personnalisés. </li><li>Créez une collection de plusieurs produits basée sur des intérêts et des activités partagés.</li></ul>",
    GOT_IT: "J'ai compris",
    MEET_KWIK_CASH: "- Voici KwikCash !",
    BEST_PART_USING_KWIK:
      "La meilleure partie de l'utilisation de Kwik - l'argent ! \n KwikCash se présente sous deux formes : disponible et en attente. Les gains deviennent disponibles lorsque la période de retour se termine.",
    MONEY_MOVES: "- L'argent bouge",
    MONEY_MOVE_DESC:
      "<ul><li>Retirer le cash via ACH ou PayPal</li><li>Voir votre KwikCash, voir où vous l'avez gagné, comment vous l'avez dépensé, et quand vos derniers gains seront disponibles.</li><li>En savoir plus sur KwikCash ici.</li></ul>",
    MEET_CAMPAIGNS: "- Rencontrer des campagnes",
    MEET_CAMPAIGNS_DESC:
      "C'est ici que nous mettons notre technologie blockchain au travail. \n Nous suivons chaque lien afin que vous puissiez voir le véritable impact de vos recommandations de produits",
    KEY_FEATURES: "- Caractéristiques principales",
    KEY_FEATURE_DESC:
      "<ul><li>Les données sont décomposées en trois niveaux : toutes les campagnes, les campagnes uniques et les produits individuels.</li><li>Utilisez les ondes pour voir comment une recommandation peut se transformer en plusieurs d'entre elles !</li></ul>",
    ADDITIONAL_FEATURES: "- Caractéristiques supplémentaires",
    ADDITIONAL_FEATURES_DESC:
      "<ul><li>Perdu ? Cliquez sur l'icône 'I' pour plus d'infos.</li><li>Pour plus de détails sur le fonctionnement des vagues de gains ou des campagnes, <a href='https://kwik.com/work' target='_blank'>cliquez ici</a>.</li></ul>",
    KWIK_TEAM: "- L'équipe Kwik",
    KWIK_TEAM_QUESTION:
      "<p>Vous avez des questions ou des commentaires ? Nous voulons que vous nous en fassiez part ! Envoyez-nous un courriel à <a href='mailto:hello@wer1.com'>hello@wer1.com</a></p><p>PS : Nous lisons tous les messages. :) Merci de nous aider à rendre Kwik encore meilleur!</p>",
    IAMREADY: "Je suis prêt",
    DASHBOARD_PAGE: "- Page du tableau de bord",
    DASHBOARD_DESCRIPTION:
      "<p>Votre tableau de bord de données montre les commandes passées, notifications, les campagnes, et des conseils pour faire des vagues avec les recommandations de produits.</p><p>Vous devriez trouver quelques données de base, et vous aider à démarrer!</p>",
    I_GOT_IT: "J'ai compris",
    DASHBOARD_CHECK_YOUR_EARINGS: "Vérifiez vos revenus",
    DASHBOARD_BLOG_ARTICLES: "Blog / Articles",
    SETTINGS_GENERAL_CONTACT_REFERRER_FIRST_NAME: "Prénom du référent ",
    SETTINGS_GENERAL_CONTACT_REFERRER_LAST_NAME: "Nom de famille du référent",
    SETTINGS_GENERAL_CONTACT_REFERRER_NAME: "Nom du référent",
    SETTINGS_GENERAL_CONTACT_REFERRER_EMAIL: "Adresse e-mail du référent",
    VENDOR_FINANCE_TABLE_HD_DATE: "Date",
    VENDOR_FINANCE_TABLE_HD_TRANSACTION_STATUS: "Statut de la transaction",
    VENDOR_FINANCE_TABLE_HD_TRANSACTION_METHOD: "Méthode de transaction",
    VENDOR_FINANCE_TABLE_HD_NET_PAYMENT: "Paiement net",
    VENDOR_FINANCE_TABLE_HD_TYPE: "Type",
    VENDOR_FINANCE_TABLE_HD_KWIKCASH_TYPE: "Type KwikCash",
    VENDOR_FINANCE_TABLE_HD_AMOUNT: "Montant",
    VENDOR_FINANCE_TABLE_HD_BALANCE: "Solde",
    CAMPAIGNS_SELECTED_KWIKCASH: "1Cash",
    CAMPAIGNS_MY_CAMPAIGNS_THESE_ARE_THE_MESSAGE:
      "Ce sont les campagnes auxquelles vous participez. Pour gagner plus de campagnes, achetez un produit de cette marque ou postulez directement auprès de la marque pour devenir un ambassadeur.",
    CAMPAIGNS_IMPACTFULRECOMMEND_THIS_WILL_SHOW_MESSAGE:
      "Ceci vous montrera qui vous avez référé qui vous a généré le plus de revenus.",
    DASHBOARD_SEE_LESS: "Voir moins",
    SHARELIINK_REGISTER_PASSWORD_PLACEHOLDER: "Mot de passe de 8+ caractères",
    JOIN_CAMPAIGN_INFO:
      "Pour pouvoir participer à une campagne, vous devez avoir une expérience du produit. Soit vous achetez le produit que vous voulez promouvoir, soit vous contactez le support client concernant tout achat précédent effectué avant de rejoindre Kwik. D'autres moyens de participer à une campagne seront bientôt disponibles",
    MAKE_REFERRAL_INFO:
      "Partagez un lien vers n'importe quel produit avec n'importe qui. S'ils font un achat, vous avez réussi à faire une recommandation et vous pouvez cocher cette case sur votre liste !",
    CHECK_EARNINGS_INFO:
      "Facile, il suffit d'aller sur la page KwikCash via la navigation.",
    CHECK_WAVES_INFO:
      "Allez sur la page des campagnes via le menu de navigation.",
    CAMPAIGNS_ALL_CAMPAIGNS: "Toutes les campagnes",
    CAMPAIGNS_WAVE_INSTANT_CASH_BACK: "Cashback instantané",
    CAMPAIGNS_WAVE_RECENT_CASH_BACK_ORDERS: "Commandes récentes avec Cashback",
    CAMPAIGNS_WAVE_ALL_CASH_BACK_ORDERS: "Toutes les commandes Cashback",
    CAMPAIGNS_WAVE_CASHBACK_EARNED: "Cashback gagné",
    ALL_TIME2: "Tout le temps",
    DASHBOARD_THIS_MONTH_ITEM2: "Ce mois-ci",
    LAST_DAY2: "Dernier {{day}} jours",
    CAMPAIGNS_NO_SHARED_PRODUCTS: "Pas de produits partagés",
    CAMPAIGNS_NO_MADE_REFERRALS:
      "Il semble que vous n'ayez pas encore fait de recommandations.",
    CAMPAIGNS_SHARE_SOMETHING: "Partager quelque chose",
    CAMPAIGNS_NO_WAVES: "Pas de Vagues",
    CAMPAIGNS_ONLY_WORKS:
      "Les Vagues ne fonctionnent que si vous partagez avec vos amis !",
    CAMPAIGNS_WAVE_TEXT_REFERRALS: "Recommandations",
    YOUR_ACCOUNT_ALMOST_CREATED: "Votre compte est presque créé !",
    ORDER_DETAIL_REVIEW_CONTENT_MESSAGE: "Veuillez laisser votre avis !",
    NEW_CHECKOUT_DELIVERY_INFORMATION: "Informations sur la livraison",
    NEW_CHECKOUT_EDIT: "Modifier",
    NEW_CHECKOUT_SHIPPING_METHOD: "Mode de livraison",
    NEW_CHECKOUT_PAYMENT_METHOD: "Billing Information",
    ENTER_LOGIN_EMAIL_NEW:
      "Entrez votre adresse e-mail, et nous ferons le reste !",
    KWIKCASH_BALANCE_TITLE_AVAILABLE: "Solde disponible",
    KWIKCASH_BALANCE_TITLE_PENDING: "En attente",
    KWIKCASH_BALANCE_SEARCH_TRANSACTION_ID: "Rechercher des transactions / ID",
    KWIKCASH_BALANCE_VIEW_TRANSACTIONS: "Afficher les transactions",
    KWIKCASH_ALL_TIME: "Tout le temps",
    KWIKCASH_THIS_MONTH: "Ce mois-ci",
    KWIKCASH_LAST_7_DAYS_1: "Récemment",
    KWIKCASH_LAST_7_DAYS_2: "7 jours",
    KWIKCASH_TEXT_TRANSACTIONS: "Transactions",
    KWIKCASH_TEXT_JOINED_WAVES: "Vagues jointes",
    KWIKCASH_TEXT_Earnings: "Gains",
    KWIKCASH_CASH_OUT_TITLE: "Méthodes de retrait",
    KWIKCASH_BTN_CASH_OUT: "Retrait",
    KWIKCASH_ADD_PAYMENT_BTN_NEXT_STEP: "Étape suivante",
    KWIKCASH_ADD_PAYMENT_BTN_BACK: "Retour",
    KWIKCASH_ADD_PAYMENT_SELECT_TYPE_TITLE: "Sélectionner le type",
    KWIKCASH_ADD_PAYMENT_SELECT_TYPE_MSG:
      "Sélectionnez le type de compte que vous voulez ajouter.",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_TITLE: "Ajouter une banque",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_1:
      "Veuillez entrer les détails ci-dessous pour ",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_2: "Ajouter un compte bancaire",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_3:
      "Ces informations seront sauvegardées en toute sécurité conformément aux ",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_4: "Conditions de service et ",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_5: "Politique de confidentialité",
    KWIKCASH_ADD_PAYMENT_ADD_PAYPAL_MSG_1:
      "Veuillez entrer les détails ci-dessous pour ",
    KWIKCASH_ADD_PAYMENT_ADD_PAYPAL_MSG_2: "Ajouter un compte PayPal",
    KWIKCASH_CASH_OUT_TRANSFER_AMOUNT: "Transférer le montant",
    KWIKCASH_CASH_OUT_MSG1:
      "*Vous pouvez transférer le montant facilement vers n'importe quel compte lié",
    KWIKCASH_CASH_OUT_METHOD: "Méthodes de retrait",
    KWIKCASH_CASH_OUT_MSG21: "Commencez par ajouter votre premier ",
    KWIKCASH_CASH_OUT_MSG22: "méthode ",
    KWIKCASH_CASH_OUT_MSG23: "de retrait",
    KWIKCASH_CASH_OUT_ADD: "Ajouter une méthode",
    KWIKCASH_CASH_OUT_LEARN_MORE: "En savoir plus",
    KWIKCASH_TRANSACTION_STATUS_TIPS_DELIVERED:
      "Vous devriez avoir votre argent !",
    KWIKCASH_TRANSACTION_STATUS_TIPS_INPROCESS:
      "Le retrait est en cours de traitement pour arriver sur votre compte",
    KWIKCASH_TRANSACTION_STATUS_TIPS_CANCELED: "Ce retrait a été annulé",
    KWIKCASH_TRANSACTION_STATUS_TIPS_ONHOLD:
      "Le retrait est en cours de vérification par notre équipe. Tout retrait supérieur à 500$ sera examiné par l'équipe Kwik. Cela devrait prendre moins de 24 heures",
    KWIKCASH_TRANSACTION_CASH_OUT: "Transactions de retrait",
    KWIKCASH_TRANSACTION_EXPORT: "Exporter",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TYPE: "Type",
    KWIKCASH_TRANSACTION_TABLE_HEADER_DATE: "Date",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TRANSACTION_ID: "ID de la transaction",
    KWIKCASH_TRANSACTION_TABLE_HEADER_AMOUNT: "Montant",
    KWIKCASH_TRANSACTION_TABLE_HEADER_STATUS: "Statut",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TRANSACTION_TYPE: "Type de transaction",
    KWIKCASH_TRANSACTION_TABLE_HEADER_BALANCE: "Solde",
    KWIKCASH_TRANSACTION_TABLE_HEADER_WAVE: "Vague",
    KWIKCASH_TRANSACTION_TABLE_HEADER_INFLUENCER: "Influenceur",
    KWIKCASH_TRANSACTION_TABLE_HEADER_AVAILABLE_DATE: "Date disponible",
    KWIKCASH_TRANSACTION_NO_DATA_TITLE: "Aucune transaction à afficher",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION1:
      "Commencez à partager vos produits avec vos amis pour ",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION2: "Gagner du 1Cash",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION3:
      " Puis retirez vos gains et ils apparaîtront ici :)",
    KWIKCASH_TRANSACTION_NO_DATA_BTN_START_SHARING: "Commencer à partager",
    KWIKCASH_TRANSACTION_DETAIL_BACK: "Retour",
    KWIKCASH_TRANSACTION_DETAIL_TRANSACTIONS: "Transactions",
    KWIKCASH_TRANSACTION_DETAIL_NO_DATA: "Aucune transaction à afficher",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION1:
      "Commencez à partager vos produits avec vos amis pour ",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION2: "Gagner du KwikCash",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION3:
      " Puis retirez vos gains et ils apparaîtront ici :)",
    KWIKCASH_VERIFY_NUMBER_TEXT_1:
      "Avant de continuer avec 1Cash, veuillez vérifier votre",
    KWIKCASH_VERIFY_NUMBER_TEXT_2: " Adresse e-mail",
    KWIKCASH_VERIFY_NUMBER_BTN: "Vérifier maintenant",
    KWIKCASH_CASH_OUT_TIPS_SELECT_CARD:
      "Veuillez sélectionner une carte bancaire !",
    KWIKCASH_CASH_OUT_MINIMUM_AMOUNTS:
      "Le montant minimum doit être {{currency}}{{amount}} !",
    KWIKCASH_CASH_OUT_TIPS_AMOUNT_INVALID:
      "Vous ne pouvez pas retirer plus de cash que votre solde disponible",
    KWIKCASH_CASH_OUT_TIPS_SENT_SUCCESS: "Code envoyé avec succès",
    KWIKCASH_CASH_OUT_MODAL_TITLE: "Retirer le cash",
    KWIKCASH_CASH_OUT_TIPS_MSG1: "Veuillez entrer votre ",
    KWIKCASH_CASH_OUT_TIPS_MSG2: "Code à 4 chiffres",
    KWIKCASH_CASH_OUT_TIPS_MSG3: " pour retirer",
    KWIKCASH_CASH_OUT_TITLE_VERIFY: "Vérifier pour retirer",
    KWIKCASH_CASH_OUT_TIPS_SENT_TO1: "Le code a été envoyé à ",
    KWIKCASH_CASH_OUT_TIPS_DONT_RECEIVE: "Vous n'avez pas reçu de code ? ",
    KWIKCASH_CASH_OUT_LINK_REQUEST_AGAIN: "En demander un nouveau",
    KWIKCASH_CASH_OUT_CONTENT_MSG1: "Sélectionnez votre ",
    KWIKCASH_CASH_OUT_CONTENT_MSG2: "méthode",
    KWIKCASH_CASH_OUT_CONTENT_MSG3:
      " de retrait, puis entrez le montant et appuyez sur transfert !",
    KWIKCASH_CASH_OUT_AVAILABLE_BALANCE: "Solde disponible",
    KWIKCASH_CASH_OUT_SELECT_METHOD: "Sélectionnez une méthode de paiement",
    KWIKCASH_CASH_OUT_TO_CITY_BANK: "Vers la City Bank",
    KWIKCASH_CASH_OUT_TITLE_SUCCESS: "Transfert réussi !",
    KWIKCASH_CASH_OUT_SUCCESS_MSG1:
      "Votre paiement a été transféré avec succès, il faudra attendre ",
    KWIKCASH_CASH_OUT_SUCCESS_MSG2: "9-10 jours ouvrables",
    KWIKCASH_CASH_OUT_SUCCESS_MSG3: "pour traiter la demande",
    KWIKCASH_VERIFY_ENTER_EMAIL: "Veuillez entrer une adresse e-mail valide",
    KWIKCASH_VERIFY_ENTER_4_CODE: "Veuillez entrer le code à 4 chiffres",
    KWIKCASH_VERIFY_EMAIL: "Vérifier l'adresse e-mail",
    KWIKCASH_VERIFY_TIPS_1:
      "Nous enverrons un code à votre adresse e-mail pour vérifier que c'est la vôtre",
    KWIKCASH_VERIFY_TIPS_ENTER_EMAIL: "Veuillez entrer votre adresse e-mail",
    KWIKCASH_VERIFY_MAKE_SURE_EMAIL:
      "Veuillez vous assurer que vous avez entré l'adresse e-mail correcte",
    KWIKCASH_VERIFY_CODE_SENT_TO: "Le code a été envoyé à ",
    KWIKCASH_VERIFY_ENTER_EMAIL_CHECK:
      "L'adresse e-mail doit être l'adresse de connexion",
    KWIKCASH_ADD_DIFFERENT_NUM: "Les deux numéros de compte sont différents",
    KWIKCASH_ADD_SELECT_PAYMENT: "Veuillez sélectionner un type de paiement",
    KWIKCASH_ADD_ACCOUNT_ADDED: "Compte bancaire ajouté",
    KWIKCASH_ADD_ADDED_TIPS_1:
      "On dirait que tout est prêt ! Votre compte bancaire apparaît maintenant comme une option d'encaissement ! Profitez de votre argent :)",
    KWIKCASH_ADD_ADDED_PAYPAL: "Compte PayPal ajouté",
    KWIKCASH_ADD_ADDED_TIPS_PAYPAL_1:
      "On dirait que tout est prêt ! Votre compte PayPal apparaît maintenant comme une option d'encaissement ! Profitez de votre argent :)",
    KWIKCASH_ADD_VERIFY_TIPS_1: "Veuillez entrer votre ",
    KWIKCASH_ADD_VERIFY_TIPS_2: "Code à 4 chiffres",
    KWIKCASH_ADD_VERIFY_TIPS_3: "pour",
    KWIKCASH_ADD_VERIFY_TIPS_ADD_PAYPAL: "Ajouter PayPal",
    KWIKCASH_ADD_VERIFY_TIPS_ADD_BANK: "Ajouter une banque",
    KWIKCASH_EDIT_BANK_ACCOUNT: "Modifier le compte bancaire",
    KWIKCASH_EDIT_VERIFY_REALLY_YOU: "Vérifier que c'est bien vous",
    KWIKCASH_EDIT_PAYPAL_ACCOUNT: "Modifier le compte PayPal",
    KWIKCASH_EDIT_PAYPAL_MSG_1:
      "Ces informations seront sauvegardées en toute sécurité conformément aux ",
    KWIKCASH_EDIT_PAYPAL_MSG_2: "Conditions d'utilisation et ",
    KWIKCASH_EDIT_PAYPAL_MSG_3: " à la Politique de confidentialité.",
    KWIKCASH_EDIT_PAYPAL_VERIFY_MSG_1:
      "Veuillez vérifier qu'il s'agit bien de vous ci-dessous pour ",
    KWIKCASH_EDIT_PAYPAL_VERIFY_MSG_2: "Modifier un compte PayPal",
    KWIKCASH_EDIT_BANK_VERIFY_MSG_2: "Modifier un compte bancaire",
    KWIKCASH_TIPS_SELECT_COUNTRY: "Veuillez sélectionner un pays",
    KWIKCASH_TIPS_SELECT_CURRENCY: "Veuillez sélectionner une devise",
    KWIKCASH_MANAGE_CASH_OUT_METHOD: "Gérer vos méthodes d'encaissement",
    KWIKCASH_CASH_OUT_METHOD2: "Méthodes d'encaissement",
    KWIKCASH_ITS_EASY: "C'est super facile !",
    KWIKCASH_MANAGE_BTN_ADD: "+ Ajouter",
    KWIKCASH_MANAGE_BTN_EDIT: "Modifier",
    KWIKCASH_MANAGE_BTN_CANCEL: "Annuler",
    KWIKCASH_MANAGE_TIPS_SELECT_METHOD:
      "Sélectionnez une méthode de retrait à modifier",
    KWIKCASH_MANAGE_REMOVE_PAYPAL: "Supprimer PayPal",
    KWIKCASH_MANAGE_REMOVE_CARD: "Supprimer la compte",
    KWIKCASH_MANAGE_TO_REMOVE_PAYPAL: "pour supprimer votre PayPal",
    KWIKCASH_MANAGE_TO_REMOVE_CARD: " pour supprimer votre compte",
    KWIKCASH_MANAGE_VERIFY_REMOVE: "Vérifier pour supprimer ",
    KWIKCASH_MANAGE_VERIFY_TO: "Vérifier pour",
    KWIKCASH_MANAGE_WORD_PAYPAL: "PayPal",
    KWIKCASH_MANAGE_WORD_CARD: "compte",
    KWIKCASH_MANAGE_WORD_BANK: "Banque",
    KWIKCASH_MANAGE_ACCOUNT_REMOVED: " Compte supprimé",
    KWIKCASH_MANAGE_REMOVE_TIPS_1:
      "Une fois que vous aurez retiré une carte, elle sera supprimée de Kwik.",
    KWIKCASH_MANAGE_BANK_ACCOUNT_UPDATED: "Compte bancaire mis à jour",
    KWIKCASH_MANAGE_PAYPAL_ACCOUNT_UPDATED: "Compte PayPal mis à jour",
    KWIKCASH_MANAGE_BTN_ADD_ACCOUNT: "Vérifier et ajouter un compte",
    KWIKCASH_BTN_CONFIRM_NUMBER: "Confirmer le numéro",
    KWIKCASH_BTN_CONFIRM_EMAIL: "Confirmer l'adresse e-mail",
    VENDOR_SETTINGS_UP: "Utilisateurs et autorisations",
    VENDOR_SETTINGS_MWUCSODIYS:
      "Gérer ce que les utilisateurs peuvent voir ou faire dans votre boutique",
    VENDOR_SETTINGS_BRAND_OWER: "Propriétaire de la marque",
    VENDOR_SETTINGS_ADDS_MEMBERS_TIPS: "Membres ajoutés (jusqu'à 15)",
    VENDOR_SETTINGS_NO_DATA_TIPS:
      "Vous n'avez pas ajouté d'utilisateurs. Veuillez ajouter des utilisateurs pour afficher les détails",
    VENDOR_SETTINGS_LAST_LOGIN: "La dernière connexion était",
    VENDOR_SETTINGS_ADD_USERS: "Ajouter un utilisateur",
    VENDOR_SETTINGS_EDIT_USERS: "Modifier l'utilisateur",
    VENDOR_SETTINGS_ETU_GOVERNMENTID:
      "Entrez le prénom et le nom de famille de l'utilisateur tels qu'ils apparaissent sur une pièce d'identité délivrée par le gouvernement",
    VENDOR_SETTINGS_SELECT_PERMISSIONS: "Sélectionner les permissions",
    VENDOR_SETTINGS_SELECT_ALL: "Sélectionner tout",
    VERSION_DETAIL_01: "Bio du vendeur",
    VERSION_DETAIL_02: "Supprimer les descriptions courtes",
    VERSION_DETAIL_03: "Informations de recommandation du vendeur",
    VERSION_DETAIL_04: "Aucun nom sur les évaluations",
    VERSION_DETAIL_05: "Modifier le panier d'achat",
    VERSION_DETAIL_06: "Afficher le logo du vendeur sur l'écran de post achat",
    VERSION_DETAIL_07: "Corrections grammaticales",
    VERSION_DETAIL_08: "Afficher des données erronées",
    VERSION_DETAIL_09: "Afficher les données spécifiques au produit",
    INVALID_LINK: "Lien invalide",
    ORDER_LIST_ORDER_DATE: "Date de la commande",
    VENDOR_ACCEPTING_ORDERS_STEP_1: "ÉTAPE 1",
    VENDOR_ACCEPTING_ORDERS_STEP_2: "ÉTAPE 2",
    VENDOR_ACCEPTING_ORDERS_STEP_3: "ETAPE 3",
    VENDOR_ACCEPTING_ORDERS_STEP_4: "ETAPE 4",
    VENDOR_ACCEPTING_ORDERS_STEP_5: "ETAPE 5",
    VENDOR_ACCEPTING_ORDERS_STEP_6: "ETAPE 6",
    VENDOR_ACCEPTING_ORDERS_TITLE_1:
      "Configurez l'endroit d'où vos produits sont expédiés",
    VENDOR_ACCEPTING_ORDERS_TITLE_2: "Ajouter des produits",
    VENDOR_ACCEPTING_ORDERS_TITLE_3: "Personnalisez vos campagnes",
    VENDOR_ACCEPTING_ORDERS_TITLE_4: "Définissez vos tarifs d'expédition",
    VENDOR_ACCEPTING_ORDERS_TITLE_5: "Personnalisez votre marque",
    VENDOR_ACCEPTING_ORDERS_TITLE_6: "Personnalisez votre marque",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_1:
      "Cela permettra de s'assurer que la quantité est suivie de manière appropriée et aidera à la coordination de l'expédition. Nous avons déjà défini une adresse comme votre adresse professionnelle. Mettez-la à jour si elle est incorrecte ou si vous avez plus d'un emplacement.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_2:
      "Faites-nous savoir lesquels de vos produits vous voulez Kwikifier et nous le ferons ! Nous avons juste besoin de quelques informations sur chaque produit que vous voulez. Ajoutez ces informations avec notre plugin Shopify, l'importation CVS, ou manuellement.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_3:
      "Il est plus facile d'avoir une seule campagne, donc nous l'avons déjà configuré de cette façon par défaut. Cela signifie que lorsqu'une personne rejoint votre campagne, elle a accès au partage de tous vos produits. Si vous voulez les séparer en différentes campagnes, n'hésitez pas à le faire !",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_4:
      "Cette étape n'est requise que si vous voulez participer au Marché Kwik, si cela vous intéresse, cliquez ici et nous pourrons vous montrer quelques avantages :). Si ce n'est pas le cas, cliquez ici et tout ira bien ! ",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_5:
      "Nous avons besoin de certains de vos designs de marque sympas pour rendre l'expérience de vos clients dans Kwik encore meilleure. Donnez-nous quelques couleurs, images, bio, etc.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_6:
      "Nous avons besoin de quelques-uns de vos designs de marque pour améliorer l'expérience de vos clients sur Kwik. Donnez-nous quelques couleurs, images, bio, etc.",
    VENDOR_ACCEPTING_ORDERS_BTN_11_NAME: "Editer l'entrepôt",
    VENDOR_ACCEPTING_ORDERS_BTN_21_NAME: "Ajouter des produits",
    VENDOR_ACCEPTING_ORDERS_BTN_31_NAME: "Personnaliser les campagnes",
    VENDOR_ACCEPTING_ORDERS_BTN_41_NAME: "Définir les tarifs d'expédition",
    VENDOR_ACCEPTING_ORDERS_BTN_42_NAME: "Je ne suis pas intéressé",
    VENDOR_ACCEPTING_ORDERS_BTN_51_NAME: "Personnaliser ma marque",
    VENDOR_ACCEPTING_ORDERS_BTN_61_NAME: "Personnaliser mon compte bancaire",
    VENDOR_ACCEPTING_ORDERS_MENU_1: "Personnaliser vos entrepôts",
    VENDOR_ACCEPTING_ORDERS_MENU_2: "Ajouter des produits",
    VENDOR_ACCEPTING_ORDERS_MENU_3: "Personnaliser vos campagnes",
    VENDOR_ACCEPTING_ORDERS_MENU_4: "Configurer vos campagnes",
    VENDOR_ACCEPTING_ORDERS_MENU_5: "Personnalisez votre marque",
    VENDOR_ACCEPTING_ORDERS_MENU_6: "Connectez votre compte bancaire",
    VENDOR_ACCEPTING_ORDERS_TEXT_OF_6: " de 6",
    VENDOR_ACCEPTING_ORDERS_TEXT_COMPLETED: " Terminé",
    VENDOR_ANALYTIC_REPORT_TITLE: "Rapport analytique",
    VENDOR_ANALYTIC_REPORT_TITLE_1: "Ventes totales",
    VENDOR_ANALYTIC_REPORT_TITLE_2: "Total des commandes",
    VENDOR_ANALYTIC_REPORT_TITLE_3: "Nouveaux clients",
    VENDOR_ANALYTIC_REPORT_TITLE_4: "Partage des clients",
    VENDOR_ANALYTIC_REPORT_TIPS_1: "-----",
    VENDOR_OVERVIEW_COMPLETE_STEP_TITLE: "Terminer la configuration",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_TITLE:
      "Configurer vos taux d'imposition",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_MESSAGE:
      "Nous devons nous assurer que vous êtes en conformité et prêt à payer des impôts",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_BTN_NAME:
      "Définir le taux d'imposition",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_TITLE: "Ajouter des ambassadeurs",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_MESSAGE:
      "Vous n'avez pas de partageurs ajoutés, donnez un lien à certains de vos clients fidèles",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_BTN_NAME: "Ajouter des utilisateurs",
    VENDOR_OVERVIEW_CUSTOMIZATION_TITLE: "Personnalisation",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_TITLE: "Personnaliser votre marque",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_MESSAGE:
      "Mettez à jour les couleurs et les logos que vous voulez que les utilisateurs voient. Faites de votre marque la vôtre",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_BTN_NAME: "Personnalisons",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_TITLE: "Ajouter vos finances",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_MESSAGE:
      "Assurez-vous que vous pouvez obtenir votre argent pour les ventes et avoir une méthode pour payer ceux qui vendent vos produits !",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_BTN_NAME: "Mettre à jour maintenant",
    VENDOR_OVERVIEW_EARNERS_TITLE: "Top gagnants",
    VENDOR_OVERVIEW_TABLE_TITLE: "Produits les plus vendus",
    VENDOR_OVERVIEW_TABLE_HEADER_1: "Image",
    VENDOR_OVERVIEW_TABLE_HEADER_2: "Nom du produit",
    VENDOR_OVERVIEW_TABLE_HEADER_3: "Inventaire",
    VENDOR_OVERVIEW_TABLE_HEADER_4: "Prix",
    VENDOR_OVERVIEW_TABLE_HEADER_5: "Ventes",
    VENDOR_OVERVIEW_TABLE_HEADER_6: "Valeur KwikCash",
    SHOP_BY_CATEGORY: "Acheter par catégories",
    NEWEST_PRODUCTS: "Produits les plus récents",
    PRODUCT_YOU_MIGHT_LIKE: "Produits que vous pourriez aimer",
    HIGHEST_KCASH: "Valeur 1Cash la plus élevée",
    HIGHEST_INS_CASHBACK: "Cashback instantané le plus élevé",
    SEE_ALL: "Tout voir",
    NEW_BRANDS_ON_KWIK: "Nouvelles marques sur Kwik",
    SHOP_BY_BRAND: "Acheter par marque",
    SHOPPING_EMAIL_TITLE1:
      "Vous voulez savoir quand de nouvelles marques sont lancées ?",
    SHOPPING_EMAIL_DESC1:
      "Recevez une notification lorsque de nouvelles marques sont lancées sur Kwik et soyez les premiers à obtenir un lien !",
    SHOPPING_EMAIL_TITLE2: "Votre recommandation va loin",
    SHOPPING_EMAIL_DESC2:
      "Trouver un produit que vous aimez est la première étape pour faire une recommandation !",
    SHOPPING_EMAIL_DESC3:
      "Trouvez un produit que vous aimez utiliser et Kwik vous permettra de le recommander facilement à vos amis et d'être payé pour cela !",
    ALL: "tout",
    RECENT_PURCHASES: "Achats récents",
    RECENTLY_PURCHASED_PRODUCTS: "Produits récemment achetés",
    PAGE: "Page",
    OF: "sur",
    PREV: "Précédent",
    TOP_SHARED_PRODUCTS: "Produits les plus partagés",
    YOUR_PRODUCTS: "Vos produits",
    MOST_EARNED: "Les plus gagnés",
    MOST_SHARED: "Les plus partagés",
    SEARCH: "Recherche",
    SEARCH_BY_PRODUCT_NAME: "Recherche par nom de produit",
    CAMPAIGNS_YOU_HAVENT_JOINED_TEXT:
      "Vous n'avez pas encore rejoint de campagne :(",
    CAMPAIGNS_FIND_PRODUCTS_OR_CONNECT_TEXT:
      "Trouvez des produits ou connectez-vous avec des marques pour obtenir des liens !",
    CAMPAIGNS_FIND_THE_BRANDS_TEXT: "Trouver les marques",
    CAMPAIGNS_SHARES: "Actions",
    CAMAPIGNS_NO_DATA: "Aucune donnée",
    CAMPAIGNS_LOOKS_LIKE_YOU_HAVE_MESSAGE:
      "On dirait que vous n'avez pas encore fait de liens ou de recommandations",
    CAMPAIGNS_LEARN_MORE_AT: "En savoir plus à",
    CAMPAIGNS_SALES_FROM: "Ventes de",
    DESCRIPTION: "Description",
    INGREDIENTS: "Ingredients",
    USAGE: "Usage",
    MANUFACTURER: "Manufacturer",
    SHIPPING: "Shipping",
    CONGRATULATIONS: "Order Complete!",
    STANDARD: "Standard",
    FIELD_NAME_IBAN: "IBAN",
    FIELD_NAME_RE_IBAN: "Re-IBAN",
    FIELD_NAME_SORT_CODE: "Sort Code",
    FIELD_NAME_STATE: "State",
    FIELD_NAME_SWIFT_CODE: "Swift Code",
    FIELD_NAME_ZIP_CODE: "Postal Code",
    FIELD_RE_ACCOUNT_NUMBER: "Re-Enter Account Number",
    FIELD_SWIFT_CODE: "SWIFT",
    FIELD_BIC: "BIC",
    FIELD_BIC_CODE_SORT: "BIC/Sort Code",
    FIELD_BANK_BSB: "BSB",
    CANCEL: "Cancel",
    OK: "Ok",
    REFUND: "Refund",
    DELETE: "Delete",
    HEADER_SHOPPING: "Shopping",
    HELP: "Help",
    FIELD_REQUIRED: "This field is required",
    ACCONT_CONFIRM:
      "Changes to this type of account may require you to confirm the account. This will be done by entering the amounts of two small deposits into the account.",
    SS_FOOTER_MAIL_TO: "mailto:support@wer1.com",
    SS_FOOTER_HELLO_EMAIL: "hello@wer1.com",
    ORDER_AGAIN: "Order Again",
    VENDOR_SETTINGS_REFERRAL_NAME: "Referrer's Name",
    VENDOR_ACCEPTING_ORDERS_BTN_PREVIOUS: "Previous Step",
    VERSION_DETAIL_01_3_0_2: "Order Date in Order History",
    VERSION_DETAIL_02_3_0_2: "Share page keeps data when changing countries",
    VERSION_DETAIL_03_3_0_2: "Accurate numbers in product categories",
    VERSION_DETAIL_04_3_0_2: "Can’t share removed products",
    VERSION_DETAIL_05_3_0_2: "Campaigns search message",
    VERSION_DETAIL_06_3_0_2: "Available dates for pending Kwikcash",
    VERSION_DETAIL_07_3_0_2: "Post-purchase coin animation for guest users",
    VERSION_DETAIL_08_3_0_2:
      "Image shows in order history for removed products",
    VERSION_DETAIL_09_3_0_2:
      "Terms, Conditions, and Privacy Policy links updated",
    VERSION_DETAIL_10_3_0_2: "Typos!",
    VERSION_DETAIL_11_3_0_2: "Exported reports show countries for brands",
    VERSION_DETAIL_12_3_0_2:
      "Phone Number field is mandatory during brand sign up",
    VERSION_DETAIL_13_3_0_2: "Min & Max on vendor cashouts",
    VERSION_DETAIL_14_3_0_2: "Fixed vendor cash out issues",
    VERSION_DETAIL_15_3_0_2: "Added vendor password reset option",
    USER_SETTING_ACCOUNT_SETTINGS: "Paramètres du compte",
    USER_SETTING_UPDATE_PROFILE: "Mise à jour du profil",
    USER_SETTING_ACCOUNT_INFO: "Informations sur le compte",
    USER_SETTING_PUBLIC_ACCOUNT_NAME: "Nom du compte public",
    USER_SETTING_PUBLIC_ACCOUNT_NAME_IS_REQUIRED:
      "Public Account Name is required",
    USER_SETTING_USERNAME: "Nom d'utilisateur",
    USER_SETTING_PUBLIC_ACCOUNT_USERNAME_IS_REQUIRED:
      "Public Account Username is required",
    USER_SETTING_CONTACT_DETAIL: "Détail du contact",
    USER_SETTING_EMAIL_ADDRESS: "Adresse email",
    USER_SETTING_BIRTHDAY: "Anniversaire",
    USER_SETTING_UPDATE_EMAIL_ADDRESS: "Mise à jour de l'adresse email",
    USER_SETTING_UPDATE: "Update",
    USER_SETTING_PHONE_NUMBER: "Numéro de téléphone",
    USER_SETTING_UPDATE_PHONE_NUMBER: "Mise à jour du numéro de téléphone",
    USER_SETTING_LOGIN: "Connexion",
    USER_SETTING_PASSWORD: "Mot de Passe ",
    USER_SETTING_LAST_UPDATED_AGO: "Last updated {{lastUpdatePwd}} ago",
    USER_SETTING_UPDATE_PASSWORD: "Update Password",
    USER_SETTING_LANGUAGE: "Language",
    USER_SETTING_UPDATE_LANGUAGE: "Update Language",
    USER_SETTING_COUNTRY: "Country",
    USER_SETTING_UPDATE_COUNTRY: "Update Country",
    USER_SETTING_ACCOUNT_DETAILS: "Détails du compte",
    USER_SETTING_THESE_CAN_BE_USED_TO_MAKE_MESSAGE:
      'Ces données peuvent être utilisées pour s\'assurer que c\'est bien vous qui vous connectez ou pour vous contacter. Pour mettre à jour ces données, contactez notre service clientèle <a target="_blank" href="mailto:support@wer1.com"> service clientèle</a>',
    USER_SETTING_LEGAL_NAME: "Nom légal",
    USER_SETTING_RECENT_LOGIN: "Connexion récente",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_COMPUTER1:
      "{{sessionNum}} Session sur {{system}} ordinateur",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_COMPUTER2:
      "{{sessionNum}} Sessions sur {{system}} ordinateur",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_MOBILE1:
      "{{sessionNum}} Session sur {{system}} mobile phone",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_MOBILE2:
      "{{sessionNum}} Sessions sur {{system}} mobile phone",
    USER_SETTING_CHANGE_PASSWORD: "Change Password",
    USER_SETTING_ENTER_THE_DETAILS_BELOW_MESSAGE:
      "Enter the details below to <span>Change password</span> on WeR1.",
    USER_SETTING_ENTER_CURRENT_PASSWORD: "Enter Current Password",
    USER_SETTING_CURRENT_PASSWORD_IS_REQUIRED: "Current Password is required",
    USER_SETTING_INCORRECT_PASSWORD_FORMAT: "Incorrect password format",
    USER_SETTING_YOUR_NEW_PASSWORD: "Your New Password",
    USER_SETTING_NEW_PASSWORD_IS_REQUIRED: "New Password is required",
    USER_SETTING_RE_ENTER_YOUR_NEW_PASSWORD: "Re-Enter Your New Password",
    USER_SETTING_INCONSISTENT_PASSWORDS: "Inconsistent passwords",
    USER_SETTING_THIS_INFORMATION_WILL_BE_MESSAGE:
      'This information will be securely saved as per  the <span><a href="https://help.kwik.com/en/support/solutions/70000319669" target="_blank"><u>Terms of Service & Privacy Policy </u></a></span>',
    USER_SETTING_BACK: "Back",
    USER_SETTING_PASSWORD_SUCCESSFULLY_CHANGED: "Password Successfully Changed",
    USER_SETTING_YOU_CAN_NOW_USE_YOUR_MESSAGE:
      "You can now use your new password to <span>Log in to your account</span>",
    USER_SETTING_CHOOSE_A_LANGUAGE: "Choose a Language",
    USER_SETTING_YOUR_LANGUAGE_WILL_MESSAGE:
      "Your language will save the next time you load Kwik.",
    USER_SETTING_DEFAULT: "Default",
    USER_SETTING_SAVE: "Save",
    USER_SETTING_CHOOSE_A_COUNTRY: "Choose a Country",
    USER_SETTING_YOUR_COUNTRY_WILL_MESSAGE:
      "Your Country will save the next time you load Kwik.",
    USER_SETTING_MENU_SAVED_INFORMATION: "Informations enregistrées",
    USER_SETTING_MENU_ADDRESSES: "Addresses",
    USER_SETTING_MENU_CASH_OUT_METHODS: "Méthodes de retrait",
    USER_SETTING_MENU_PRIVACY_SETTINGS: "Paramètres de confidentialité",
    USER_SETTING_MENU_NOTIFICATION: "Notification",
    USER_SETTING_ADD_ADDRESS: "Ajouter une adresse",
    USER_SETTING_ZIP_CODE: "Zip code",
    USER_SETTING_EDIT: "Editer",
    USER_SETTING_REMOVE: "Retirer",
    USER_SETTING_SUBMIT: "Submit",
    USER_SETTING_PHONE_NUMBER2: "Phone Number",
    USER_SETTING_PHONE_NUMBER_IS_REQUIRED: "Phone Number is required",
    USER_SETTING_NAME: "Name",
    USER_SETTING_NAME_IS_REQUIRED: "Name is required",
    USER_SETTING_ADDRESS: "Adresses",
    USER_SETTING_ADDRESS_IS_REQUIRED: "Address is required",
    USER_SETTING_APARTIMENT_SUITE_ETC_OPTIONAL:
      "Apartment, Suite, Etc. (Optional)",
    USER_SETTING_CITY: "City",
    USER_SETTING_CITY_IS_REQUIRED: "City is required",
    USER_SETTING_STATE: "State",
    USER_SETTING_STATE_IS_REQUIRED: "State is required",
    USER_SETTING_POSTAL_CODE: "Postal Code",
    USER_SETTING_POSTAL_CODE_IS_REQUIRED: "Postal Code is required",
    USER_SETTING_EMAIL: "Email",
    USER_SETTING_EMAIL_IS_REQUIRED: "Email is required",
    USER_SETTING_GET_STARTED_BY_ADDING_MESSAGE:
      "Get started by adding your first <span>cash out</span> method!",
    USER_SETTING_ADD_METHOD: "Add Method",
    USER_SETTING_SHOW_MY_FULL_NAME_IN_WAVES:
      "Afficher mon nom complet dans les vagues",
    USER_SETTING_ALLOW_USERS_TO_SEE_MESSAGE:
      "Permettre aux utilisateurs de voir mon nom complet dans Waves",
    USER_SETTING_ALLOW_OTHER_USERS_TO_MESSAGE_ME:
      "Autoriser les autres utilisateurs à m'envoyer des messages",
    USER_SETTING_COMING_SOON: "Bientôt disponible",
    USER_SETTING_SUBSCRIBE_TO_KWIK_NEWSLETTER: "Subscribe to Kwik Newsletter",
    USER_SETTING_ALL_WE_DO_IS_LET_MESSAGE:
      "All we do is let you know when we make your life better!",
    USER_SETTING_SUBSCRIBE_TO_NEWSLETTERS:
      "Subscribe To Newsletters From Vendors I Have Purchased From",
    USER_SETTING_AUTOMATICALLY_GET_MESSAGE:
      "Automatically get signed up for newsletters from the brands you bought from.",
    USER_SETTING_ALLOW_OTHER_USERS_MESSAGE:
      "Permettre aux autres utilisateurs de voir ma photo de profil dans leurs vagues",
    USER_SETTING_IF_ON_OTHERS_CAN_MESSAGE:
      "Si cette option est activée, les autres peuvent voir votre photo de profil dans leurs vagues.",
    USER_SETTING_DOWNLOAD_MY_DATA: "Télécharger mes données",
    USER_SETTING_YOU_CAN_DOWNLOAD_MESSAGE:
      "Vous pouvez télécharger une copie de vos données à tout moment",
    USER_SETTING_REQUEST_TO_DOWNLOAD_MU_DATA:
      "Demande de téléchargement de mes données",
    USER_SETTING_DELETE_MY_DATA: "Supprimer mes données",
    USER_SETTING_YOU_CAN_DELETE_MESSAGE:
      "Supprimer les données stockées dans mon compte",
    USER_SETTING_NOTIFICATION_SETTINGS: "Paramètres de notification",
    USER_SETTING_NOTIFY_ME_ON: "Me notifier sur",
    USER_SETTING_FINANCE: "Finances",
    USER_SETTING_CASHOUT_ALERTS: "Alertes de retrait",
    USER_SETTING_NOTIFY_ME_ON_EVERY_CASHOUT: "M'avertir de chaque retrait",
    USER_SETTING_NEW_BANK_ACCOUNT_ADDED: "Ajout d'un nouveau compte bancaire",
    USER_SETTING_NOTIFY_ME_WHEN_A_NEW_BANK_ACCOUNT_IS_ADDED:
      "M'avertir lorsqu'un nouveau compte bancaire est ajouté",
    USER_SETTING_KWIKCASH_CLEARS: "1Cash Clears",
    USER_SETTING_WAVES: "Vagues",
    USER_SETTING_WHEN_SOMEONE_JOINS_MY_WAVES:
      "Quand quelqu'un rejoint mes vagues",
    USER_SETTING_NOTIFY_ME_EVERY_TIME_SOMEONE_JOINS_MY_WAVES:
      "M'avertir chaque fois que quelqu'un rejoint mes vagues",
    USER_SETTING_MARKETING: "Marketing",
    USER_SETTING_SIGN_ME_UP_FOR_KWIK_NEWSLETTER:
      "Sign me up for Kwik Newsletter",
    USER_SETTING_GET_UPDATES_ON_THE_RELEASES_MESSAGE:
      "Get updates on the releases, and get important updates that might impact your account",
    USER_SETTING_ALLOW_BRANDS_MESSAGE:
      "Allow Brands to Send Me Their Newsletter",
    USER_SETTING_ALLOW_THE_BRANDS_OF_THE_MESSAGE:
      "Allow the brands of the campaigns I am in to send me newsletters by default",
    USER_SETTING_SHOPPING: "Shopping",
    USER_SETTING_NEW_BRANDS_ON_KWIK: "New Brands on Kwik",
    USER_SETTING_TRENDING_DEALS: "Trending Deals",
    USER_SETTING_SETTINGS: "Paramètres",
    USER_SETTING_ANY_SETTINGS_CHANGES_ARE_MADE:
      "Toute modification des paramètres est effectuée",
    USER_SETTING_NOTIFY_ME_WHEN_ANY_SETTINGS_ARE_CHANGED:
      "M'avertir en cas de modification des paramètres",
    USER_SETTING_LANGUAGE_CHANGED: "Changement de langue",
    USER_SETTING_NOTIFY_ME_WHEN_THE_LANGUAGE_CHANGES:
      "M'avertir en cas de changement de langue",
    USER_REGISTER_LEGAL_NAME: "Legal Name",
    USER_REGISTER_PLEASE_INPUT_YOUR_ADDRESS_LEGAL_NAME:
      "Please input your Address Legal Name",
    DASHBOARD_TODAY: "Aujourd'hui",
    DASHBOARD_PAST_WEEK: "La semaine derniere",
    DASHBOARD_PAST_MONTH: "Le mois dernier",
    DASHBOARD_PAST_YEAR: "L'annee derniere",
    DASHBOARD_VIEW_ALL_CAMPAIGN: "Voir toutes les campagnes",
    DASHBOARD_ORDERS_NO_DATA:
      "Plus de perte de votre numero de commande ou lien de suivis. Tout est ici.",
    CAMPAIGNS_LEARN_KWIK: "Apprendre sur KWIK",
    CAMPAIGNS_WANT_TO_LEARN_ABOUT:
      "Tu veux apprendre ce que les data venant de KWIK apporte ?",
    CAMPAIGNS_WHAT_IS_A_CAMP: "Qu’est qu’une campagne ?",
    CAMPAIGNS_MINS_READ: "minutes de lecture",
    CAMPAIGNS_HOW_WE_TRACK_WAVES: "Comment nous traquons les vagues ?",
    CAMPAIGNS_HOW_TO_NAVIGATE_DATA: "Comment naviguer dans vos datas ?",
    CAMPAIGNS_SHARING_LINKS: "Partage de liens",
    MOST_POPULAR: "Les plus populaires",
    DASHBOARD_SHARE_BRANDS: "Partager des marques",
    DASHBOARD_TOP_CAMPAIGN: "Meilleure campagne",
    NOTIFICATION_NAV_HOME: "Accueil",
    NOTIFICATION_NAV_NOTIFICATIONS: "Avis",
    NOTIFICATION_FILTERS: "Filtre",
    NOTIFICATION_CHECKBOX_ALL: "Tout",
    NOTIFICATION_CHECKBOX_UNREAD: "Non lu",
    NOTIFICATION_CHECKBOX_READ: "Vu",
    NOTIFICATION_BUTTON_APPLY_FILTER: "Appliquer le filtre",
    NOTIFICATION_BUTTON_APPLY_CLEAR: "Effacer",
    NOTIFICATION_SELECT_RECENT: "Récent",
    NOTIFICATION_SELECT_OLDER: "Ancien",
    NOTIFICATION_SELECT_MARK_ALL_AS_READ: "Marquer tous lu.",
    NOTIFICATION_SELECT_GO_TO_SETTING: "Aller dans les réglages",
    MINIMUM_8_CHARACTERS_FOR_SECURE_PASSWORD:
      "8 caractères minimum pour un mot de passe sécurisé.",
    UPPER_CASE: "Majuscules",
    LOWER_CASE: "Minuscules",
    ONE_NUMBERS: "Un Chiffre",
    A_8_CHARC: "8 Caractères",
    MOST_RECENT_SHARE: "Partages les plus récents",
    WALK_THROUGH: "Procédure pas à pas",
    KWIKCASH_ADD_PAYMENT_BTN_NEXT_STEP: "Prochaine étape",
    NEW_SHARE_LINK_CART_TEXT_CREATE_ACCOUNT: "Créer un compte",
    YROYW:
      "Vous êtes sur la bonne voie! Maintenant que vous avez créé votre compte, familiarisez-vous avec Kwik en prenant une minute pour passer en revue les étapes décrites ici. Elles vous mettront sur la voie rapide pour faire des vagues !",
    EJABCBM:
      "Rejoignez facilement la campagne d'une marque en effectuant un achat auprès d'elle, en étant ajouté par la marque directement, ou rejoignez une campagne sans conditions!",
    SASLN:
      "Envoyez un lien de partage maintenant! Une fois que quelqu' un achète à partir de votre lien, vous avez réussi votre parrainage!",
    GTTKPTSHMY:
      "Rendez-vous sur la page Kwikcash pour voir combien vous avez gagné en partageant des liens vers des produits et services que vous aimez et utilisez tous les jours !",
    SHAYDAIRC:
      "Voyez comment toutes vos références directes et indirectes constituent vos vagues et augmentent vos vagues de revenus !",
    HEADER_LAYER_EDIT_PROFILE: "Modifier le profil",
    SHARE_ORDER: "Commande de partage",
    WAYS_TO_REDEEM: "Les moyens d'échange",
    WAYS_TO_EARN: "Facon de gagner",
    VIEW_ALL_PRODUCTS: "Voir tous les produits",
    SHARE_BRAND: "Partagez une marque",
    LOYALTY_SUBTEXT:
      "Consultez tous les points de récompense que vous avez collectés auprès de différentes marques et campagnes, ainsi que les bonus qu'elles proposent !",
    LOYALTY_POINTS: "Points de fidelité",
    LOYALTY_POINTS_REWARDS: "Récompenses",
    INVITE_A_FRIEND: "Invite un ami",
    WHATSNEW_TOP_TEXT: "Extension du doubleur",
    WHATSNEW_HEADER_TEXT: "Nous avons une bonne nouvelle!",
    WHATSNEW_BODY_TEXT:
      "En raison de la demande populaire et de l'enthousiasme débordant de votre incroyable communauté, nous avons décidé de prolonger la date limite de dépôt des doublons d'une semaine.",
    WHATSNEW_DEADLINE_TEXT:
      "Nouvelle date limite pour les Doubler Bonus : Vendredi 6 octobre, 23h59 (heure de l'Utah)",
    WHATSNEW_BTN_TEXT: "Learn More",
    IAMACOMPANY: "Je suis une entreprise",
    BUSINESSNAME_OPTIONAL: "Nom de l'entreprise (facultatif)",
    EINNUMBER: "SIRET/SIREN",
    SOCIAL_POPUP_CONTENT_1:
      "Suivez les comptes sociaux WeR1 pour obtenir toutes les mises à jour !",
    SOCIAL_POPUP_CONTENT_2:
      "Pour commencer, obtenez 5 entrées gratuites pour chaque page que vous suivez !",
    SOCIAL_POPUP_INS: "Suivez l'Instagram WeR1",
    SOCIAL_POPUP_FB: "Suivez le Facebook WeR1",
    SOCIAL_POPUP_YTB: "Abonnez-vous à notre YouTube",
    SOCIAL_FOLLOW_US: "Suivez-nous!",
    SOCIAL_BOTTOM_DESC: "Cliquez sur une page pour suivre",
    SOCIAL_BTN_TEXT: "Cliquez lorsque vous avez terminé !",
    NEW_DASHBOARD_IMPORTANT_STEP: "Étape importante !",
    DSTSWUYEATGYYR:
      "Ne sautez pas cette étape ! WeR1 utilise votre adresse e-mail pour vous remettre vos récompenses.  ",
    YAEAI: "L'adresse électronique de votre compte est la suivante: ",
    IYUADEAWPFWYRWGRTTE:
      "If you use a different email address when purchasing from WeR1, your rewards will get routed to that email.",
    TOHELPWITHTHISWE:
      "Pour vous aider, nous vous permettons d'ajouter des alias d'email. Si vous utilisez l'un de ces emails lors de votre commande, vos récompenses seront toujours placées sur votre compte WeR1.",
    ENTER_YOUR_EMAILS: "Saisissez vos emails",
    AEAEWBSUC:
      "Alias Email addresses entered will be saved upon clicking SAVE.  After clicking SAVE, any additional changes to alias Emails should be made in Account Settings.",
    WUYAETAYRWYA:
      "We utilize your account email to associate your rewards with your account, add up to two different emails that you use when buying products so that if you use one of those emails when purchasing you will still get the rewards in your account.",

    VIEW_REWARDS: "voir les récompenses",
    SHARE_PRODUCT: "Partager un produit",
    PURCHASING: "Acheter",
    REFERRING: "Recommender",
    BUY: "Acheter",
    KWIKCASH_VALID_TILL: "Date de validité",
    KWIKCASH_VIEW_BONUS_DETAILS: "Voir les détails de la prime",
    BONUSES: "Bonus",
    YANAVP: "Vous n'êtes pas un acheteur vérifié",
    NVUCGRFAP:
      "Les utilisateurs non vérifiés ne peuvent pas attribuer de notes à un produit.",
    BRAND: "Marque",
  },
};
